let municipalities = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.189004478000072, -27.454314525999962],
            [31.087359943000024, -27.519769937999968],
            [31.032560068000066, -27.52104006299993],
            [31.048419943000056, -27.62223993799995],
            [30.95817994300006, -27.618759937999982],
            [30.798539943000037, -27.663330062999933],
            [30.66423994300004, -27.679150062999952],
            [30.691649943000073, -27.71553993799995],
            [30.62698994300007, -27.739739937999957],
            [30.629419943000073, -27.810289937999983],
            [30.581389943000033, -27.888569937999932],
            [30.60214006800004, -27.93359993799993],
            [30.68444006800007, -27.971089938999967],
            [30.612789943000053, -28.035199938999938],
            [30.68689994300007, -28.129299938999964],
            [30.790039943000068, -28.141459938999958],
            [30.863909943000067, -28.11683993899993],
            [30.91399994300008, -28.17016006399996],
            [30.950359943000024, -28.143590063999966],
            [30.986909943000057, -28.056889938999973],
            [30.994189943000038, -27.99660993899994],
            [31.142089944000077, -28.033129938999934],
            [31.218019944000048, -28.02174006399997],
            [31.30768994400006, -28.03732993899996],
            [31.345099944000026, -27.970090063999976],
            [31.488839944000063, -27.85770993799997],
            [31.51141294400003, -27.83823406299996],
            [31.504340944000035, -27.812478062999958],
            [31.570779944000037, -27.64861006299998],
            [31.51992994400007, -27.670030062999956],
            [31.45533994400006, -27.609170062999965],
            [31.297369944000025, -27.511700062999978],
            [31.254949944000032, -27.581740062999984],
            [31.171449944000074, -27.563989937999963],
            [31.189004478000072, -27.454314525999962],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN263' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.99042994200005, -28.18492993899997],
            [29.814084154000057, -28.215034868999965],
            [29.72759994200004, -28.12564993899997],
            [29.663289934000034, -28.14202004499998],
            [29.62633996900007, -28.18573996999993],
            [29.619765027000028, -28.241219959999967],
            [29.50992004400007, -28.26543993699994],
            [29.375559977000023, -28.37210997099993],
            [29.438269942000034, -28.423119938999946],
            [29.485419942000078, -28.402649938999957],
            [29.519459942000026, -28.471819938999943],
            [29.491880942000023, -28.528799938999953],
            [29.56564994200005, -28.570809938999957],
            [29.610382942000058, -28.532850938999957],
            [29.669979942000055, -28.562320063999948],
            [29.567449942000053, -28.665359938999984],
            [29.669979942000055, -28.74715993899997],
            [29.761249942000063, -28.737949938999975],
            [29.847860067000056, -28.74389993899996],
            [29.82913994200004, -28.698639938999975],
            [29.88163006700006, -28.669499938999934],
            [29.930629942000053, -28.681829938999954],
            [29.99502994200003, -28.642819938999935],
            [30.043330067000056, -28.70574993899993],
            [30.144079943000065, -28.745679938999956],
            [30.267529943000056, -28.731019938999964],
            [30.27860994300005, -28.683799938999982],
            [30.220729943000038, -28.57331993899993],
            [30.300659943000028, -28.53409993899993],
            [30.337770068000054, -28.47392006399997],
            [30.23359494300007, -28.408709938999948],
            [30.178124943000057, -28.43966293899996],
            [30.135639943000058, -28.340529938999964],
            [30.07547994300006, -28.357839938999973],
            [30.06540994200003, -28.305130063999968],
            [29.97679394200003, -28.239587938999932],
            [29.99042994200005, -28.18492993899997],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN238' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.758832939000058, -32.331968064999955],
            [27.705318436000027, -32.32440268399995],
            [27.64370824200006, -32.278592110999966],
            [27.60068758700004, -32.21345436599995],
            [27.535090000000025, -32.197479999999985],
            [27.507879998000078, -32.230749996999975],
            [27.492120002000036, -32.30663000199996],
            [27.451350003000073, -32.35220999699993],
            [27.386880002000055, -32.358830001999934],
            [27.347779997000032, -32.311730000999944],
            [27.243620002000057, -32.28194000299993],
            [27.16072999900007, -32.23849999799995],
            [27.010920000000056, -32.22249999999997],
            [26.970180000000028, -32.193839999999966],
            [26.892960000000073, -32.27160999999995],
            [26.844930000000033, -32.27038999999996],
            [26.775780000000054, -32.333279999999945],
            [26.86515000000003, -32.51154999999994],
            [26.950570000000027, -32.547829999999976],
            [27.017100002000063, -32.51125000299993],
            [27.036430000000053, -32.56634999999994],
            [27.004514998000047, -32.60509500099994],
            [27.025570001000062, -32.68177000199995],
            [27.017230002000076, -32.785150001999966],
            [27.15761029300006, -32.83846006899995],
            [27.230619997000076, -32.71738999599995],
            [27.297439997000026, -32.676680000999966],
            [27.371290001000034, -32.69976000299994],
            [27.39574483100006, -32.73227080499993],
            [27.37006341800003, -32.80434184799998],
            [27.45610000100004, -32.78162999799997],
            [27.51527999700005, -32.71594000099998],
            [27.536440001000074, -32.792619997999964],
            [27.67416999900007, -32.83434999999997],
            [27.78268999900007, -32.74894000399996],
            [27.677970001000062, -32.66043999699997],
            [27.729159999000046, -32.61632000299994],
            [27.729699998000058, -32.510870000999944],
            [27.787990002000072, -32.52757000199995],
            [27.893980003000024, -32.45614999999998],
            [27.758832939000058, -32.331968064999955],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC124' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.56120207300006, -23.226929905999953],
            [31.317955018000077, -23.30097770699996],
            [31.301942825000026, -23.378080367999928],
            [31.238309860000072, -23.340030669999976],
            [31.173540115000037, -23.350185393999936],
            [31.143371582000043, -23.531866073999936],
            [31.078299997000045, -23.64602999999994],
            [31.008350002000043, -23.67619000299993],
            [30.971369999000046, -23.66486999899996],
            [30.759670003000053, -23.697349990999953],
            [30.715659997000046, -23.648100002999968],
            [30.624930001000052, -23.596700001999977],
            [30.613521002000027, -23.633207999999968],
            [30.492049998000027, -23.713759996999954],
            [30.525589999000033, -23.727099995999936],
            [30.531499996000036, -23.804949996999937],
            [30.585719999000048, -23.84737000299998],
            [30.555018003000043, -23.890914003999967],
            [30.557380004000038, -23.94147999599994],
            [30.480120000000056, -23.980880010999954],
            [30.675509997000063, -24.14592999699994],
            [30.77604999700003, -24.092389998999977],
            [30.846260002000065, -24.098319999999944],
            [30.940210000000036, -24.053039998999964],
            [31.012669998000035, -24.12941999399993],
            [31.063430002000075, -24.091459998999937],
            [31.13377999800008, -24.07369999699995],
            [31.19425000800004, -24.03114999899998],
            [31.252280003000067, -24.09773000299998],
            [31.428049998000063, -24.054499999999962],
            [31.44093999900008, -24.020980002999977],
            [31.594699999000056, -24.05636999799998],
            [31.665980002000026, -24.016699999999958],
            [31.68372000000005, -24.059530003999953],
            [31.73581000300004, -24.04607999999996],
            [31.767479998000056, -23.98461999999995],
            [31.883834663000073, -23.984594453999932],
            [31.880720001000043, -23.95505000199995],
            [31.76918000300003, -23.88779999999997],
            [31.697390004000056, -23.721889992999934],
            [31.69054999900004, -23.629440002999957],
            [31.561020000000042, -23.481959996999933],
            [31.550730001000034, -23.41028000199998],
            [31.56120207300006, -23.226929905999953],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM334' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.152459995000072, -31.78860999799997],
            [24.070940002000043, -31.807089996999935],
            [24.028519997000046, -31.730170000999976],
            [23.96306000100003, -31.706670006999957],
            [23.94865999900003, -31.773330000999977],
            [23.878630002000023, -31.833680004999962],
            [23.808520002000023, -31.76365999799998],
            [23.847620002000042, -31.729219996999973],
            [23.756489996000028, -31.69571000199994],
            [23.715130000000045, -31.64704000399996],
            [23.496109997000076, -31.702689998999972],
            [23.42314000500005, -31.682140001999983],
            [23.40708999700007, -31.713799999999935],
            [23.30242000000004, -31.730149998999934],
            [23.263440003000028, -31.778340000999947],
            [23.23036999900006, -31.87569000299993],
            [23.139449995000064, -31.951539998999976],
            [23.087619999000026, -31.972290000999976],
            [23.052589999000077, -31.939780000999974],
            [23.067390000000046, -31.89073999599998],
            [22.975830002000066, -31.860829998999975],
            [22.901950001000046, -31.875769997999953],
            [22.858970002000035, -31.818289999999934],
            [22.776880000000062, -31.85690999999997],
            [22.73510000500005, -31.79937999599997],
            [22.65152999700007, -31.821670001999962],
            [22.578340001000072, -31.80551000099996],
            [22.619070003000047, -31.72465000099993],
            [22.56481499000006, -31.677919994999968],
            [22.495760001000065, -31.67033999599994],
            [22.312290002000054, -31.58346000199998],
            [22.272920000000056, -31.592540000999975],
            [22.26010000200006, -31.662470000999974],
            [22.20401000000004, -31.76403000199997],
            [22.166599999000027, -31.893089998999983],
            [22.101439998000046, -31.898719994999965],
            [22.07133000300007, -31.939299996999978],
            [22.094980004000035, -32.00105999899995],
            [22.069560000000024, -32.08144999899997],
            [22.016439990000038, -32.11425999499994],
            [21.995920002000048, -32.20298000399998],
            [21.936205003000055, -32.22288000399993],
            [21.92460000600005, -32.26196000099998],
            [21.855109998000046, -32.275509994999936],
            [21.78061999700003, -32.25092999999998],
            [21.73589000000004, -32.20502000099998],
            [21.691649995000034, -32.24857000199995],
            [21.64457999800004, -32.20871000099993],
            [21.536010000000033, -32.22922000999995],
            [21.561809999000047, -32.314730001999976],
            [21.475640003000024, -32.33145000199994],
            [21.40839999700006, -32.368769999999984],
            [21.303010011000026, -32.402440001999935],
            [21.269479997000076, -32.45029000099993],
            [21.188309998000022, -32.50304999499997],
            [21.25053000300005, -32.547910000999934],
            [21.35224000100004, -32.65772999899997],
            [21.426580004000073, -32.66712999799995],
            [21.432109997000055, -32.75672999699998],
            [21.479760003000024, -32.78659999699994],
            [21.691180001000077, -32.71439000099997],
            [21.717760002000034, -32.641649997999934],
            [21.760430003000067, -32.65843999899994],
            [21.945939999000075, -32.609800003999965],
            [22.033419997000067, -32.55492999799998],
            [22.071850011000038, -32.64271999699997],
            [22.065019996000046, -32.71055999699996],
            [22.12416999800007, -32.732839997999974],
            [22.191380000000038, -32.79061000099995],
            [22.21728000400003, -32.744149996999965],
            [22.30132999700004, -32.73991000199993],
            [22.321340001000067, -32.82061000799996],
            [22.38400000000007, -32.87083000599995],
            [22.455680003000055, -32.876530000999935],
            [22.66463999800004, -32.92879999599995],
            [22.78315000200007, -32.93059999899998],
            [22.83540000100004, -33.03773999999993],
            [22.934090000000026, -33.02165999899995],
            [22.948750001000064, -32.950040000999934],
            [23.007439997000063, -32.872819998999944],
            [23.098009998000066, -32.87369000899997],
            [23.08935000100007, -32.79917999699995],
            [23.149329996000063, -32.766739997999935],
            [23.37862000100006, -32.82501999599998],
            [23.30130999800008, -32.65178999899996],
            [23.288155001000064, -32.55120999799993],
            [23.24447000400005, -32.513229998999975],
            [23.221610003000023, -32.42503999999997],
            [23.307329999000046, -32.39592000199997],
            [23.33305000400003, -32.35113999799995],
            [23.40985000200004, -32.38919999899997],
            [23.448959998000078, -32.323269997999944],
            [23.66514999900005, -32.344229997999946],
            [23.648870002000024, -32.29801999599994],
            [23.670450002000052, -32.23767000399994],
            [23.79785000100003, -32.19407000299998],
            [23.892299997000066, -32.25494999599994],
            [23.961149999000042, -32.20652000399997],
            [24.100129996000078, -32.16399999999993],
            [24.13552999700005, -32.12314000099997],
            [24.10967499700007, -32.084289998999964],
            [24.140870001000053, -32.01170999799996],
            [24.222410000000025, -31.95564000099995],
            [24.164199997000026, -31.902410002999943],
            [24.105380000000025, -31.906850001999942],
            [24.152459995000072, -31.78860999799997],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC053' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.713779997000074, -24.95362000199998],
            [28.65762999800006, -24.837700001999963],
            [28.50488000000007, -24.87354000299996],
            [28.36611800000003, -24.78649399699998],
            [28.29210999700007, -24.795669997999937],
            [28.276230000000055, -24.751969998999982],
            [28.21060999900004, -24.730619997999952],
            [28.176136017000033, -24.681600570999933],
            [28.09486000000004, -24.63025999699994],
            [27.996049999000036, -24.63843000199995],
            [27.89511999700005, -24.582679994999978],
            [27.86470999900007, -24.69523000299995],
            [27.82673999800005, -24.713320000999943],
            [27.87066400300006, -24.768357996999953],
            [27.830980001000057, -24.849409999999978],
            [27.859920000000045, -24.87137000299998],
            [27.977860003000046, -24.90102000199994],
            [27.983559998000032, -24.957849997999972],
            [28.25975999700006, -25.050449999999955],
            [28.19827000300006, -25.12759000099993],
            [28.15393000000006, -25.086780000999966],
            [28.128970002000074, -25.145689989999937],
            [28.13571999900006, -25.20563999799998],
            [28.246270001000028, -25.212855003999948],
            [28.298160001000042, -25.310370001999956],
            [28.38260000500003, -25.321149999999932],
            [28.503590001000077, -25.30883999899993],
            [28.513280004000023, -25.256149998999945],
            [28.659309999000072, -25.234780000999933],
            [28.615870002000065, -25.15162999699993],
            [28.651569996000035, -25.142899996999972],
            [28.536829999000076, -25.152549990999944],
            [28.461599997000064, -25.20147999699998],
            [28.411020001000054, -25.20482999999996],
            [28.379259999000055, -25.155299998999965],
            [28.44297000100005, -25.128989988999933],
            [28.473739998000042, -25.08931999899994],
            [28.634289996000064, -25.058240001999934],
            [28.605540003000044, -25.003799997999977],
            [28.713779997000074, -24.95362000199998],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM366' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.18442999900003, -32.82707000199997],
            [19.15052999900007, -32.87211999699997],
            [19.09860999700004, -32.879119996999975],
            [19.03567000000004, -32.848870001999956],
            [19.007160003000024, -32.71618999599997],
            [18.930969998000023, -32.60679000299996],
            [18.848940000000027, -32.52178999699993],
            [18.791439989000025, -32.55943999999994],
            [18.724900002000027, -32.56648999899994],
            [18.642719998000075, -32.45601999899998],
            [18.591269999000076, -32.464839998999935],
            [18.492800001000035, -32.438339998999936],
            [18.458519998000043, -32.47643000199997],
            [18.398829998000053, -32.42551000299994],
            [18.334489998000038, -32.44294999899995],
            [18.320319996000023, -32.54778000899995],
            [18.279430002000026, -32.63322999799993],
            [18.161499997000078, -32.758679996999945],
            [18.124805002000073, -32.77778499999994],
            [18.171710002000054, -32.85109000199998],
            [18.29260000100004, -32.96199000399997],
            [18.340079997000032, -32.94646999799994],
            [18.511344003000033, -32.94604598799998],
            [18.59600000100005, -32.90072000899994],
            [18.72658000200005, -32.95053000099995],
            [18.807800003000068, -33.03002000199996],
            [18.844649998000023, -33.11732000099994],
            [18.939005000000066, -33.19638999799997],
            [18.98010000000005, -33.15210999999994],
            [19.072419997000054, -33.127659997999956],
            [19.172990000000027, -33.09192000199994],
            [19.153710001000036, -32.98403999899995],
            [19.18442999900003, -32.82707000199997],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC013' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.662844617000076, -27.79470825599998],
            [32.52307608000007, -27.77544761699994],
            [32.52578322800008, -27.68469506599996],
            [32.41573307700003, -27.661980149999977],
            [32.33728794500007, -27.753563062999945],
            [32.259768945000076, -27.807365062999963],
            [32.19023006900005, -27.784149937999928],
            [32.17151994400007, -27.850339937999934],
            [32.098209944000075, -27.872570062999955],
            [32.031879944000025, -27.92858006299997],
            [31.968709944000068, -27.930920062999974],
            [31.94805994400008, -28.013130063999938],
            [31.81923994400006, -28.038040063999972],
            [31.807360069000026, -28.216039938999984],
            [31.733409944000073, -28.218509938999944],
            [31.70206494400003, -28.371455063999974],
            [31.74105994400003, -28.433460063999973],
            [31.811069944000053, -28.431680938999932],
            [31.96252994400004, -28.406219938999982],
            [31.981432944000062, -28.35041993899995],
            [32.02841994400006, -28.220219938999946],
            [32.12099994400006, -28.117189938999957],
            [32.26751994500006, -28.145899938999946],
            [32.339399945000025, -28.098979938999946],
            [32.349838945000045, -28.052269063999972],
            [32.443477631000064, -28.109577178999928],
            [32.614832748000026, -28.133148029999973],
            [32.64947194500007, -27.942397937999942],
            [32.662844617000076, -27.79470825599998],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN276' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.647020000000055, -33.98055999999997],
            [23.65522999800004, -33.88738999699996],
            [23.517920004000075, -33.78562000299996],
            [23.468049999000073, -33.80747999999994],
            [23.395039996000037, -33.79263999899996],
            [23.325480002000063, -33.79913000399995],
            [23.33441000600004, -33.85656000299997],
            [23.22901000300004, -33.87834999699993],
            [23.21071000300003, -33.96288999899997],
            [23.168739996000056, -34.006250001999945],
            [23.164119998000047, -34.08305000099995],
            [23.286390004000054, -34.101719997999965],
            [23.37552000000005, -34.09816000099994],
            [23.384460002000026, -34.04006000199996],
            [23.437879998000028, -34.00864000299998],
            [23.561899999000048, -33.98187000399997],
            [23.647020000000055, -33.98055999999997],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC047' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.92327896200004, -22.457035037999958],
            [28.88087999700008, -22.44783999999993],
            [28.83105000100005, -22.488250000999983],
            [28.710359999000048, -22.514749999999935],
            [28.639279999000053, -22.558710007999935],
            [28.48285000100003, -22.57176000399994],
            [28.342640001000063, -22.57372000099997],
            [28.209670001000063, -22.66446000199994],
            [28.15972000100004, -22.718329998999934],
            [28.16236999800003, -22.755859998999938],
            [28.096936971000048, -22.811053028999936],
            [28.147640000000024, -22.916039999999953],
            [28.234560000000045, -22.96703999999994],
            [28.22434000000004, -23.04932999999994],
            [28.25177000000008, -23.10865999999993],
            [28.291180000000054, -23.090979999999945],
            [28.33707000000004, -23.12283999999994],
            [28.353290000000072, -23.18414999999993],
            [28.32009000000005, -23.204019999999957],
            [28.355540000000076, -23.28344999999996],
            [28.413290000000075, -23.351669999999956],
            [28.47404000000006, -23.31218999999993],
            [28.595938052000065, -23.40472805199994],
            [28.659700001000033, -23.385749998999927],
            [28.68511998500003, -23.336130020999974],
            [28.73576997200007, -23.330910030999974],
            [28.795609971000033, -23.416060028999937],
            [28.910059971000067, -23.544460029999982],
            [28.969249811000054, -23.59783252699998],
            [29.01020108000006, -23.620451171999946],
            [29.066478751000034, -23.554339891999973],
            [29.076866997000025, -23.388579999999934],
            [29.026280003000068, -23.37662999799994],
            [29.082059956000023, -23.299960044999978],
            [29.157239969000045, -23.318800003999968],
            [29.267809965000026, -23.238640029999942],
            [29.251730000000066, -23.107069999999965],
            [29.31015000000008, -23.07379999999995],
            [29.246350000000064, -22.93838999999997],
            [29.18333000000007, -22.973549999999932],
            [29.166969942000037, -22.91779005899997],
            [29.222919942000033, -22.807430058999955],
            [29.244899942000075, -22.735260058999927],
            [29.204719984000064, -22.712639956999965],
            [29.20935997500004, -22.66278004299994],
            [29.16587994200006, -22.553120057999934],
            [29.107339942000067, -22.539250057999936],
            [28.979110066000032, -22.581130058999975],
            [28.932910066000034, -22.521060056999943],
            [28.92327896200004, -22.457035037999958],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM351' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.887309997000045, -32.48680000199994],
            [25.797389991000045, -32.477220003999946],
            [25.785559999000043, -32.53790000099997],
            [25.65508199800007, -32.50690700299998],
            [25.621720002000075, -32.45678999599994],
            [25.574369999000055, -32.457799997999984],
            [25.534059996000053, -32.394469998999966],
            [25.398729996000043, -32.41303000099998],
            [25.407709999000076, -32.37400999699997],
            [25.309550001000048, -32.31332999199998],
            [25.27862999900003, -32.34555999799994],
            [25.167560003000062, -32.328709999999944],
            [25.128310002000035, -32.291099997999936],
            [25.055050004000066, -32.28005000099995],
            [24.949610000000064, -32.241180001999965],
            [24.93173000400003, -32.28374999699997],
            [24.86018000200005, -32.32967999999994],
            [24.795180001000062, -32.40922999899993],
            [24.76141000100006, -32.377580000999956],
            [24.589819996000074, -32.44383999799993],
            [24.545329996000078, -32.56204000199995],
            [24.45657920800005, -32.64081954999995],
            [24.41367999600004, -32.73698000299993],
            [24.47182000400005, -32.76540999799994],
            [24.54287000000005, -32.71666999799993],
            [24.691030004000027, -32.69167999699994],
            [24.784050002000072, -32.72305999599996],
            [24.910831407000046, -32.74323000299995],
            [24.933970000000045, -32.78151000399998],
            [24.992540009000038, -32.800289996999936],
            [25.08741000200007, -32.87103000199994],
            [25.01616000100006, -32.91490000099998],
            [25.10160999800007, -32.951240000999974],
            [25.077050000000042, -33.00292999699997],
            [25.113699999000062, -33.11572000199993],
            [25.173969998000075, -33.119599996999966],
            [25.178260000000023, -33.251679999999965],
            [25.315679998000064, -33.259919999999966],
            [25.450720002000025, -33.283530000999974],
            [25.78963999800004, -33.28451999899994],
            [25.927680004000024, -33.31238000099995],
            [25.98793999700007, -33.306610002999946],
            [26.016490003000058, -33.25040999699996],
            [25.970839996000052, -33.23293000099994],
            [25.948189998000032, -33.17266000199993],
            [25.96258000000006, -33.109969999999976],
            [26.021529997000073, -33.081929997999964],
            [26.096130001000063, -32.98309000299997],
            [26.135669990000054, -32.96016999699998],
            [26.274939998000036, -32.93697999899996],
            [26.28508000000005, -32.89918999799994],
            [26.223600003000058, -32.85712999899994],
            [26.179510003000075, -32.76344000199998],
            [26.06595999900003, -32.78693000099997],
            [26.032040003000077, -32.76401000299995],
            [26.063979997000047, -32.685599998999976],
            [26.047619999000062, -32.63280000299994],
            [26.127175000000022, -32.59543999599998],
            [26.08084000100007, -32.54658000199993],
            [25.939830003000054, -32.53871999699993],
            [25.887309997000045, -32.48680000199994],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC102' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.336220000000026, -33.48781999099998],
            [20.335609990000023, -33.42564000099998],
            [20.368039999000075, -33.36626999999993],
            [20.209170001000075, -33.379799996999964],
            [20.251180001000023, -33.29151000099995],
            [20.235620002000076, -33.26241999699994],
            [20.257969999000068, -33.18844999099997],
            [20.202179999000066, -33.17010999799993],
            [20.086984003000055, -33.19327799599995],
            [20.013769999000033, -33.23878800399996],
            [19.972039997000024, -33.316779990999976],
            [19.90847000100007, -33.36269999599995],
            [19.830580000000054, -33.37942000199996],
            [19.66866999900003, -33.38186000099995],
            [19.58069000200004, -33.36452000399993],
            [19.537909998000032, -33.426440000999946],
            [19.405300003000036, -33.480509998999935],
            [19.378590001000077, -33.61909000399993],
            [19.31132000200006, -33.607100000999935],
            [19.23946999800006, -33.558840000999965],
            [19.107040003000066, -33.54113999699996],
            [19.101960000000076, -33.606760005999945],
            [19.183989998000072, -33.715390001999936],
            [19.21404900600004, -33.857067995999955],
            [19.24380000000008, -33.89744999699997],
            [19.297400003000064, -33.88967999999994],
            [19.318860001000075, -33.94719000099997],
            [19.455799998000032, -33.99987999999996],
            [19.506889998000077, -33.97169999999994],
            [19.54539999800005, -33.91564999899998],
            [19.532279998000035, -33.878429998999934],
            [19.681389998000043, -33.79936999999995],
            [19.659639997000056, -33.77508999999998],
            [19.70207000100004, -33.71842998899996],
            [19.69963000100006, -33.63793000199996],
            [19.645191003000036, -33.604601000999935],
            [19.637590002000024, -33.536550001999956],
            [19.79846999700004, -33.53789999799994],
            [19.83878999700005, -33.56594999799995],
            [19.91710001100006, -33.51927000099994],
            [19.992483868000022, -33.556838168999946],
            [20.125414309000064, -33.55628514099993],
            [20.173060001000067, -33.52624699699993],
            [20.24153099700004, -33.53804599699998],
            [20.336220000000026, -33.48781999099998],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC025' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.78268999900007, -32.74894000399996],
            [27.67416999900007, -32.83434999999997],
            [27.536440001000074, -32.792619997999964],
            [27.51527999700005, -32.71594000099998],
            [27.45610000100004, -32.78162999799997],
            [27.37006341800003, -32.80434184799998],
            [27.39574483100006, -32.73227080499993],
            [27.371290001000034, -32.69976000299994],
            [27.297439997000026, -32.676680000999966],
            [27.230619997000076, -32.71738999599995],
            [27.15761029300006, -32.83846006899995],
            [27.232879997000055, -32.852349997999966],
            [27.217910004000032, -32.89013000099993],
            [27.239752891000023, -32.95668991699995],
            [27.29586428300007, -33.02417272899993],
            [27.34307485200003, -32.96295413499996],
            [27.503910002000055, -32.995219996999936],
            [27.44417001100004, -33.07976000599996],
            [27.360132943000053, -33.12994728399997],
            [27.37488999900006, -33.180089995999936],
            [27.424730001000057, -33.193019997999954],
            [27.442949999000064, -33.25837999799995],
            [27.49182999900006, -33.28203999799996],
            [27.608599997000056, -33.21818999799996],
            [27.72796999800005, -33.12144000099994],
            [27.919659999000032, -33.02961000399995],
            [27.969119997000064, -32.97365000299993],
            [28.075529994000078, -32.907794999999965],
            [27.991459946000077, -32.85556183399996],
            [27.95717783400005, -32.75833922499993],
            [27.882910001000027, -32.78550000299998],
            [27.78268999900007, -32.74894000399996],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'BUF' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.883834663000073, -23.984594453999932],
            [31.767479998000056, -23.98461999999995],
            [31.73581000300004, -24.04607999999996],
            [31.68372000000005, -24.059530003999953],
            [31.665980002000026, -24.016699999999958],
            [31.594699999000056, -24.05636999799998],
            [31.44093999900008, -24.020980002999977],
            [31.428049998000063, -24.054499999999962],
            [31.252280003000067, -24.09773000299998],
            [31.19425000800004, -24.03114999899998],
            [31.13377999800008, -24.07369999699995],
            [31.063430002000075, -24.091459998999937],
            [31.120569998000065, -24.090259999999944],
            [31.10726999900004, -24.145730000999947],
            [31.04993999800007, -24.187319996999975],
            [31.05602000500005, -24.32188999699997],
            [31.200059999000075, -24.304949991999933],
            [31.242029998000078, -24.365430000999936],
            [31.159969998000065, -24.37557000199996],
            [31.25366000200006, -24.499120000999937],
            [31.226180011000054, -24.556010001999937],
            [30.95931999900006, -24.582070000999977],
            [30.954330011000025, -24.521279999999933],
            [30.871709999000075, -24.538500002999967],
            [30.795040001000075, -24.57749000399997],
            [30.89888000600007, -24.63033000799993],
            [30.88992999800007, -24.70875000199993],
            [30.919410003000053, -24.80515999599993],
            [31.00542000300004, -24.83701999599998],
            [31.026809997000043, -24.914109998999947],
            [31.025230003000047, -25.030099993999954],
            [31.060699999000065, -24.99540000299993],
            [31.14072748700005, -24.98202324199997],
            [31.15310809500005, -25.02240632099995],
            [31.24930000300003, -25.018360137999935],
            [31.317630768000072, -24.96453094499998],
            [31.421579361000056, -24.972740172999977],
            [31.564248501000066, -24.96042203299993],
            [31.61089389600005, -24.98924693999993],
            [31.71690900200008, -24.954299998999943],
            [31.823160001000076, -25.06190799999996],
            [31.942004000000054, -25.124763997999935],
            [31.958945011000026, -25.164785999999935],
            [32.031979997000064, -25.18309499999998],
            [32.03017000400007, -25.06569000099995],
            [31.998270003000073, -24.68974000199995],
            [32.01309999800003, -24.45458999999994],
            [31.987129998000057, -24.30219999999997],
            [31.908010003000072, -24.182429998999964],
            [31.883834663000073, -23.984594453999932],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP325' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.871390005000023, -34.45243999999997],
            [20.53172999900005, -34.360520002999976],
            [20.484750001000066, -34.401319988999944],
            [20.391979997000078, -34.426290000999984],
            [20.35731000000004, -34.38844000199998],
            [20.289079999000023, -34.41777000299993],
            [20.28633000700006, -34.34515000199997],
            [20.244850000000042, -34.288889998999935],
            [20.065529998000045, -34.24126999599997],
            [20.032429998000055, -34.20359999699997],
            [19.940030000000036, -34.23955000299998],
            [19.880430000000047, -34.22010999999998],
            [19.845399997000072, -34.280439996999974],
            [19.740940000000023, -34.31261999999998],
            [19.641055394000034, -34.372031739999954],
            [19.624219995000033, -34.41871999999995],
            [19.69587000000007, -34.43223999899993],
            [19.713349996000034, -34.46856000199995],
            [19.68816000000004, -34.56220999799996],
            [19.719719998000073, -34.59977000099997],
            [19.724737004000076, -34.767248998999946],
            [19.87223000000006, -34.76589999999993],
            [19.989179998000054, -34.83337000299997],
            [20.079780001000074, -34.73651000199993],
            [20.162939996000034, -34.697499996999966],
            [20.232589997000048, -34.68962000399995],
            [20.258840002000056, -34.63828999899994],
            [20.407240002000037, -34.56343000199996],
            [20.47609000400007, -34.492329997999946],
            [20.597849998000072, -34.455270000999974],
            [20.691119999000023, -34.45026999999993],
            [20.84837999900003, -34.47234999699998],
            [20.871390005000023, -34.45243999999997],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC033' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.02622000100007, -31.876639998999963],
            [18.981950002000076, -31.85570000399997],
            [18.875510003000045, -31.85241999599998],
            [18.740900001000057, -31.878890001999935],
            [18.62286000000006, -31.95634000299998],
            [18.56123999700003, -31.87885999899993],
            [18.451599999000052, -31.84381999699997],
            [18.395689997000034, -31.873970001999965],
            [18.411920003000034, -31.94558999999998],
            [18.29026699700006, -32.00665299999997],
            [18.31392999800005, -32.08357000099994],
            [18.31031000300004, -32.17262000399995],
            [18.342220002000033, -32.265699998999935],
            [18.314230000000066, -32.31651999999997],
            [18.334489998000038, -32.44294999899995],
            [18.398829998000053, -32.42551000299994],
            [18.458519998000043, -32.47643000199997],
            [18.492800001000035, -32.438339998999936],
            [18.591269999000076, -32.464839998999935],
            [18.642719998000075, -32.45601999899998],
            [18.724900002000027, -32.56648999899994],
            [18.791439989000025, -32.55943999999994],
            [18.848940000000027, -32.52178999699993],
            [18.930969998000023, -32.60679000299996],
            [19.007160003000024, -32.71618999599997],
            [19.03567000000004, -32.848870001999956],
            [19.09860999700004, -32.879119996999975],
            [19.15052999900007, -32.87211999699997],
            [19.18442999900003, -32.82707000199997],
            [19.171769996000023, -32.736819999999966],
            [19.204800001000024, -32.71113998799996],
            [19.142990000000054, -32.62143999799997],
            [19.159169999000028, -32.57193000099994],
            [19.26470000300003, -32.588720001999945],
            [19.320050002000073, -32.57463999999993],
            [19.356930000000034, -32.616360003999944],
            [19.419019998000067, -32.622319999999945],
            [19.48680500300003, -32.56543999599995],
            [19.496370003000038, -32.47481999799993],
            [19.430200004000028, -32.36570999899993],
            [19.409080002000053, -32.29007999799995],
            [19.49150000000003, -32.25237000599998],
            [19.515190005000022, -32.11519999999996],
            [19.395849996000038, -32.01511000299996],
            [19.210710000000063, -31.948039996999967],
            [19.142450002000032, -31.912080001999982],
            [19.02622000100007, -31.876639998999963],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC012' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.64662999500007, -25.71242000899997],
            [30.61119000900004, -25.719020000999933],
            [30.381149996000033, -25.886899995999954],
            [30.331109998000045, -25.88054000099993],
            [30.299050002000058, -25.92637999699997],
            [30.243440002000057, -25.87211000999997],
            [30.270399999000063, -25.825370000999953],
            [30.21375000200004, -25.804019998999934],
            [30.086688003000063, -25.860293997999975],
            [29.943750004000037, -25.905660000999944],
            [29.86179000100003, -25.862450002999935],
            [29.830569997000055, -25.921929999999975],
            [29.876959998000075, -25.965210001999935],
            [29.86578999900007, -26.01392999899997],
            [29.811059999000065, -26.105299998999953],
            [29.80468999800007, -26.189510002999953],
            [29.844699998000067, -26.22162999699998],
            [29.94110000200004, -26.216639999999927],
            [29.96906000200005, -26.243360000999928],
            [30.06185499700007, -26.209603000999948],
            [30.209469999000078, -26.220130001999962],
            [30.35802000500007, -26.17068999999998],
            [30.493890002000057, -26.23303999999996],
            [30.592760000000055, -26.207990002999964],
            [30.624160003000043, -26.25877000299994],
            [30.61073000400006, -26.316950003999978],
            [30.688579997000033, -26.306109999999933],
            [30.755520997000076, -26.332773003999932],
            [30.74868000300006, -26.374510003999944],
            [30.698690012000043, -26.444570002999967],
            [30.717919996000035, -26.48579000099994],
            [30.800260002000073, -26.504059998999935],
            [30.831010003000074, -26.41117000099996],
            [30.891860001000055, -26.32082000099996],
            [30.96143799600003, -26.261731999999938],
            [31.11275000200004, -25.98256999599994],
            [31.12657000300004, -25.92114999699993],
            [31.055690997000056, -25.92392099799997],
            [31.03951999900005, -25.86626000299998],
            [30.968099997000024, -25.93476000399994],
            [30.849860000000035, -25.92634000399994],
            [30.823059998000076, -25.876519997999935],
            [30.773649999000042, -25.86193999099993],
            [30.732650001000025, -25.741350001999933],
            [30.64662999500007, -25.71242000899997],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP301' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.787539997000067, -33.637630000999934],
            [18.73673001000003, -33.68703000199997],
            [18.627000000000066, -33.624589999999955],
            [18.57642000000004, -33.53147999699996],
            [18.524160003000077, -33.52522999699994],
            [18.455458003000047, -33.47127600399995],
            [18.38881999700004, -33.50890999999996],
            [18.343040006000024, -33.570630000999984],
            [18.437959998000053, -33.69256000399997],
            [18.449770001000047, -33.78182000099997],
            [18.488699997000026, -33.851910002999944],
            [18.46521999600003, -33.91209999999995],
            [18.398259997000025, -33.90088000199995],
            [18.369799999000065, -33.974599988999955],
            [18.31063000200004, -34.04329000299998],
            [18.35694999900005, -34.11038000299993],
            [18.31833000300003, -34.14590999599994],
            [18.362840000000062, -34.184369996999976],
            [18.40219999800007, -34.309650002999945],
            [18.45322000300007, -34.336669996999944],
            [18.475430001000063, -34.23044999799998],
            [18.426410003000058, -34.17718999699997],
            [18.46909000100004, -34.109140010999965],
            [18.597439997000038, -34.07760999899995],
            [18.69465999700003, -34.07210999999995],
            [18.813380004000066, -34.10132999699994],
            [18.86811999300005, -34.16047999799997],
            [18.81973000100004, -34.185329999999965],
            [18.845815000000073, -34.26959000299996],
            [18.930709386000046, -34.203527863999966],
            [18.943900000000042, -34.13823999699997],
            [19.005338203000065, -34.07427507199998],
            [18.98713112300004, -34.03526966299995],
            [18.955299998000044, -34.010110001999976],
            [18.790210003000027, -34.05287999999996],
            [18.744430004000037, -34.024820001999956],
            [18.729180020000058, -33.96747639199998],
            [18.75287000000003, -33.834419999999966],
            [18.79257000100006, -33.81921000199998],
            [18.80945999900007, -33.74078000199995],
            [18.787539997000067, -33.637630000999934],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'CPT' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.181050000000027, -25.91954999799998],
            [28.110230001000048, -25.944910010999934],
            [27.983980003000056, -25.902829999999938],
            [27.932119998000076, -25.916300000999968],
            [27.912640002000046, -26.02820999599993],
            [27.84964000000008, -26.06238001099996],
            [27.83881000300005, -26.12021999999996],
            [27.77199000300004, -26.21320999699998],
            [27.71826999700005, -26.198929998999972],
            [27.743799996000064, -26.28722000199997],
            [27.813679996000076, -26.28564999799994],
            [27.811589997000056, -26.36447500299994],
            [27.751864003000037, -26.361995002999947],
            [27.76128999900004, -26.419150000999934],
            [27.759710004000056, -26.48386998799998],
            [27.821689998000068, -26.48487999799994],
            [27.887210001000028, -26.526250000999937],
            [27.869074999000077, -26.44480099799995],
            [27.912229996000065, -26.35894999599998],
            [27.969980002000057, -26.34170000699993],
            [28.067101999000045, -26.34194000399998],
            [28.070560003000026, -26.272619997999982],
            [28.122851998000044, -26.247929002999967],
            [28.112739996000073, -26.167779997999958],
            [28.184829997000065, -26.089259998999978],
            [28.158183001000054, -26.038249999999948],
            [28.181050000000027, -25.91954999799998],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'JHB' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.45990999600008, -26.483499998999946],
            [26.384739999000033, -26.499899997999933],
            [26.333700006000072, -26.555159989999936],
            [26.248110002000033, -26.58731999899993],
            [26.27236000000005, -26.691440000999933],
            [26.11505999900004, -26.77104999599993],
            [26.07676000200007, -26.862330004999933],
            [26.129410000000064, -26.86912000199993],
            [26.190640002000066, -26.908319997999968],
            [26.139579996000066, -26.977389991999928],
            [26.22949000400007, -26.96963999999997],
            [26.270249997000064, -27.04090999699997],
            [26.301089997000076, -27.030529998999953],
            [26.390610003000063, -27.180885001999968],
            [26.419900003000066, -27.171359996999968],
            [26.473629999000025, -27.15375999899993],
            [26.521619999000052, -27.104389999999967],
            [26.585619997000038, -27.106029999999976],
            [26.581820003000075, -27.05311999999998],
            [26.621069997000063, -27.00272000299998],
            [26.67182000200006, -26.99573000099997],
            [26.80502000200005, -26.931979998999964],
            [26.866440002000047, -26.91906000299997],
            [26.89799000200003, -26.828930002999982],
            [26.85022243000003, -26.816509534999966],
            [26.79416000300006, -26.767229998999937],
            [26.783010000000047, -26.611090003999948],
            [26.704759999000032, -26.612480000999938],
            [26.694669997000062, -26.55868000199996],
            [26.63119000100005, -26.515979998999967],
            [26.530379994000043, -26.51806999799993],
            [26.45990999600008, -26.483499998999946],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW403' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.739590001000067, -25.28853000099997],
            [28.77541000000008, -25.18377000299995],
            [28.74458899700005, -25.10961200099996],
            [28.651569996000035, -25.142899996999972],
            [28.615870002000065, -25.15162999699993],
            [28.659309999000072, -25.234780000999933],
            [28.513280004000023, -25.256149998999945],
            [28.503590001000077, -25.30883999899993],
            [28.38260000500003, -25.321149999999932],
            [28.298160001000042, -25.310370001999956],
            [28.298060004000035, -25.33933999599998],
            [28.04473000400003, -25.401739994999957],
            [27.970759997000073, -25.362949989999947],
            [27.945639996000068, -25.40670000299997],
            [28.03595000400003, -25.470589996999934],
            [27.99243999500004, -25.518029999999953],
            [27.95763000100004, -25.59261999699993],
            [27.98056001200007, -25.632800006999958],
            [27.948190000000068, -25.695210003999932],
            [27.960169997000037, -25.815989996999974],
            [27.898200001000077, -25.859740003999946],
            [27.932119998000076, -25.916300000999968],
            [27.983980003000056, -25.902829999999938],
            [28.110230001000048, -25.944910010999934],
            [28.181050000000027, -25.91954999799998],
            [28.319479002000037, -25.913720000999945],
            [28.352380004000054, -25.954599997999935],
            [28.407189997000046, -25.924090001999957],
            [28.44442000400005, -25.99114999899996],
            [28.468670001000078, -26.07808999899993],
            [28.50305499700005, -26.063800002999983],
            [28.578939997000077, -26.059590002999983],
            [28.590949997000052, -26.00247999299995],
            [28.632260004000045, -25.970779996999966],
            [28.793860004000067, -26.004569999999944],
            [28.864839998000036, -26.001269994999973],
            [28.885049996000077, -25.974399997999967],
            [28.888960002000033, -25.88032999799998],
            [28.94107000200006, -25.877290002999928],
            [28.938169999000024, -25.823284995999927],
            [28.981310002000043, -25.74254000199994],
            [28.968830000000025, -25.67330999799998],
            [29.00829000300007, -25.66057000099994],
            [29.03999999800004, -25.617549999999937],
            [29.007760003000044, -25.57416000099994],
            [28.946540000000027, -25.599799996999934],
            [28.851780003000044, -25.501809999999978],
            [28.846950004000064, -25.68242000099997],
            [28.792730001000052, -25.70242999499993],
            [28.76631000200007, -25.64697999899994],
            [28.723870000000034, -25.63177000099995],
            [28.683779997000045, -25.67537999999996],
            [28.625750002000075, -25.52304999599994],
            [28.62257999800005, -25.33364999899993],
            [28.739590001000067, -25.28853000099997],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'TSH' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.561423243000036, -23.224282794999965],
            [31.563599990000057, -23.19822999799993],
            [31.344896727000048, -22.534532147999982],
            [31.17854309100005, -22.672002791999944],
            [31.070337296000048, -22.802122115999964],
            [30.977773666000076, -22.81967163099995],
            [31.013439178000056, -22.72781944199994],
            [30.88948059100005, -22.71283912699994],
            [30.894081568000047, -22.76321668399993],
            [30.822356611000032, -22.78262088699995],
            [30.77542085400006, -22.829517388999932],
            [30.721125296000025, -22.846444064999957],
            [30.658123518000025, -22.941118959999983],
            [30.60064794300007, -22.978891058999977],
            [30.505397414000072, -23.00142527299994],
            [30.47836033200008, -23.063286413999947],
            [30.410079943000028, -23.09472005899994],
            [30.357790943000055, -23.117338058999962],
            [30.23791194300003, -23.12428205899994],
            [30.189781400000072, -23.158214874999942],
            [30.245272930000056, -23.253729017999945],
            [30.159646492000036, -23.256312615999946],
            [30.151606737000066, -23.31379967999993],
            [30.268560962000038, -23.324409040999967],
            [30.29401998000003, -23.385680021999974],
            [30.328639966000026, -23.377580029999933],
            [30.36914997300005, -23.310160027999927],
            [30.334979974000078, -23.249440032999928],
            [30.40350697100007, -23.234244027999978],
            [30.487569971000028, -23.244240030999947],
            [30.562659973000052, -23.17569003099993],
            [30.652229971000054, -23.157420025999954],
            [30.728049972000065, -23.072310030999972],
            [30.880269971000075, -23.15055002799994],
            [30.929580688000044, -23.13943481399997],
            [30.966876984000066, -23.174127578999958],
            [31.15665817300004, -23.188066482999943],
            [31.20694541900008, -23.219594954999934],
            [31.374877930000025, -23.138339995999956],
            [31.41187095600003, -23.091106414999956],
            [31.534372330000053, -23.187564849999944],
            [31.561423243000036, -23.224282794999965],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM345' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.292336943000066, -27.95119393899995],
            [30.30680006800003, -27.891919937999944],
            [30.280709943000033, -27.81498993799994],
            [30.208594943000037, -27.788359937999928],
            [30.119619943000032, -27.82056993799995],
            [30.056739942000036, -27.822649937999984],
            [30.07447006800004, -27.874210062999964],
            [30.00096994200004, -27.899259937999943],
            [29.914110067000024, -27.988790063999943],
            [29.832389942000077, -27.99207006399996],
            [29.676849959000037, -27.959510042999966],
            [29.65069997200004, -27.967120034999937],
            [29.616861983000035, -28.04683801599998],
            [29.655479977000027, -28.090020025999934],
            [29.663289934000034, -28.14202004499998],
            [29.72759994200004, -28.12564993899997],
            [29.814084154000057, -28.215034868999965],
            [29.99042994200005, -28.18492993899997],
            [30.01564994200004, -28.15307993899995],
            [30.13208994300004, -28.177439938999953],
            [30.180889943000068, -28.145959938999965],
            [30.19771994300004, -28.07152006399997],
            [30.25583994300007, -28.07788993899993],
            [30.24526194300006, -27.995296938999957],
            [30.292336943000066, -27.95119393899995],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN254' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.79286999900006, -26.76962999899996],
            [21.78019000300003, -26.802529997999955],
            [21.694839999000067, -26.861240003999967],
            [21.485859996000045, -26.84154999599997],
            [21.405429996000066, -26.822099994999974],
            [21.264560000000074, -26.837539996999965],
            [21.134170004000055, -26.87375999799997],
            [21.07888000400004, -26.848509993999983],
            [21.006629995000026, -26.844310002999975],
            [20.97782999900005, -26.811509998999952],
            [20.885230000000035, -26.79726999899998],
            [20.76311000000004, -26.86647000399995],
            [20.676149993000024, -26.861250003999942],
            [20.62242999700004, -26.78624999599998],
            [20.61689000000007, -26.67731000499998],
            [20.631460004000076, -26.584049998999944],
            [20.608559999000022, -26.554059999999936],
            [20.617299993000074, -26.443990003999943],
            [20.64614999500003, -26.43507999999997],
            [20.758920000000046, -26.286989999999946],
            [20.790290002000063, -26.27141000299997],
            [20.82278000100007, -26.176500011999963],
            [20.863279998000053, -26.13267999699997],
            [20.815350005000028, -26.00589999999994],
            [20.837430002000076, -25.950749993999978],
            [20.80507000500006, -25.925289997999982],
            [20.786740001000055, -25.86060000499998],
            [20.682559996000066, -25.69452000399997],
            [20.69818999900008, -25.595110000999966],
            [20.598279999000056, -25.421739997999964],
            [20.539229998000053, -25.34453000299993],
            [20.542890003000025, -25.292579994999983],
            [20.496440001000053, -25.268979999999942],
            [20.498920002000034, -25.228359999999952],
            [20.446380001000023, -25.198970001999953],
            [20.41255000500007, -25.082719993999945],
            [20.38417000100003, -25.03430000299994],
            [20.286079995000023, -24.969570003999934],
            [20.265709997000044, -24.92851999499993],
            [20.203730004000022, -24.896479994999936],
            [20.115829993000034, -24.88088999799993],
            [20.090240003000076, -24.83282000199995],
            [19.998870004000025, -24.765860007999947],
            [20.00019001000004, -25.53155999599994],
            [19.999419999000054, -26.14263000099993],
            [19.998839989000032, -26.61870999499996],
            [20.000210001000028, -26.961010000999977],
            [20.000210001000028, -27.77401999899996],
            [20.15366935700007, -27.852560042999983],
            [20.24860000600006, -27.790569304999963],
            [20.270820618000073, -27.91489028899997],
            [20.411949158000027, -27.853340148999962],
            [20.433149338000078, -27.903619765999963],
            [20.51177024800006, -27.95871925399996],
            [20.55798912000006, -28.034820556999932],
            [20.579980727000077, -28.181939240999952],
            [20.638014890000022, -28.17485348899993],
            [20.712329863000036, -28.281499865999933],
            [20.805000008000036, -28.354829999999936],
            [20.849555002000045, -28.350969994999957],
            [20.926249993000056, -28.412699997999937],
            [21.00117999500003, -28.400709999999947],
            [21.017790001000037, -28.44387000699993],
            [21.160369004000074, -28.593195999999978],
            [21.191390003000038, -28.60766999899994],
            [21.260460005000027, -28.711480002999963],
            [21.34179999400004, -28.631930000999944],
            [21.531649999000024, -28.563430000999972],
            [21.609987000000046, -28.551045001999967],
            [21.65343999600003, -28.50586999899997],
            [21.70155999800005, -28.512470002999976],
            [21.738519995000047, -28.47525000099995],
            [21.786999999000045, -28.50508999699997],
            [21.837610093000023, -28.38274006399996],
            [21.774179568000022, -28.353029205999974],
            [21.74646999500004, -28.300830005999956],
            [21.747940063000044, -28.23625945999993],
            [21.681259155000077, -28.209600448999936],
            [21.808980942000062, -28.080049514999928],
            [21.832889557000044, -28.01063919099994],
            [21.788539886000024, -27.968240737999963],
            [21.987249374000044, -27.806890487999965],
            [22.006195183000045, -27.760420348999958],
            [21.91632080100004, -27.55381011999998],
            [21.999410629000067, -27.52479934699994],
            [21.999490738000077, -27.110249661999944],
            [21.99946000500006, -27.024790005999932],
            [21.951630007000063, -26.948810011999967],
            [21.917139989000077, -26.95868999399994],
            [21.872350003000065, -26.86014999799994],
            [21.79286999900006, -26.76962999899996],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC087' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.76977000100004, -28.12457999999998],
            [28.804749998000034, -28.019829999999956],
            [28.737960000000044, -27.976099998999928],
            [28.728190004000055, -28.022859996999955],
            [28.635209001000078, -28.030581997999946],
            [28.566879998000047, -28.01779999799993],
            [28.320419998000034, -28.05972999599993],
            [28.27760999900005, -28.119179998999982],
            [28.181635002000064, -28.108182003999957],
            [28.027990001000035, -28.176749997999934],
            [27.992710009000064, -28.23198998999993],
            [27.837580009000078, -28.22941998999994],
            [27.78866001800003, -28.24798099399993],
            [27.830580009000073, -28.283119993999946],
            [27.860509998000055, -28.361190002999933],
            [27.808520000000044, -28.458240001999968],
            [27.846040002000052, -28.47622000399997],
            [27.833885998000028, -28.55083700299997],
            [27.901350000000036, -28.555850002999932],
            [28.03999999000007, -28.624859992999973],
            [28.05985000100003, -28.72500999899995],
            [28.10165998900004, -28.76714999899997],
            [28.168510000000026, -28.705259996999928],
            [28.35281999600005, -28.700249996999958],
            [28.41324001600003, -28.62741998599995],
            [28.472089984000036, -28.605369982999946],
            [28.56841998400006, -28.608289983999953],
            [28.63148000700005, -28.582509997999978],
            [28.651800003000062, -28.496539998999936],
            [28.58237000200006, -28.449420001999954],
            [28.582755000000077, -28.39132499799996],
            [28.63140999600006, -28.34299999899997],
            [28.65504001000005, -28.251870002999965],
            [28.71572999700004, -28.235520002999976],
            [28.72764999700007, -28.155810001999953],
            [28.76977000100004, -28.12457999999998],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS192' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.534639003000052, -28.092088995999973],
            [24.465479997000045, -28.035840005999944],
            [24.46728999900006, -27.980569998999954],
            [24.40994999800006, -27.923300001999962],
            [24.360459994000053, -27.91067000299995],
            [24.452310005000072, -27.782880002999946],
            [24.408839999000065, -27.761099996999974],
            [24.44676000000004, -27.70285000399997],
            [24.40528000100005, -27.681180001999962],
            [24.111000001000036, -27.73898000099996],
            [23.644100000000037, -27.833489998999937],
            [23.580930004000038, -27.879310000999965],
            [23.834599996000065, -28.015079999999955],
            [23.79066000200004, -28.082849995999936],
            [23.891420002000075, -28.12594000599995],
            [23.81438000000003, -28.333800002999965],
            [23.828049990000068, -28.39098000299998],
            [23.767250000000047, -28.47146999299997],
            [23.75470000000007, -28.52878000399994],
            [23.908660008000027, -28.641440005999982],
            [23.949589996000043, -28.603360003999967],
            [24.117039961000046, -28.59861322499995],
            [24.200259999000025, -28.517570000999967],
            [24.33348000700005, -28.560820004999982],
            [24.408940005000034, -28.62680000499995],
            [24.521699994000073, -28.674599994999937],
            [24.54866999500007, -28.71369999899997],
            [24.608249999000066, -28.59722000599993],
            [24.606599999000025, -28.49547999699996],
            [24.688020003000076, -28.51417999599994],
            [24.726490004000027, -28.449739990999944],
            [24.70390999500006, -28.37660000099993],
            [24.733319382000047, -28.341136328999937],
            [24.697969998000076, -28.27782999699997],
            [24.63005000000004, -28.227100005999944],
            [24.656249999000067, -28.202390005999973],
            [24.547930000000065, -28.11784000299997],
            [24.534639003000052, -28.092088995999973],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC092' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.763910003000035, -26.518009998999958],
            [28.641620001000035, -26.507569995999972],
            [28.483250001000044, -26.618379999999945],
            [28.40009999700004, -26.655044999999973],
            [28.406850002000056, -26.761710001999973],
            [28.319410004000076, -26.79266999699996],
            [28.325010001000066, -26.84107000299997],
            [28.24428000000006, -26.88477999899993],
            [28.300429999000073, -26.94016000199997],
            [28.392150000000072, -26.93142000299997],
            [28.413320002000034, -27.00685999999996],
            [28.485850002000063, -26.971109997999974],
            [28.549689998000076, -27.04159999999996],
            [28.585470052000062, -27.035860016999948],
            [28.646920004000037, -26.953039996999962],
            [28.81085999800007, -27.038610003999963],
            [28.911099997000065, -27.01854000299994],
            [28.854440002000047, -26.97061999899995],
            [28.851600003000044, -26.923019998999962],
            [28.917940002000023, -26.843039999999974],
            [28.921739996000042, -26.797610000999953],
            [28.88269999700003, -26.75741000299996],
            [28.93213999900007, -26.71104999599993],
            [28.897497628000053, -26.62397787699996],
            [28.911080001000073, -26.589949995999973],
            [28.83678999700004, -26.536380003999966],
            [28.763910003000035, -26.518009998999958],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP306' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.462370000000078, -25.745369995999965],
            [26.390419998000027, -25.757639996999956],
            [26.396380002000058, -25.69288999899993],
            [26.297702521000076, -25.667500191999977],
            [26.25829238500006, -25.774949710999977],
            [26.185004758000048, -25.756553752999935],
            [26.184520003000046, -25.674620000999937],
            [26.109244997000076, -25.70210999799997],
            [26.071660002000044, -25.76797000399995],
            [26.115150782000057, -25.830554450999955],
            [26.079337389000045, -25.88272286499995],
            [26.022920708000072, -25.837961614999983],
            [25.98815800400007, -25.865067307999936],
            [25.907500000000027, -25.857660002999978],
            [25.924569998000038, -25.911579996999933],
            [25.801900001000035, -25.90005999599998],
            [25.78735000300003, -26.019609996999975],
            [25.738300003000063, -26.047219995999967],
            [25.766663003000076, -26.085166002999983],
            [25.71304000300006, -26.22758000999994],
            [25.722779997000032, -26.25692000099997],
            [25.826899999000034, -26.200359996999964],
            [25.889180003000035, -26.320510008999975],
            [25.866760003000024, -26.35990000099997],
            [25.898370000000057, -26.42296000099998],
            [25.94799000200004, -26.400409999999965],
            [26.015239996000048, -26.448830001999966],
            [26.101999997000064, -26.46177000199998],
            [26.103160003000028, -26.578400001999967],
            [26.248110002000033, -26.58731999899993],
            [26.333700006000072, -26.555159989999936],
            [26.384739999000033, -26.499899997999933],
            [26.45990999600008, -26.483499998999946],
            [26.483649998000033, -26.38641999799995],
            [26.55844078100006, -26.340418393999983],
            [26.534689999000022, -26.264190000999974],
            [26.586130001000072, -26.24519999699993],
            [26.545779997000068, -26.172699997999928],
            [26.62964000900007, -26.13613000099997],
            [26.61765100300005, -26.06486700199997],
            [26.709239998000044, -26.04755999899993],
            [26.733110001000057, -26.10156999999998],
            [26.807079999000052, -26.084029998999938],
            [26.76358000400006, -25.991090009999937],
            [26.77055000200005, -25.95232999999996],
            [26.643529998000076, -25.868000000999928],
            [26.643680003000043, -25.837984998999957],
            [26.580030006000072, -25.782679995999956],
            [26.462370000000078, -25.745369995999965],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW384' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.50627000000003, -31.706830001999947],
            [24.345990001000075, -31.714480004999984],
            [24.26825000300005, -31.76666999699995],
            [24.161589996000032, -31.740149993999978],
            [24.152459995000072, -31.78860999799997],
            [24.105380000000025, -31.906850001999942],
            [24.164199997000026, -31.902410002999943],
            [24.222410000000025, -31.95564000099995],
            [24.140870001000053, -32.01170999799996],
            [24.10967499700007, -32.084289998999964],
            [24.13552999700005, -32.12314000099997],
            [24.100129996000078, -32.16399999999993],
            [23.961149999000042, -32.20652000399997],
            [23.892299997000066, -32.25494999599994],
            [23.79785000100003, -32.19407000299998],
            [23.670450002000052, -32.23767000399994],
            [23.648870002000024, -32.29801999599994],
            [23.66514999900005, -32.344229997999946],
            [23.448959998000078, -32.323269997999944],
            [23.40985000200004, -32.38919999899997],
            [23.33305000400003, -32.35113999799995],
            [23.307329999000046, -32.39592000199997],
            [23.221610003000023, -32.42503999999997],
            [23.24447000400005, -32.513229998999975],
            [23.288155001000064, -32.55120999799993],
            [23.30130999800008, -32.65178999899996],
            [23.37862000100006, -32.82501999599998],
            [23.149329996000063, -32.766739997999935],
            [23.08935000100007, -32.79917999699995],
            [23.098009998000066, -32.87369000899997],
            [23.007439997000063, -32.872819998999944],
            [22.948750001000064, -32.950040000999934],
            [22.934090000000026, -33.02165999899995],
            [22.955310001000043, -33.073140000999956],
            [22.892269998000074, -33.14163000399998],
            [22.735740001000067, -33.39476999799996],
            [22.774430000000052, -33.41974000199997],
            [22.93478000300007, -33.42914000099995],
            [23.134800004000056, -33.38762000099996],
            [23.297124998000072, -33.38864000099994],
            [23.354879999000048, -33.441169996999975],
            [23.495619998000052, -33.44344001099995],
            [23.603999999000052, -33.49640000199997],
            [23.61687000300003, -33.570239998999966],
            [23.72229000300007, -33.61748999699995],
            [23.76049000200004, -33.60931999999997],
            [23.842809996000028, -33.65044999799994],
            [24.060740003000035, -33.69838999899997],
            [24.057160002000046, -33.72594000099997],
            [24.187689996000074, -33.764760000999956],
            [24.26291999800003, -33.74431499999997],
            [24.290979996000033, -33.71189999999996],
            [24.499620832000062, -33.77845492599994],
            [24.536700000000053, -33.72649999999993],
            [24.53532000000007, -33.66285999999997],
            [24.730740001000072, -33.62038000199993],
            [24.673050002000025, -33.57160000199997],
            [24.70185000200007, -33.51453000099997],
            [24.804405003000056, -33.53823999999997],
            [24.798039996000057, -33.483420001999946],
            [24.850391388000048, -33.37798690799997],
            [24.839540482000075, -33.35184478799994],
            [24.880290003000027, -33.257470001999934],
            [24.977809997000065, -33.25656999699993],
            [25.13477000300003, -33.295069997999974],
            [25.178260000000023, -33.251679999999965],
            [25.173969998000075, -33.119599996999966],
            [25.113699999000062, -33.11572000199993],
            [25.077050000000042, -33.00292999699997],
            [25.10160999800007, -32.951240000999974],
            [25.01616000100006, -32.91490000099998],
            [25.08741000200007, -32.87103000199994],
            [24.992540009000038, -32.800289996999936],
            [24.933970000000045, -32.78151000399998],
            [24.910831407000046, -32.74323000299995],
            [24.784050002000072, -32.72305999599996],
            [24.691030004000027, -32.69167999699994],
            [24.54287000000005, -32.71666999799993],
            [24.47182000400005, -32.76540999799994],
            [24.41367999600004, -32.73698000299993],
            [24.45657920800005, -32.64081954999995],
            [24.545329996000078, -32.56204000199995],
            [24.589819996000074, -32.44383999799993],
            [24.76141000100006, -32.377580000999956],
            [24.795180001000062, -32.40922999899993],
            [24.86018000200005, -32.32967999999994],
            [24.93173000400003, -32.28374999699997],
            [24.949610000000064, -32.241180001999965],
            [24.90401999900007, -32.221940003999975],
            [24.915539999000032, -32.17211999799997],
            [24.967119999000033, -32.107509998999944],
            [24.938049999000043, -32.053260000999956],
            [24.95068999700004, -32.00726999999995],
            [24.92448999900006, -31.94159000199994],
            [24.939119998000024, -31.90504999899997],
            [24.899250004000066, -31.837270003999947],
            [24.85562999900003, -31.83488499799995],
            [24.80192999800005, -31.78496999799995],
            [24.733469998000032, -31.787290002999953],
            [24.704399998000042, -31.744279999999947],
            [24.616460002000053, -31.726169996999943],
            [24.550710001000027, -31.761169998999947],
            [24.50627000000003, -31.706830001999947],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC101' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.118499962000044, -25.10752004099993],
            [29.070663960000047, -25.06546604199997],
            [28.971709970000063, -25.070179966999945],
            [28.89165997200007, -24.955459962999953],
            [28.924069974000076, -24.901529977999928],
            [28.837390001000074, -24.91600999999997],
            [28.759379997000053, -24.91135000099996],
            [28.713779997000074, -24.95362000199998],
            [28.605540003000044, -25.003799997999977],
            [28.634289996000064, -25.058240001999934],
            [28.473739998000042, -25.08931999899994],
            [28.44297000100005, -25.128989988999933],
            [28.379259999000055, -25.155299998999965],
            [28.411020001000054, -25.20482999999996],
            [28.461599997000064, -25.20147999699998],
            [28.536829999000076, -25.152549990999944],
            [28.651569996000035, -25.142899996999972],
            [28.74458899700005, -25.10961200099996],
            [28.77541000000008, -25.18377000299995],
            [28.739590001000067, -25.28853000099997],
            [28.79100999800005, -25.328339997999933],
            [28.899134004000075, -25.235077002999958],
            [29.032259983000074, -25.249330019999945],
            [29.042509981000023, -25.140500019999934],
            [29.118499962000044, -25.10752004099993],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP316' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.957625609000047, -29.78094086699997],
            [29.91852293100004, -29.767480744999943],
            [29.70281971600008, -29.63574344799997],
            [29.592859925000027, -29.577360029999966],
            [29.493708880000042, -29.586860324999975],
            [29.399520874000075, -29.524938582999937],
            [29.299845521000066, -29.49893551899993],
            [29.31973994200007, -29.581399939999983],
            [29.279189942000073, -29.644739939999965],
            [29.183429942000032, -29.66821993999997],
            [29.145239942000046, -29.71640993999995],
            [29.131659942000056, -29.825630064999928],
            [29.16882494200007, -29.912705064999955],
            [29.22021994200003, -29.905749939999964],
            [29.277639942000064, -29.942049939999947],
            [29.357379942000023, -29.93955993999998],
            [29.417289942000025, -29.969134939999947],
            [29.479739942000037, -29.965269939999928],
            [29.50890994200006, -30.00181993999996],
            [29.632879942000045, -30.033889939999938],
            [29.673859942000036, -30.079409939999948],
            [29.77227994200007, -30.061450064999974],
            [29.828389942000058, -30.073039939999944],
            [29.852376942000035, -30.117639940999936],
            [29.928449942000043, -30.112059940999984],
            [29.957788942000036, -30.07326293999995],
            [30.043649048000077, -30.056479173999946],
            [30.105759943000066, -29.97464993999995],
            [30.037049942000067, -29.867080064999982],
            [30.045361357000047, -29.829961907999973],
            [29.957625609000047, -29.78094086699997],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN436' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.25076000100006, -26.824759995999955],
            [30.13794000100006, -26.834820003999937],
            [30.111160004000055, -26.736320001999957],
            [29.994810001000076, -26.69772000399996],
            [29.963759999000047, -26.770670001999974],
            [29.842960000000062, -26.799460003999968],
            [29.798540012000046, -26.848449997999978],
            [29.750240004000034, -26.83184999499997],
            [29.657430000000033, -26.86930000199993],
            [29.665229999000076, -26.943229998999982],
            [29.620230004000064, -27.074550002999956],
            [29.572769996000034, -27.105379995999954],
            [29.55040000300005, -27.18561000099993],
            [29.49258000100008, -27.19468999299994],
            [29.418859999000063, -27.254519999999957],
            [29.618910002000064, -27.506020001999957],
            [29.704269999000076, -27.489400001999968],
            [29.699290002000055, -27.450339998999937],
            [29.75867998600006, -27.442570014999944],
            [29.810689987000046, -27.444769979999933],
            [29.840189999000074, -27.37898998099996],
            [29.89913997700006, -27.385490027999936],
            [29.917219986000077, -27.354409982999982],
            [30.016241986000068, -27.39758901999994],
            [30.068289979000042, -27.36587001999993],
            [30.15023998600003, -27.392249985999968],
            [30.19807998400006, -27.355180022999946],
            [30.279930016000037, -27.368589975999953],
            [30.28248998600003, -27.314439981999953],
            [30.367609988000027, -27.267429979999974],
            [30.426449989000048, -27.269830018999983],
            [30.448269998000058, -27.32773993799998],
            [30.527049997000063, -27.315749989999972],
            [30.50226000300006, -27.283549997999955],
            [30.566910003000032, -27.16951000299997],
            [30.499740002000067, -27.170890000999975],
            [30.44848999900006, -27.207199997999965],
            [30.328069995000078, -27.183920000999933],
            [30.31546000000003, -27.146259999999984],
            [30.380580011000063, -27.11703999499997],
            [30.39947999900005, -27.021520000999942],
            [30.360678009000026, -26.97004899999996],
            [30.295749998000076, -27.016160000999946],
            [30.24370000300007, -26.85984999599998],
            [30.25076000100006, -26.824759995999955],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP304' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.107040003000066, -33.54113999699996],
            [19.086350002000074, -33.43106999699995],
            [19.083970000000022, -33.319609999999955],
            [19.05773000100004, -33.200140000999966],
            [19.072419997000054, -33.127659997999956],
            [18.98010000000005, -33.15210999999994],
            [18.939005000000066, -33.19638999799997],
            [18.945750002000068, -33.25269999899996],
            [18.997350006000033, -33.307909999999936],
            [18.992770001000054, -33.35478999999998],
            [18.93405000200005, -33.49215000899994],
            [18.938090001000035, -33.545999998999946],
            [18.839310002000047, -33.57763000099993],
            [18.787539997000067, -33.637630000999934],
            [18.80945999900007, -33.74078000199995],
            [18.79257000100006, -33.81921000199998],
            [18.89678000300006, -33.79335999699998],
            [18.895429998000054, -33.84212999999994],
            [18.93153999900005, -33.87908000199997],
            [18.981979997000053, -33.85289999999998],
            [19.094160008000074, -33.831670000999964],
            [19.164570000000026, -33.868519995999975],
            [19.21404900600004, -33.857067995999955],
            [19.183989998000072, -33.715390001999936],
            [19.101960000000076, -33.606760005999945],
            [19.107040003000066, -33.54113999699996],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC023' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.14086502400005, -27.362659979999933],
            [31.100959988000056, -27.335760020999942],
            [30.95578998900004, -27.35970998299996],
            [30.922159988000033, -27.305049981999957],
            [30.829679989000056, -27.350149981999948],
            [30.706799990000036, -27.283289986999932],
            [30.587739989000056, -27.322949980999965],
            [30.527049997000063, -27.315749989999972],
            [30.448269998000058, -27.32773993799998],
            [30.50042994300003, -27.390550062999978],
            [30.509639943000025, -27.45658993799998],
            [30.58674994300003, -27.499829937999948],
            [30.592539943000077, -27.532498062999935],
            [30.66755994300007, -27.644890062999934],
            [30.66423994300004, -27.679150062999952],
            [30.798539943000037, -27.663330062999933],
            [30.95817994300006, -27.618759937999982],
            [31.048419943000056, -27.62223993799995],
            [31.032560068000066, -27.52104006299993],
            [31.087359943000024, -27.519769937999968],
            [31.189004478000072, -27.454314525999962],
            [31.14086502400005, -27.362659979999933],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN261' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.50305499700005, -26.063800002999983],
            [28.468670001000078, -26.07808999899993],
            [28.44442000400005, -25.99114999899996],
            [28.407189997000046, -25.924090001999957],
            [28.352380004000054, -25.954599997999935],
            [28.319479002000037, -25.913720000999945],
            [28.181050000000027, -25.91954999799998],
            [28.158183001000054, -26.038249999999948],
            [28.184829997000065, -26.089259998999978],
            [28.112739996000073, -26.167779997999958],
            [28.122851998000044, -26.247929002999967],
            [28.070560003000026, -26.272619997999982],
            [28.067101999000045, -26.34194000399998],
            [28.076060002000077, -26.415370002999964],
            [28.22039999900005, -26.43628000399997],
            [28.271099998000068, -26.41369999999995],
            [28.27401000100008, -26.358679997999957],
            [28.370294998000077, -26.393630996999946],
            [28.45023000200007, -26.440749996999955],
            [28.49908000000005, -26.43930000199998],
            [28.517879997000023, -26.361959997999975],
            [28.51363000400005, -26.22143000099993],
            [28.52715000300003, -26.178740003999962],
            [28.49050000400007, -26.126392000999942],
            [28.50305499700005, -26.063800002999983],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'EKU' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.978949982000074, -25.09211998199993],
            [29.905889985000044, -25.047489970999948],
            [29.959419971000045, -24.986609966999936],
            [29.975439960000074, -24.935349962999965],
            [29.90509600200005, -24.93239899899993],
            [29.88128794800008, -24.977264050999963],
            [29.782550021000077, -24.978789983999945],
            [29.71831994300004, -25.000330059999953],
            [29.685049943000024, -24.932350059999976],
            [29.63672994600006, -24.95306005699996],
            [29.63076994200003, -24.988460060999955],
            [29.514352942000073, -24.99355006099995],
            [29.469859942000028, -24.96961006099997],
            [29.431599942000048, -25.03925993599995],
            [29.358789942000044, -25.07694006099996],
            [29.264749942000037, -25.09795006099995],
            [29.20069994200003, -25.05465006099996],
            [29.155010067000035, -25.10709993599994],
            [29.118499962000044, -25.10752004099993],
            [29.042509981000023, -25.140500019999934],
            [29.032259983000074, -25.249330019999945],
            [29.090169969000044, -25.289399965999962],
            [29.166959960000042, -25.30336004199995],
            [29.16411997000006, -25.354480029999934],
            [29.207338979000042, -25.41457202099997],
            [29.264433960000076, -25.37546304199998],
            [29.342129973000056, -25.37307003199993],
            [29.36245997900005, -25.407110020999937],
            [29.51882997900003, -25.42279002199996],
            [29.67385997200006, -25.37216002899993],
            [29.77023997200007, -25.401530028999957],
            [29.840299972000025, -25.38632003099997],
            [29.88791996200007, -25.338579954999943],
            [29.990589983000064, -25.33825002599997],
            [30.009839971000076, -25.231280030999983],
            [30.005409971000063, -25.14438003099997],
            [29.978949982000074, -25.09211998199993],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM472' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.560369998000056, -30.655260001999977],
            [28.540550008000025, -30.588989998999978],
            [28.569840000000056, -30.49629000599998],
            [28.480840004000072, -30.422299996999982],
            [28.268770003000043, -30.37372999699994],
            [28.257650002000048, -30.416380000999936],
            [28.17955999700007, -30.438919987999952],
            [28.15558999600006, -30.471829990999936],
            [28.17735000400006, -30.522410002999948],
            [28.15073999200007, -30.58429999699996],
            [28.114130001000035, -30.59903000199995],
            [28.117680000000064, -30.668669996999938],
            [28.162290002000077, -30.69279000299997],
            [28.12042000200006, -30.778169995999974],
            [28.132130000000075, -30.83530000199994],
            [28.051139997000064, -30.974329997999973],
            [28.063939998000023, -31.012569997999947],
            [27.981575001000067, -31.07651500099996],
            [27.985490002000063, -31.15199000299998],
            [27.931252005000033, -31.234014000999935],
            [27.988519991000032, -31.24040999999994],
            [28.08077000000003, -31.32375000199994],
            [28.121219993000068, -31.30012000399995],
            [28.216159997000034, -31.31280000299995],
            [28.260700004000057, -31.37043999699995],
            [28.29376999300007, -31.416699996999967],
            [28.38126500100003, -31.48000000099995],
            [28.38231999900006, -31.48055000499994],
            [28.443980002000046, -31.38646999799994],
            [28.49925999800007, -31.33262999899995],
            [28.45598999400005, -31.306839998999976],
            [28.497800006000034, -31.250270003999958],
            [28.61938999800003, -31.236869998999964],
            [28.682269998000038, -31.179259999999942],
            [28.67548000000005, -31.134970003999968],
            [28.600980010000058, -31.088230001999932],
            [28.53957999900007, -31.090389995999942],
            [28.52592000100003, -31.048859997999955],
            [28.57724999800007, -30.992910002999963],
            [28.591649998000037, -30.93111000099998],
            [28.63861000000003, -30.920929998999952],
            [28.641113076000067, -30.772916348999956],
            [28.54985000100004, -30.69243000399996],
            [28.560369998000056, -30.655260001999977],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC141' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.448269998000058, -27.32773993799998],
            [30.426449989000048, -27.269830018999983],
            [30.367609988000027, -27.267429979999974],
            [30.28248998600003, -27.314439981999953],
            [30.279930016000037, -27.368589975999953],
            [30.19807998400006, -27.355180022999946],
            [30.15023998600003, -27.392249985999968],
            [30.068289979000042, -27.36587001999993],
            [30.016241986000068, -27.39758901999994],
            [29.917219986000077, -27.354409982999982],
            [29.89913997700006, -27.385490027999936],
            [29.924879942000075, -27.53887993799998],
            [29.920159942000055, -27.57922993799997],
            [30.081719943000053, -27.724890062999975],
            [30.116269943000077, -27.707799937999937],
            [30.21058994300006, -27.732319937999932],
            [30.208594943000037, -27.788359937999928],
            [30.280709943000033, -27.81498993799994],
            [30.30680006800003, -27.891919937999944],
            [30.292336943000066, -27.95119393899995],
            [30.386210068000025, -27.93055993799993],
            [30.43239094300003, -27.97368006399995],
            [30.56970006800003, -28.008950063999976],
            [30.60214006800004, -27.93359993799993],
            [30.581389943000033, -27.888569937999932],
            [30.629419943000073, -27.810289937999983],
            [30.62698994300007, -27.739739937999957],
            [30.691649943000073, -27.71553993799995],
            [30.66423994300004, -27.679150062999952],
            [30.66755994300007, -27.644890062999934],
            [30.592539943000077, -27.532498062999935],
            [30.58674994300003, -27.499829937999948],
            [30.509639943000025, -27.45658993799998],
            [30.50042994300003, -27.390550062999978],
            [30.448269998000058, -27.32773993799998],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN253' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.449239999000042, -25.34495999799998],
            [30.40138999800007, -25.38083999899993],
            [30.417800003000025, -25.42350000199997],
            [30.35099000100007, -25.492479996999975],
            [30.30141999800003, -25.444979995999972],
            [30.22945999800004, -25.432410000999937],
            [30.251709997000034, -25.357287002999954],
            [30.20557999700003, -25.35681999999997],
            [30.190750003000062, -25.275810001999957],
            [30.143230006000067, -25.245810008999968],
            [30.083440000000053, -25.294079998999962],
            [30.025460004000024, -25.367719999999963],
            [29.990589983000064, -25.33825002599997],
            [29.88791996200007, -25.338579954999943],
            [29.840299972000025, -25.38632003099997],
            [29.77023997200007, -25.401530028999957],
            [29.67385997200006, -25.37216002899993],
            [29.51882997900003, -25.42279002199996],
            [29.51146999900004, -25.45881000299994],
            [29.58592999600006, -25.581449997999982],
            [29.713110003000054, -25.572179999999946],
            [29.706420003000062, -25.61342000199994],
            [29.776670000000024, -25.619829996999954],
            [29.785180000000025, -25.674260001999983],
            [29.825900000000047, -25.701420002999953],
            [29.80094000300005, -25.84876000199995],
            [29.86179000100003, -25.862450002999935],
            [29.943750004000037, -25.905660000999944],
            [30.086688003000063, -25.860293997999975],
            [30.21375000200004, -25.804019998999934],
            [30.270399999000063, -25.825370000999953],
            [30.243440002000057, -25.87211000999997],
            [30.299050002000058, -25.92637999699997],
            [30.331109998000045, -25.88054000099993],
            [30.381149996000033, -25.886899995999954],
            [30.61119000900004, -25.719020000999933],
            [30.64662999500007, -25.71242000899997],
            [30.665619998000068, -25.672980000999928],
            [30.593709997000076, -25.554130001999965],
            [30.534120003000055, -25.53600000299997],
            [30.565345999000044, -25.481235995999953],
            [30.48011000200006, -25.45239000199996],
            [30.442429997000033, -25.38082000299994],
            [30.449239999000042, -25.34495999799998],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP314' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.437136002000045, -31.676665999999955],
            [27.43424000400006, -31.596729997999944],
            [27.482256434000078, -31.58604907299997],
            [27.474440000000072, -31.481229999999982],
            [27.59864000300007, -31.443719990999966],
            [27.57744999700003, -31.38920000199994],
            [27.62412000300003, -31.224029996999946],
            [27.569559997000056, -31.209089997999968],
            [27.45131000200007, -31.25719000199996],
            [27.44295999700006, -31.377410001999976],
            [27.408460002000027, -31.418459998999936],
            [27.275999996000053, -31.339759998999966],
            [27.175179998000033, -31.367779996999957],
            [27.130789996000033, -31.42660000099994],
            [27.047469999000043, -31.34454999899998],
            [27.017140002000076, -31.36102499599997],
            [26.93464499600003, -31.343969998999967],
            [26.882279998000058, -31.378019995999978],
            [26.846869999000035, -31.435850002999928],
            [26.84664999900008, -31.507879998999954],
            [26.891713997000068, -31.543270998999958],
            [26.86690999700005, -31.584949996999967],
            [26.769649996000055, -31.666820007999945],
            [26.804620003000025, -31.706719996999936],
            [26.848800002000075, -31.691829996999957],
            [26.958260001000042, -31.78101000099997],
            [26.980839996000043, -31.82716000499994],
            [27.10595999900005, -31.915559996999946],
            [27.208040002000075, -31.96216999799998],
            [27.27276160400004, -31.933650016999934],
            [27.328849999000056, -31.890879996999956],
            [27.407873005000056, -31.895912003999968],
            [27.434009997000032, -31.80967900299993],
            [27.39869999600006, -31.72566999999998],
            [27.437136002000045, -31.676665999999955],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC136' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.289129996000042, -25.74535999799997],
            [29.24252000300004, -25.708759997999948],
            [29.117270000000076, -25.656499999999937],
            [29.04154999800005, -25.70803000099994],
            [29.00829000300007, -25.66057000099994],
            [28.968830000000025, -25.67330999799998],
            [28.981310002000043, -25.74254000199994],
            [28.938169999000024, -25.823284995999927],
            [28.94107000200006, -25.877290002999928],
            [29.02670999700007, -25.916650000999937],
            [28.95366000100006, -25.97478000199993],
            [28.92492999600006, -26.023830001999954],
            [28.919584000000043, -26.100004998999964],
            [28.99935000100004, -26.120870002999936],
            [29.02028999600003, -26.193169997999973],
            [28.984219996000036, -26.23693000999998],
            [29.033262001000026, -26.225760002999948],
            [29.06580000400004, -26.31429000299994],
            [29.12359000200007, -26.38428999699994],
            [29.173069997000027, -26.34888999599997],
            [29.260619999000028, -26.36236000399998],
            [29.335469998000065, -26.348330001999955],
            [29.366572999000027, -26.29210799699996],
            [29.340690000000052, -26.245080001999952],
            [29.387970000000053, -26.20490000099994],
            [29.391039997000064, -26.14419000199996],
            [29.333670003000066, -26.095220001999962],
            [29.40244799900006, -26.063212007999937],
            [29.329759997000053, -25.986920002999966],
            [29.36075000200003, -25.96000999699993],
            [29.327979998000046, -25.791719995999983],
            [29.289129996000042, -25.74535999799997],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP312' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.887210001000028, -26.526250000999937],
            [27.821689998000068, -26.48487999799994],
            [27.759710004000056, -26.48386998799998],
            [27.76128999900004, -26.419150000999934],
            [27.709669998000038, -26.45467000399998],
            [27.675980000000038, -26.52434999999997],
            [27.667929998000034, -26.610549996999964],
            [27.579600001000074, -26.60752999899995],
            [27.569090002000053, -26.647160003999943],
            [27.590429997000058, -26.73836000299997],
            [27.661369998000055, -26.773190002999968],
            [27.716306001000078, -26.761676999999963],
            [27.873640003000048, -26.747630000999948],
            [27.940960001000064, -26.675899998999967],
            [28.000489998000035, -26.703320000999952],
            [27.962234996000063, -26.644136996999976],
            [27.983020000000067, -26.555829996999933],
            [27.887210001000028, -26.526250000999937],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'GT421' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.84207999800003, -30.195130001999928],
            [23.776339997000036, -30.103039999999964],
            [23.64245999800005, -30.14434999799994],
            [23.497719998000036, -30.058619999999962],
            [23.352890002000038, -30.066130000999976],
            [23.239449998000055, -29.901959990999956],
            [23.183677033000038, -29.938064673999975],
            [23.206658358000027, -30.039386014999934],
            [23.182016000000033, -30.094968995999977],
            [23.113139998000065, -30.15642999199997],
            [22.982039997000072, -30.238129999999956],
            [22.959189998000056, -30.27322998699998],
            [22.997989996000058, -30.377350010999976],
            [23.06678000100004, -30.391630001999943],
            [23.133210000000076, -30.381469997999943],
            [23.230259997000076, -30.39873000199998],
            [23.224300001000074, -30.488249998999947],
            [23.242530001000034, -30.54131999699996],
            [23.094329997000045, -30.56744999899996],
            [23.064460002000033, -30.65116999299994],
            [23.01329200400005, -30.658792997999967],
            [23.05554999800006, -30.728529997999942],
            [23.067449999000075, -30.799329997999962],
            [23.109370006000063, -30.828209998999967],
            [23.164820001000066, -30.86259999799995],
            [23.22530000300003, -30.95372999799997],
            [23.325510000000065, -30.95398999599996],
            [23.40172999200007, -31.034099999999967],
            [23.513484996000045, -30.950600004999956],
            [23.556749640000078, -31.007575371999962],
            [23.599274344000037, -30.942878657999984],
            [23.65829862000004, -30.89690928799996],
            [23.70332011100004, -30.941973490999942],
            [23.76169297900003, -30.905429159999983],
            [23.81402336000008, -30.906850806999955],
            [23.86042999400007, -30.864940004999937],
            [23.987642298000026, -30.910912614999972],
            [23.950628506000044, -30.97168026299994],
            [24.054772184000058, -30.97775319899995],
            [24.13678764200006, -31.042860877999942],
            [24.12350000200007, -31.10532999999998],
            [24.152299998000046, -31.18035000599997],
            [24.23489000400008, -31.21799999999996],
            [24.265629998000065, -31.324039997999932],
            [24.387529998000048, -31.386800001999973],
            [24.400949998000044, -31.443599991999974],
            [24.445739999000068, -31.47863999799995],
            [24.478780001000075, -31.43174999699994],
            [24.56719000100003, -31.41864000099997],
            [24.563969996000026, -31.377370001999964],
            [24.661509998000042, -31.287819997999975],
            [24.75150999300007, -31.140319998999928],
            [24.750860002000024, -31.095959996999966],
            [24.82237615400004, -31.04039404699995],
            [24.847270000000037, -30.99189000399997],
            [24.802620001000037, -30.972409995999953],
            [24.757820000000038, -30.870549997999944],
            [24.703809999000043, -30.828499995999948],
            [24.630346748000022, -30.836215873999947],
            [24.644425397000077, -30.751596894999977],
            [24.58666000100004, -30.70258999699996],
            [24.54078180600004, -30.731442956999956],
            [24.452420000000075, -30.658369997999955],
            [24.274300003000064, -30.583859995999944],
            [24.252580000000023, -30.51215999799996],
            [24.277617081000074, -30.448922981999942],
            [24.10826000000003, -30.37306999799995],
            [24.07665000000003, -30.33099000599998],
            [24.018870006000043, -30.339969998999948],
            [23.93169000000006, -30.278179997999928],
            [23.956340003000037, -30.23662000199994],
            [23.84207999800003, -30.195130001999928],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC073' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.56970006800003, -28.008950063999976],
            [30.43239094300003, -27.97368006399995],
            [30.386210068000025, -27.93055993799993],
            [30.292336943000066, -27.95119393899995],
            [30.24526194300006, -27.995296938999957],
            [30.25583994300007, -28.07788993899993],
            [30.19771994300004, -28.07152006399997],
            [30.180889943000068, -28.145959938999965],
            [30.13208994300004, -28.177439938999953],
            [30.01564994200004, -28.15307993899995],
            [29.99042994200005, -28.18492993899997],
            [29.97679394200003, -28.239587938999932],
            [30.06540994200003, -28.305130063999968],
            [30.07547994300006, -28.357839938999973],
            [30.135639943000058, -28.340529938999964],
            [30.178124943000057, -28.43966293899996],
            [30.23359494300007, -28.408709938999948],
            [30.35194994300008, -28.266459938999958],
            [30.44915994300004, -28.28189006399998],
            [30.505729943000063, -28.262689938999983],
            [30.541949943000077, -28.198219938999955],
            [30.51365994300005, -28.171299938999937],
            [30.56970006800003, -28.008950063999976],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN241' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.38126500100003, -31.48000000099995],
            [28.29376999300007, -31.416699996999967],
            [28.260700004000057, -31.37043999699995],
            [28.156989999000075, -31.40189999699993],
            [28.04843999700006, -31.50576999599997],
            [27.97181999000003, -31.537730001999932],
            [27.860509998000055, -31.534439995999946],
            [27.746920001000035, -31.556189996999933],
            [27.725629997000055, -31.60791000399996],
            [27.758459997000045, -31.65649000899998],
            [27.801010004000034, -31.697799998999983],
            [27.80001999800004, -31.743580005999945],
            [27.879180003000045, -31.81473000099993],
            [28.016820001000042, -31.87285000399993],
            [27.98333358800005, -31.98428535499994],
            [28.010034442000062, -32.03639166599993],
            [28.01884885800007, -32.043181292999975],
            [28.19468000300003, -31.96641000099993],
            [28.263330001000043, -31.791320002999953],
            [28.351969998000072, -31.828649999999982],
            [28.32386000100007, -31.790759999999977],
            [28.344140003000064, -31.716959995999957],
            [28.312089998000033, -31.688650002999964],
            [28.309010002000036, -31.618319996999958],
            [28.38110000300003, -31.558009996999942],
            [28.38126500100003, -31.48000000099995],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC137' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.846869999000035, -31.435850002999928],
            [26.743230006000033, -31.417259999999942],
            [26.633320001000072, -31.455249996999953],
            [26.61266000300003, -31.371979990999932],
            [26.66367000200006, -31.37255999799993],
            [26.666680002000078, -31.32136000099996],
            [26.70870000000008, -31.27709999999996],
            [26.687380001000065, -31.192590000999928],
            [26.628740004000065, -31.22938999799993],
            [26.52102999400006, -31.207279996999944],
            [26.42713000200007, -31.222999998999967],
            [26.426300000000026, -31.184740002999945],
            [26.237009998000076, -31.224320000999967],
            [26.20341999900006, -31.27723999899996],
            [26.13459000100005, -31.251529999999946],
            [26.121829993000063, -31.293670007999935],
            [26.033190004000062, -31.332179999999937],
            [25.965890002000037, -31.47676999999993],
            [25.769259997000063, -31.444140002999973],
            [25.706090002000053, -31.475119993999954],
            [25.66567000300006, -31.460999998999966],
            [25.589330002000054, -31.48531000199995],
            [25.61735999700005, -31.577260000999956],
            [25.50582000600008, -31.548869998999976],
            [25.52832999900005, -31.613749997999946],
            [25.454490001000067, -31.684599997999953],
            [25.41488000100003, -31.67424999499997],
            [25.36039999600007, -31.714490001999934],
            [25.54142000300004, -31.767429995999976],
            [25.563680000000033, -31.80290999899995],
            [25.634099999000057, -31.839609996999968],
            [25.640569999000036, -31.90269000099994],
            [25.723179997000045, -31.86365000099994],
            [25.762169997000058, -31.897900000999982],
            [25.850160000000074, -31.908890000999975],
            [25.99953000100004, -32.005000001999974],
            [26.076000003000047, -32.11261999599998],
            [26.20688999600003, -32.16447000299996],
            [26.191329997000025, -32.285230000999945],
            [26.20252000100004, -32.33127000099995],
            [26.30962000100004, -32.37600999599994],
            [26.53369001200008, -32.36017999799998],
            [26.53923999400007, -32.38596500299997],
            [26.662449998000056, -32.42792999899996],
            [26.735072999000067, -32.39080599799996],
            [26.711760000000027, -32.34001999999998],
            [26.775780000000054, -32.333279999999945],
            [26.844930000000033, -32.27038999999996],
            [26.892960000000073, -32.27160999999995],
            [26.970180000000028, -32.193839999999966],
            [27.010920000000056, -32.22249999999997],
            [27.16072999900007, -32.23849999799995],
            [27.243620002000057, -32.28194000299993],
            [27.347779997000032, -32.311730000999944],
            [27.386880002000055, -32.358830001999934],
            [27.451350003000073, -32.35220999699993],
            [27.492120002000036, -32.30663000199996],
            [27.507879998000078, -32.230749996999975],
            [27.48234000000008, -32.16280000099994],
            [27.440119998000057, -32.18384999999995],
            [27.39748000000003, -32.136169999999936],
            [27.41182000300006, -32.09891999799993],
            [27.32141479200004, -31.97579112799997],
            [27.27276160400004, -31.933650016999934],
            [27.208040002000075, -31.96216999799998],
            [27.10595999900005, -31.915559996999946],
            [26.980839996000043, -31.82716000499994],
            [26.958260001000042, -31.78101000099997],
            [26.848800002000075, -31.691829996999957],
            [26.804620003000025, -31.706719996999936],
            [26.769649996000055, -31.666820007999945],
            [26.86690999700005, -31.584949996999967],
            [26.891713997000068, -31.543270998999958],
            [26.84664999900008, -31.507879998999954],
            [26.846869999000035, -31.435850002999928],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC139' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.63672994600006, -24.95306005699996],
            [29.744279943000038, -24.791230060999965],
            [29.63471994400004, -24.80052005999994],
            [29.478030018000027, -24.763619981999966],
            [29.434069945000033, -24.709770056999957],
            [29.470755001000043, -24.640615002999937],
            [29.400489983000057, -24.608530019999932],
            [29.369900037000036, -24.663356028999942],
            [29.247380000000078, -24.71360999999996],
            [29.275580000000048, -24.791369999999972],
            [29.229779971000028, -24.81264996599998],
            [29.183149963000062, -24.939920040999937],
            [29.082879972000057, -24.981209941999964],
            [29.05592998000003, -24.912259990999928],
            [28.924069974000076, -24.901529977999928],
            [28.89165997200007, -24.955459962999953],
            [28.971709970000063, -25.070179966999945],
            [29.070663960000047, -25.06546604199997],
            [29.118499962000044, -25.10752004099993],
            [29.155010067000035, -25.10709993599994],
            [29.20069994200003, -25.05465006099996],
            [29.264749942000037, -25.09795006099995],
            [29.358789942000044, -25.07694006099996],
            [29.431599942000048, -25.03925993599995],
            [29.469859942000028, -24.96961006099997],
            [29.514352942000073, -24.99355006099995],
            [29.63076994200003, -24.988460060999955],
            [29.63672994600006, -24.95306005699996],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM471' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.185754944000053, -29.57178493999993],
            [31.18312994400003, -29.528020064999964],
            [31.135839943000065, -29.501130064999984],
            [31.094409943000073, -29.538089939999963],
            [30.84250994300004, -29.62561993999998],
            [30.793219943000054, -29.57549993999993],
            [30.727179943000067, -29.57093993999996],
            [30.673752943000068, -29.619902064999962],
            [30.622169943000074, -29.668349939999928],
            [30.58375092400007, -29.654322830999945],
            [30.569389943000033, -29.731649939999954],
            [30.575999943000056, -29.831499939999958],
            [30.675250068000025, -29.92222093999993],
            [30.59611407400007, -30.12389829899996],
            [30.691450991000067, -30.149606948999974],
            [30.69243194300003, -30.19854794099996],
            [30.76486794300007, -30.26878394099998],
            [30.898679943000047, -30.041720064999936],
            [30.968519943000047, -29.982329939999943],
            [31.061419943000033, -29.87597993999998],
            [31.038409943000033, -29.823229939999976],
            [31.128019943000027, -29.65357993999993],
            [31.185754944000053, -29.57178493999993],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'ETH' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.01494999700003, -27.32367000599993],
            [23.936559998000064, -27.410819997999965],
            [23.81460000000004, -27.478799993999928],
            [23.767069999000057, -27.55323999899997],
            [23.671480002000067, -27.516129999999976],
            [23.610819999000057, -27.472440004999953],
            [23.56404368500006, -27.33500288299996],
            [23.52745111200005, -27.340882491999935],
            [23.476216212000054, -27.29184161099994],
            [23.394121518000077, -27.29911970099994],
            [23.17809199800007, -27.135831004999943],
            [23.11690999800004, -27.20108000099998],
            [23.132359992000033, -27.236959997999975],
            [23.27180256200006, -27.378535727999974],
            [23.313619998000036, -27.351909999999975],
            [23.372723996000047, -27.464460996999946],
            [23.307429994000074, -27.514669999999967],
            [23.264870004000045, -27.519079998999928],
            [23.274100003000058, -27.66133999799996],
            [23.28857000200003, -27.71421000299995],
            [23.16024999900003, -27.728569997999955],
            [23.085480007000058, -27.844829997999966],
            [23.097749994000026, -27.888769999999965],
            [23.11221000200004, -27.962780004999956],
            [23.30436000700007, -27.936529999999948],
            [23.362025980000055, -27.942167130999962],
            [23.416550002000065, -27.915849997999942],
            [23.443899998000063, -27.955179999999928],
            [23.580930004000038, -27.879310000999965],
            [23.644100000000037, -27.833489998999937],
            [24.111000001000036, -27.73898000099996],
            [24.093339996000054, -27.704910005999977],
            [24.118620004000036, -27.621739997999953],
            [24.050610001000052, -27.602729996999983],
            [24.05751000300006, -27.429419999999936],
            [24.08627000100006, -27.35349000399998],
            [24.01494999700003, -27.32367000599993],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC452' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.097749994000026, -27.888769999999965],
            [23.085480007000058, -27.844829997999966],
            [23.16024999900003, -27.728569997999955],
            [23.28857000200003, -27.71421000299995],
            [23.274100003000058, -27.66133999799996],
            [23.264870004000045, -27.519079998999928],
            [23.307429994000074, -27.514669999999967],
            [23.372723996000047, -27.464460996999946],
            [23.313619998000036, -27.351909999999975],
            [23.27180256200006, -27.378535727999974],
            [23.21585000400006, -27.41918999799998],
            [23.122990006000066, -27.40646999599994],
            [22.995509995000077, -27.40740999999997],
            [22.837420001000055, -27.39042000099994],
            [22.84454000100004, -27.543719993999957],
            [22.714579996000055, -27.549159994999968],
            [22.70051000600006, -27.687049999999942],
            [22.80168999700004, -27.792869998999947],
            [22.819319996000047, -27.831609998999966],
            [22.73954999500006, -27.850730004999946],
            [22.727434177000077, -27.930350277999935],
            [22.642420000000072, -27.93971999799993],
            [22.674030001000062, -27.984360004999928],
            [22.772809996000035, -27.98414000599996],
            [22.933089995000046, -27.887949998999943],
            [22.991550002000054, -27.898040013999946],
            [23.023049999000023, -27.857989999999972],
            [23.097749994000026, -27.888769999999965],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC453' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.61687000300003, -33.570239998999966],
            [23.603999999000052, -33.49640000199997],
            [23.495619998000052, -33.44344001099995],
            [23.354879999000048, -33.441169996999975],
            [23.297124998000072, -33.38864000099994],
            [23.134800004000056, -33.38762000099996],
            [22.93478000300007, -33.42914000099995],
            [22.774430000000052, -33.41974000199997],
            [22.728480000000047, -33.45415999599993],
            [22.716079999000044, -33.531680000999984],
            [22.755659997000066, -33.64072999299998],
            [22.588689998000063, -33.636669997999945],
            [22.371800003000033, -33.659389991999944],
            [22.345270000000028, -33.72525000599995],
            [22.36878000400003, -33.792810000999964],
            [22.233749998000064, -33.888240003999954],
            [22.26786000000004, -33.925020003999975],
            [22.27986000100003, -34.02149000299994],
            [22.35457000100007, -34.05442999999997],
            [22.484639999000024, -34.05125999599994],
            [22.563649999000063, -33.99610999999993],
            [22.770545002000063, -34.02744999899994],
            [22.717550000000074, -33.99856999999997],
            [22.72685000000007, -33.92477999999994],
            [22.77744000000007, -33.92754999999994],
            [22.800279998000065, -33.84118000299998],
            [22.876550004000023, -33.815959996999936],
            [23.076460000000054, -33.80858000199993],
            [23.22901000300004, -33.87834999699993],
            [23.33441000600004, -33.85656000299997],
            [23.325480002000063, -33.79913000399995],
            [23.395039996000037, -33.79263999899996],
            [23.43994000200007, -33.717390000999956],
            [23.54127000400007, -33.699539999999956],
            [23.555529998000054, -33.67295999799995],
            [23.670440004000056, -33.67255999799994],
            [23.674980000000062, -33.62587001199995],
            [23.61687000300003, -33.570239998999966],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC044' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.540350001000036, -26.253879996999956],
            [29.560225998000078, -26.209207995999975],
            [29.493449996000038, -26.16954999899997],
            [29.455549999000027, -26.211400001999948],
            [29.387970000000053, -26.20490000099994],
            [29.340690000000052, -26.245080001999952],
            [29.366572999000027, -26.29210799699996],
            [29.335469998000065, -26.348330001999955],
            [29.260619999000028, -26.36236000399998],
            [29.173069997000027, -26.34888999599997],
            [29.12359000200007, -26.38428999699994],
            [29.06580000400004, -26.31429000299994],
            [29.033262001000026, -26.225760002999948],
            [28.984219996000036, -26.23693000999998],
            [28.939509996000027, -26.265809994999984],
            [28.886340003000043, -26.257710001999953],
            [28.86756000200006, -26.32764999999995],
            [28.838440003000073, -26.340750001999936],
            [28.861289998000075, -26.398569995999935],
            [28.789930001000073, -26.426450002999957],
            [28.763910003000035, -26.518009998999958],
            [28.83678999700004, -26.536380003999966],
            [28.911080001000073, -26.589949995999973],
            [28.897497628000053, -26.62397787699996],
            [28.99211000400004, -26.608889999999974],
            [28.99120000000005, -26.685969996999972],
            [29.24139999700003, -26.716839999999934],
            [29.22379999900005, -26.658330002999946],
            [29.29099799200003, -26.64005999799997],
            [29.32549000000006, -26.66126000099996],
            [29.459380003000035, -26.64670999699996],
            [29.456320004000077, -26.59155000399994],
            [29.486830000000054, -26.55331000299998],
            [29.568310001000043, -26.56155000299998],
            [29.61916999500005, -26.52905999799998],
            [29.629110001000072, -26.48149000099994],
            [29.566180002000067, -26.442750003999947],
            [29.468669998000053, -26.352490001999968],
            [29.47029000200007, -26.303209995999964],
            [29.540350001000036, -26.253879996999956],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP307' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.38763500300007, -32.67960000199997],
            [28.222740001000034, -32.578090000999964],
            [28.16893000400006, -32.56817999799995],
            [28.14542000000006, -32.50955998899997],
            [28.047360000000026, -32.53638000299998],
            [27.955580002000033, -32.50652999999994],
            [27.893980003000024, -32.45614999999998],
            [27.787990002000072, -32.52757000199995],
            [27.729699998000058, -32.510870000999944],
            [27.729159999000046, -32.61632000299994],
            [27.677970001000062, -32.66043999699997],
            [27.78268999900007, -32.74894000399996],
            [27.882910001000027, -32.78550000299998],
            [27.95717783400005, -32.75833922499993],
            [27.991459946000077, -32.85556183399996],
            [28.075529994000078, -32.907794999999965],
            [28.117580002000068, -32.83005999799997],
            [28.178550003000055, -32.78628999699998],
            [28.268969999000035, -32.75891000399997],
            [28.38763500300007, -32.67960000199997],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC123' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.561423243000036, -23.224282794999965],
            [31.534372330000053, -23.187564849999944],
            [31.41187095600003, -23.091106414999956],
            [31.374877930000025, -23.138339995999956],
            [31.20694541900008, -23.219594954999934],
            [31.15665817300004, -23.188066482999943],
            [30.966876984000066, -23.174127578999958],
            [30.929580688000044, -23.13943481399997],
            [30.880269971000075, -23.15055002799994],
            [30.728049972000065, -23.072310030999972],
            [30.652229971000054, -23.157420025999954],
            [30.562659973000052, -23.17569003099993],
            [30.487569971000028, -23.244240030999947],
            [30.40350697100007, -23.234244027999978],
            [30.334979974000078, -23.249440032999928],
            [30.36914997300005, -23.310160027999927],
            [30.328639966000026, -23.377580029999933],
            [30.29401998000003, -23.385680021999974],
            [30.337409997000066, -23.423950005999927],
            [30.405840003000037, -23.367859996999982],
            [30.48264000100005, -23.341860002999965],
            [30.53821799600007, -23.40169099899998],
            [30.45137999700006, -23.443550011999946],
            [30.470020000000034, -23.473960001999956],
            [30.54181999700006, -23.433529996999937],
            [30.579389998000067, -23.438889996999933],
            [30.617409998000028, -23.388989997999943],
            [30.688910001000067, -23.45541999699998],
            [30.624930001000052, -23.596700001999977],
            [30.715659997000046, -23.648100002999968],
            [30.759670003000053, -23.697349990999953],
            [30.971369999000046, -23.66486999899996],
            [31.008350002000043, -23.67619000299993],
            [31.078299997000045, -23.64602999999994],
            [31.143371582000043, -23.531866073999936],
            [31.173540115000037, -23.350185393999936],
            [31.238309860000072, -23.340030669999976],
            [31.301942825000026, -23.378080367999928],
            [31.317955018000077, -23.30097770699996],
            [31.56120207300006, -23.226929905999953],
            [31.561423243000036, -23.224282794999965],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM331' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.417289942000025, -29.969134939999947],
            [29.357379942000023, -29.93955993999998],
            [29.277639942000064, -29.942049939999947],
            [29.22021994200003, -29.905749939999964],
            [29.16882494200007, -29.912705064999955],
            [29.10898994200005, -29.936969939999983],
            [29.01473997200003, -30.00179996999998],
            [29.044949978000034, -30.01296998199996],
            [29.117240037000045, -30.10018996799994],
            [29.10368997300003, -30.180540035999968],
            [29.13716997100005, -30.26233997199995],
            [29.301859965000062, -30.320119956999974],
            [29.305009976000065, -30.379859949999968],
            [29.196769982000035, -30.43439003499998],
            [29.19835997000007, -30.46233996899997],
            [29.13525000100003, -30.605139977999954],
            [29.26132997600007, -30.621159976999934],
            [29.372800038000037, -30.64896003499996],
            [29.51235997200007, -30.61821998299996],
            [29.543550296000035, -30.647186529999942],
            [29.57220004100003, -30.655149972999936],
            [29.640639942000064, -30.562039940999966],
            [29.62175994200004, -30.49035994099995],
            [29.573779942000044, -30.404852940999945],
            [29.497840067000027, -30.34030994099993],
            [29.49830994200005, -30.26992994099993],
            [29.524589942000034, -30.22235994099998],
            [29.38802994200006, -30.157550065999942],
            [29.406780067000057, -30.095859940999958],
            [29.47891994200006, -30.040369939999948],
            [29.417289942000025, -29.969134939999947],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN433' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.29401998000003, -23.385680021999974],
            [30.268560962000038, -23.324409040999967],
            [30.151606737000066, -23.31379967999993],
            [30.14675997200004, -23.341400027999953],
            [30.03769998200005, -23.33871002199993],
            [30.043259998000053, -23.42565000299993],
            [30.00599999700006, -23.447810002999972],
            [30.047347004000073, -23.535237001999974],
            [30.03643999800005, -23.57296999899995],
            [29.94901999600006, -23.62769999799997],
            [29.961120004000065, -23.66007000199994],
            [30.02542000300008, -23.624719999999968],
            [30.049900000000036, -23.70624000199996],
            [30.20124999500007, -23.753669998999953],
            [30.306069999000044, -23.631559996999954],
            [30.367669998000054, -23.624050000999944],
            [30.372510005000038, -23.56683000299995],
            [30.41791999800006, -23.52138999899995],
            [30.474790003000066, -23.56907999699996],
            [30.562779997000064, -23.552449998999975],
            [30.624930001000052, -23.596700001999977],
            [30.688910001000067, -23.45541999699998],
            [30.617409998000028, -23.388989997999943],
            [30.579389998000067, -23.438889996999933],
            [30.54181999700006, -23.433529996999937],
            [30.470020000000034, -23.473960001999956],
            [30.45137999700006, -23.443550011999946],
            [30.53821799600007, -23.40169099899998],
            [30.48264000100005, -23.341860002999965],
            [30.405840003000037, -23.367859996999982],
            [30.337409997000066, -23.423950005999927],
            [30.29401998000003, -23.385680021999974],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM332' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.32020501200003, -27.082695000999934],
            [24.223860002000038, -27.125290002999975],
            [24.195789998000066, -27.072600002999934],
            [24.13135999800005, -27.011900001999948],
            [24.037450000000035, -27.053699998999946],
            [23.973560000000077, -27.096379997999975],
            [23.89646999400003, -27.252659998999945],
            [24.01494999700003, -27.32367000599993],
            [24.08627000100006, -27.35349000399998],
            [24.05751000300006, -27.429419999999936],
            [24.050610001000052, -27.602729996999983],
            [24.118620004000036, -27.621739997999953],
            [24.093339996000054, -27.704910005999977],
            [24.111000001000036, -27.73898000099996],
            [24.40528000100005, -27.681180001999962],
            [24.44676000000004, -27.70285000399997],
            [24.408839999000065, -27.761099996999974],
            [24.452310005000072, -27.782880002999946],
            [24.360459994000053, -27.91067000299995],
            [24.40994999800006, -27.923300001999962],
            [24.46728999900006, -27.980569998999954],
            [24.465479997000045, -28.035840005999944],
            [24.534639003000052, -28.092088995999973],
            [24.56281000000007, -28.036220000999947],
            [24.62935000300007, -27.994309999999928],
            [24.615819999000053, -27.903600000999973],
            [24.699320003000025, -27.828289996999956],
            [24.65866999700006, -27.790939992999938],
            [24.69547000400007, -27.718249999999955],
            [24.692299998000067, -27.64521999899995],
            [24.762060005000023, -27.633239999999944],
            [24.80117000000007, -27.70177999699996],
            [24.99972000100007, -27.680830003999972],
            [25.047909998000023, -27.69973999599995],
            [25.08783999600007, -27.657509996999977],
            [25.006389997000042, -27.524169997999934],
            [24.976990001000047, -27.464519998999947],
            [24.91898000200007, -27.459239999999966],
            [24.892087678000053, -27.39611040099993],
            [24.782400004000067, -27.406860000999927],
            [24.777190000000076, -27.333240003999947],
            [24.699311089000048, -27.234209972999963],
            [24.58572914000007, -27.29284741999993],
            [24.612945007000064, -27.337962009999956],
            [24.45717000800005, -27.424419997999962],
            [24.380169998000042, -27.272490003999962],
            [24.415399998000055, -27.211610002999976],
            [24.32020501200003, -27.082695000999934],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW394' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.366215000000068, -24.283094996999978],
            [30.27315999700005, -24.320040002999974],
            [30.237589994000075, -24.283440002999953],
            [30.177500003000034, -24.304190000999938],
            [30.139430004000076, -24.247240002999945],
            [30.06775999900003, -24.23697999899997],
            [30.04109999600007, -24.20681999599998],
            [29.769109997000044, -24.272990001999972],
            [29.72029000300006, -24.45821000199993],
            [29.696560009000052, -24.46678998899995],
            [29.72030002100007, -24.526669982999977],
            [29.773490020000054, -24.55074998499998],
            [29.776340022000056, -24.60466998199996],
            [29.901710021000042, -24.594599982999966],
            [29.943590021000034, -24.621719982999934],
            [29.990285012000072, -24.580809984999973],
            [30.018693683000038, -24.616479676999973],
            [30.087270011000044, -24.62058998699996],
            [30.119780013000025, -24.699679987999957],
            [30.08351002200004, -24.779409980999958],
            [30.021230020000075, -24.83914998399996],
            [29.934160027000075, -24.81397497699993],
            [29.895950021000033, -24.858469983999953],
            [29.90509600200005, -24.93239899899993],
            [29.975439960000074, -24.935349962999965],
            [29.959419971000045, -24.986609966999936],
            [29.905889985000044, -25.047489970999948],
            [29.978949982000074, -25.09211998199993],
            [30.029839997000067, -25.08456999999993],
            [30.144389997000076, -25.12378999899994],
            [30.148509997000076, -25.032350003999966],
            [30.17206999900003, -24.989169998999955],
            [30.19197998900006, -24.85547000899993],
            [30.297290000000032, -24.867740001999948],
            [30.354170003000036, -24.849279998999975],
            [30.42507000300003, -24.854859999999974],
            [30.45153999200005, -24.912000003999935],
            [30.562880003000032, -24.89646000099998],
            [30.634880004000024, -24.852770000999953],
            [30.67856999600008, -24.735809996999933],
            [30.720100002000038, -24.70523800899997],
            [30.679240003000075, -24.623670001999983],
            [30.730319997000038, -24.608729995999965],
            [30.73017999900003, -24.49849999999998],
            [30.758979999000076, -24.460219998999946],
            [30.533529998000063, -24.439709997999955],
            [30.518180001000076, -24.40563999699998],
            [30.40920000400007, -24.333629997999935],
            [30.366215000000068, -24.283094996999978],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM476' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.624930001000052, -23.596700001999977],
            [30.562779997000064, -23.552449998999975],
            [30.474790003000066, -23.56907999699996],
            [30.41791999800006, -23.52138999899995],
            [30.372510005000038, -23.56683000299995],
            [30.367669998000054, -23.624050000999944],
            [30.306069999000044, -23.631559996999954],
            [30.20124999500007, -23.753669998999953],
            [30.049900000000036, -23.70624000199996],
            [30.02542000300008, -23.624719999999968],
            [29.961120004000065, -23.66007000199994],
            [29.887920003000033, -23.67941999599998],
            [29.88838000000004, -23.741600001999927],
            [29.928179999000065, -23.79767999799998],
            [29.886520000000075, -23.855119995999928],
            [29.89654999700008, -23.898719995999954],
            [29.86374999900005, -23.95138000099996],
            [29.997470001000067, -24.000659999999982],
            [30.043104998000047, -23.972489997999958],
            [30.074549997000076, -24.01201999699998],
            [30.215620001000048, -24.085699998999928],
            [30.23826000100007, -24.139269998999964],
            [30.294890001000056, -24.09587000299996],
            [30.321530000000052, -24.12969000099997],
            [30.380299998000055, -24.06934999899994],
            [30.453314593000073, -23.958283071999972],
            [30.480120000000056, -23.980880010999954],
            [30.557380004000038, -23.94147999599994],
            [30.555018003000043, -23.890914003999967],
            [30.585719999000048, -23.84737000299998],
            [30.531499996000036, -23.804949996999937],
            [30.525589999000033, -23.727099995999936],
            [30.492049998000027, -23.713759996999954],
            [30.613521002000027, -23.633207999999968],
            [30.624930001000052, -23.596700001999977],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM333' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.19539999400007, -29.63724999699997],
            [20.96151999800003, -29.796230004999984],
            [20.898560003000057, -29.85031999599994],
            [20.85758000000004, -29.858560000999944],
            [20.803750000000036, -29.942299994999928],
            [20.754809997000052, -29.98265000599997],
            [20.708139995000067, -29.985630003999972],
            [20.626389998000036, -29.86317000899993],
            [20.63684999800006, -29.75214000099993],
            [20.66141000400006, -29.643069998999977],
            [20.594470001000047, -29.63484000099993],
            [20.519840011000042, -29.71901999399995],
            [20.436840005000022, -29.615849998999977],
            [20.385830001000045, -29.603769995999983],
            [20.27338000000003, -29.64354999699998],
            [20.156710000000032, -29.65250999799997],
            [20.175209997000024, -29.76437999799998],
            [20.046140007000076, -29.861769997999943],
            [19.995640000000037, -29.86673000099995],
            [19.88141577600004, -29.777029720999963],
            [19.786281221000024, -29.87555758299993],
            [19.81688524300006, -29.952238611999974],
            [19.746426859000053, -29.980047491999983],
            [19.760719851000033, -30.021520489999943],
            [19.846224647000042, -30.03267587299996],
            [19.888157084000056, -30.093689299999937],
            [19.839409490000037, -30.14641333399993],
            [19.878073176000044, -30.228297167999983],
            [20.02635000300006, -30.238669994999952],
            [20.002280002000077, -30.279270004999944],
            [19.80409999500006, -30.38556000099993],
            [19.752279998000063, -30.394199998999966],
            [19.65014999500005, -30.37897000499993],
            [19.533789999000078, -30.316980004999948],
            [19.368379996000044, -30.296359999999936],
            [19.298139999000057, -30.25407999899994],
            [19.187160005000067, -30.298500005999983],
            [19.135780000000068, -30.37691999499998],
            [19.083110653000062, -30.342430426999954],
            [19.00597000600004, -30.49702999999994],
            [18.951480022000055, -30.74443989799994],
            [18.960470000000043, -30.866109999999935],
            [18.875390009000057, -30.887059999999963],
            [18.98449000100004, -30.945810002999963],
            [18.911770010000055, -30.978929996999966],
            [18.903470002000063, -31.041779994999956],
            [18.947600004000037, -31.112910003999957],
            [18.944460003000074, -31.237319997999975],
            [19.013010002000044, -31.305680002999964],
            [18.980130002000067, -31.355239989999973],
            [19.042989999000042, -31.424969999999973],
            [19.01968000100004, -31.499250003999975],
            [19.085420003000024, -31.526930000999982],
            [19.06556000300003, -31.706309998999984],
            [19.08627000200005, -31.794479999999965],
            [19.030459997000037, -31.83361999899995],
            [19.02622000100007, -31.876639998999963],
            [19.142450002000032, -31.912080001999982],
            [19.210710000000063, -31.948039996999967],
            [19.395849996000038, -32.01511000299996],
            [19.515190005000022, -32.11519999999996],
            [19.49150000000003, -32.25237000599998],
            [19.409080002000053, -32.29007999799995],
            [19.430200004000028, -32.36570999899993],
            [19.496370003000038, -32.47481999799993],
            [19.48680500300003, -32.56543999599995],
            [19.528249996000056, -32.67323999799993],
            [19.60495000000003, -32.62945999799996],
            [19.621850004000066, -32.47062000099993],
            [19.730240002000073, -32.44235999999995],
            [19.802700001000062, -32.393700001999946],
            [19.93749000300005, -32.37727999799995],
            [20.09696000300005, -32.25023999899997],
            [20.151830002000054, -32.18651999499997],
            [20.16472000600004, -32.087359996999965],
            [20.27734815100007, -32.08378968099993],
            [20.280049993000034, -32.012410003999946],
            [20.326710003000073, -31.903549993999945],
            [20.317649997000046, -31.86409000499998],
            [20.371859999000037, -31.822040002999984],
            [20.474689999000077, -31.806159992999937],
            [20.475589997000043, -31.840609996999945],
            [20.55933999800004, -31.852660000999947],
            [20.648430004000033, -31.84450000099997],
            [20.62104000200003, -31.765809997999952],
            [20.562474999000074, -31.72275300299998],
            [20.610494997000046, -31.657463999999948],
            [20.557600001000026, -31.604780003999963],
            [20.624150003000068, -31.520099997999978],
            [20.564139999000076, -31.494099998999957],
            [20.527689999000074, -31.424849995999978],
            [20.57931999500005, -31.41523999499998],
            [20.54627000200003, -31.33152999999993],
            [20.59158000700006, -31.310629998999957],
            [20.54742999700005, -31.201530005999928],
            [20.460529996000048, -31.17679999799998],
            [20.403079998000067, -31.18552000099993],
            [20.351190004000046, -31.090939996999964],
            [20.389879999000073, -30.95676499399997],
            [20.459320002000027, -30.898930002999975],
            [20.383159999000043, -30.81525999799993],
            [20.412269999000046, -30.758160002999944],
            [20.45392980200006, -30.765678068999932],
            [20.53151949200003, -30.70610269399998],
            [20.573284940000065, -30.78459416499993],
            [20.60949726800004, -30.73684884299996],
            [20.615560091000077, -30.654913388999944],
            [20.691008769000064, -30.640038010999945],
            [20.789986370000065, -30.588234641999975],
            [20.799292618000038, -30.63632193099994],
            [20.938535434000073, -30.61665292799995],
            [20.910101455000074, -30.519768485999975],
            [20.92542594300005, -30.50003415699996],
            [21.055962842000042, -30.485085638999976],
            [21.082062173000054, -30.401837343999944],
            [21.14261744600003, -30.42651687999995],
            [21.251485715000058, -30.39702336299996],
            [21.219809997000027, -30.332930002999944],
            [21.072910000000036, -30.332249996999963],
            [21.074880005000068, -30.302569994999942],
            [21.143060010000056, -30.25622992199993],
            [21.165240002000075, -30.08564999999993],
            [21.242980001000035, -30.039089993999937],
            [21.305260006000026, -29.980409994999945],
            [21.154130002000045, -29.872619999999984],
            [21.27204000300003, -29.736279998999976],
            [21.27559999500005, -29.687159994999945],
            [21.19539999400007, -29.63724999699997],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC065' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.70035000200005, -33.85285000099998],
            [21.740035060000025, -33.79614592699994],
            [21.64827000400004, -33.83040999599996],
            [21.548260004000042, -33.82284000299995],
            [21.423320000000047, -33.84758999899998],
            [21.371060003000025, -33.81989999799998],
            [21.084609999000065, -33.82291999699993],
            [20.99155999800007, -33.868000001999974],
            [20.943380000000047, -33.85187000199994],
            [20.93403999800006, -33.94762000299994],
            [20.833790001000068, -33.971330002999935],
            [20.806580002000032, -33.946419995999975],
            [20.707270003000076, -33.955120000999955],
            [20.754300000000057, -34.09724999699995],
            [20.640100002000054, -34.08596000399996],
            [20.664950003000058, -34.18847999899998],
            [20.599380001000043, -34.27291000399998],
            [20.596289999000078, -34.34796999699995],
            [20.683379996000042, -34.34666999899997],
            [20.735050004000072, -34.38768000299996],
            [20.849963002000038, -34.40340599799998],
            [20.933440003000044, -34.36599999799995],
            [21.13432000000006, -34.38354999699993],
            [21.29070999700008, -34.43676999699994],
            [21.413130008000053, -34.401359997999975],
            [21.450089999000056, -34.36753999999996],
            [21.53569999900003, -34.35636999999997],
            [21.69624999800004, -34.394990003999965],
            [21.83550000200006, -34.37524000099995],
            [21.88696999700005, -34.34357999699995],
            [21.792579998000065, -34.28613000099995],
            [21.71243143600003, -34.127638167999976],
            [21.715360004000047, -34.043579998999974],
            [21.666649998000025, -34.00936000099995],
            [21.65139000100004, -33.92818999899998],
            [21.70035000200005, -33.85285000099998],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC042' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.689915942000027, -29.402831939999942],
            [29.61328005200005, -29.408469929999967],
            [29.506799942000043, -29.33977993999997],
            [29.45545994200006, -29.341249939999955],
            [29.403389942000047, -29.444019939999976],
            [29.299845521000066, -29.49893551899993],
            [29.399520874000075, -29.524938582999937],
            [29.493708880000042, -29.586860324999975],
            [29.592859925000027, -29.577360029999966],
            [29.70281971600008, -29.63574344799997],
            [29.91852293100004, -29.767480744999943],
            [29.957625609000047, -29.78094086699997],
            [29.980332055000076, -29.719404435999934],
            [30.069199943000058, -29.72404006499994],
            [30.10609994300006, -29.629689939999935],
            [30.01758006700004, -29.589839939999933],
            [30.00618994200005, -29.53643993999998],
            [29.918909942000028, -29.533619939999937],
            [29.821639942000047, -29.456689939999933],
            [29.689915942000027, -29.402831939999942],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN224' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.267529943000056, -28.731019938999964],
            [30.144079943000065, -28.745679938999956],
            [30.043330067000056, -28.70574993899993],
            [29.99502994200003, -28.642819938999935],
            [29.930629942000053, -28.681829938999954],
            [29.88163006700006, -28.669499938999934],
            [29.82913994200004, -28.698639938999975],
            [29.847860067000056, -28.74389993899996],
            [29.761249942000063, -28.737949938999975],
            [29.73842994200004, -28.791759938999974],
            [29.67715006700007, -28.866379938999955],
            [29.631869942000037, -28.868699938999953],
            [29.581069942000056, -28.941119938999975],
            [29.540569942000047, -28.93754993899995],
            [29.47361006700004, -29.091747939999948],
            [29.419982910000044, -29.149206160999938],
            [29.357050041000036, -29.134250605999966],
            [29.35662994200004, -29.201319939999962],
            [29.40742994200008, -29.211559939999972],
            [29.45545994200006, -29.341249939999955],
            [29.506799942000043, -29.33977993999997],
            [29.578629942000077, -29.33552006499997],
            [29.56982994200007, -29.29037993999998],
            [29.609740067000075, -29.24864993999995],
            [29.652099942000063, -29.297079939999946],
            [29.753790067000068, -29.283259939999937],
            [29.75571994200004, -29.206939939999984],
            [29.854859942000076, -29.21807993999994],
            [29.926899942000034, -29.121849939999947],
            [30.027989942000033, -29.05932006499995],
            [30.086179943000047, -28.966530063999983],
            [30.229629943000077, -28.984039938999956],
            [30.223689943000068, -28.94574993899994],
            [30.287469943000076, -28.91489993899995],
            [30.267529943000056, -28.731019938999964],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN237' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.010034442000062, -32.03639166599993],
            [27.98333358800005, -31.98428535499994],
            [28.016820001000042, -31.87285000399993],
            [27.879180003000045, -31.81473000099993],
            [27.80001999800004, -31.743580005999945],
            [27.801010004000034, -31.697799998999983],
            [27.758459997000045, -31.65649000899998],
            [27.694469998000045, -31.713420002999953],
            [27.52737471100005, -31.726878330999966],
            [27.437136002000045, -31.676665999999955],
            [27.39869999600006, -31.72566999999998],
            [27.434009997000032, -31.80967900299993],
            [27.407873005000056, -31.895912003999968],
            [27.328849999000056, -31.890879996999956],
            [27.27276160400004, -31.933650016999934],
            [27.32141479200004, -31.97579112799997],
            [27.41182000300006, -32.09891999799993],
            [27.39748000000003, -32.136169999999936],
            [27.440119998000057, -32.18384999999995],
            [27.48234000000008, -32.16280000099994],
            [27.507879998000078, -32.230749996999975],
            [27.535090000000025, -32.197479999999985],
            [27.60068758700004, -32.21345436599995],
            [27.64370824200006, -32.278592110999966],
            [27.705318436000027, -32.32440268399995],
            [27.758832939000058, -32.331968064999955],
            [27.765019997000024, -32.25881000299995],
            [27.812770000000057, -32.183239998999966],
            [27.775190001000055, -32.10948000299993],
            [27.889110002000052, -32.04975000299993],
            [27.950199997000027, -32.08188999999993],
            [28.010034442000062, -32.03639166599993],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC135' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.38621000100005, -31.21784000399998],
            [25.354419997000036, -31.23599999399994],
            [25.22504000300006, -31.195199999999943],
            [25.170479998000076, -31.23917999899993],
            [25.05847000400007, -31.269379999999956],
            [25.00562000000008, -31.263099998999962],
            [24.94197000500003, -31.315069998999945],
            [24.852990005000038, -31.328209989999948],
            [24.788679998000077, -31.389460002999954],
            [24.704810003000034, -31.400590001999944],
            [24.664990001000035, -31.38366000999997],
            [24.56719000100003, -31.41864000099997],
            [24.558850001000053, -31.481839995999962],
            [24.503910002000055, -31.568419998999957],
            [24.522960003000037, -31.603689997999936],
            [24.50627000000003, -31.706830001999947],
            [24.550710001000027, -31.761169998999947],
            [24.616460002000053, -31.726169996999943],
            [24.704399998000042, -31.744279999999947],
            [24.733469998000032, -31.787290002999953],
            [24.80192999800005, -31.78496999799995],
            [24.85562999900003, -31.83488499799995],
            [24.899250004000066, -31.837270003999947],
            [24.939119998000024, -31.90504999899997],
            [24.92448999900006, -31.94159000199994],
            [24.95068999700004, -32.00726999999995],
            [24.938049999000043, -32.053260000999956],
            [24.967119999000033, -32.107509998999944],
            [24.915539999000032, -32.17211999799997],
            [24.90401999900007, -32.221940003999975],
            [24.949610000000064, -32.241180001999965],
            [25.055050004000066, -32.28005000099995],
            [25.128310002000035, -32.291099997999936],
            [25.167560003000062, -32.328709999999944],
            [25.27862999900003, -32.34555999799994],
            [25.309550001000048, -32.31332999199998],
            [25.407709999000076, -32.37400999699997],
            [25.398729996000043, -32.41303000099998],
            [25.534059996000053, -32.394469998999966],
            [25.574369999000055, -32.457799997999984],
            [25.621720002000075, -32.45678999599994],
            [25.65508199800007, -32.50690700299998],
            [25.785559999000043, -32.53790000099997],
            [25.797389991000045, -32.477220003999946],
            [25.887309997000045, -32.48680000199994],
            [25.899359997000033, -32.43292999999994],
            [25.951069612000026, -32.36404736299994],
            [26.08164000100004, -32.31788000299997],
            [26.141285004000054, -32.27174500799998],
            [26.191329997000025, -32.285230000999945],
            [26.20688999600003, -32.16447000299996],
            [26.076000003000047, -32.11261999599998],
            [25.99953000100004, -32.005000001999974],
            [25.850160000000074, -31.908890000999975],
            [25.762169997000058, -31.897900000999982],
            [25.723179997000045, -31.86365000099994],
            [25.640569999000036, -31.90269000099994],
            [25.634099999000057, -31.839609996999968],
            [25.563680000000033, -31.80290999899995],
            [25.54142000300004, -31.767429995999976],
            [25.36039999600007, -31.714490001999934],
            [25.41488000100003, -31.67424999499997],
            [25.454490001000067, -31.684599997999953],
            [25.52832999900005, -31.613749997999946],
            [25.50582000600008, -31.548869998999976],
            [25.61735999700005, -31.577260000999956],
            [25.589330002000054, -31.48531000199995],
            [25.59171000400005, -31.418869996999945],
            [25.564499996000052, -31.358469997999975],
            [25.51211999700007, -31.346009998999932],
            [25.557529999000053, -31.27799000699997],
            [25.47940999800005, -31.23725000199994],
            [25.38621000100005, -31.21784000399998],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC131' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.037450000000035, -27.053699998999946],
            [24.026019999000027, -26.99928999699995],
            [23.97037000100005, -26.894200001999934],
            [23.916070004000062, -26.858289997999975],
            [23.853230004000068, -26.890140002999942],
            [23.760750002000066, -26.840960000999928],
            [23.646530002000077, -26.807480001999977],
            [23.48713000300006, -26.739709004999952],
            [23.583750000000066, -26.617149997999945],
            [23.46295999800003, -26.53108999799997],
            [23.266410002000043, -26.48539999899998],
            [23.28205000300005, -26.339470002999974],
            [23.221740004000026, -26.271270000999948],
            [23.310979995000025, -26.141849999999977],
            [23.215819999000075, -26.115730003999943],
            [23.23214999700008, -26.052690002999952],
            [23.35388199700003, -26.08947800599998],
            [23.387359998000022, -26.006159999999966],
            [23.320549997000057, -25.99283999599993],
            [23.086910001000035, -25.982559995999964],
            [23.064800003000073, -26.099059994999948],
            [22.987040000000036, -26.089979995999954],
            [22.981149999000024, -26.152559999999937],
            [22.90705999900007, -26.14592000199997],
            [22.899290004000022, -26.213630000999956],
            [22.84187000000003, -26.39330000299998],
            [22.803159997000023, -26.453680000999952],
            [22.708800001000043, -26.410789998999974],
            [22.702940002000048, -26.11985000599998],
            [22.632170006000024, -26.121280000999946],
            [22.579580000000078, -26.15836999199996],
            [22.557409999000072, -26.221759994999957],
            [22.474240000000066, -26.19971000499993],
            [22.42220999500006, -26.223240002999944],
            [22.366780000000063, -26.319170002999954],
            [22.24725000500007, -26.34704000299996],
            [22.192790013000035, -26.395850001999975],
            [22.200240000000065, -26.42478000099993],
            [22.04823000600004, -26.635049994999974],
            [21.953129998000065, -26.66870999699995],
            [21.823310004000064, -26.659839999999974],
            [21.787390000000073, -26.676060003999964],
            [21.79286999900006, -26.76962999899996],
            [21.872350003000065, -26.86014999799994],
            [21.917139989000077, -26.95868999399994],
            [21.951630007000063, -26.948810011999967],
            [21.99946000500006, -27.024790005999932],
            [21.999490738000077, -27.110249661999944],
            [22.124309996000022, -27.07355999899994],
            [22.150609992000057, -27.030939994999983],
            [22.20940000300004, -27.094450000999927],
            [22.251680004000036, -27.039929994999966],
            [22.324780004000047, -27.07768999299998],
            [22.341339995000055, -27.26111000399993],
            [22.487789994000025, -27.278889996999965],
            [22.620430000000056, -27.26307000099996],
            [22.68164999800007, -27.347749998999973],
            [22.669130004000067, -27.450710002999983],
            [22.719759999000075, -27.456369993999942],
            [22.714579996000055, -27.549159994999968],
            [22.84454000100004, -27.543719993999957],
            [22.837420001000055, -27.39042000099994],
            [22.995509995000077, -27.40740999999997],
            [23.122990006000066, -27.40646999599994],
            [23.21585000400006, -27.41918999799998],
            [23.27180256200006, -27.378535727999974],
            [23.132359992000033, -27.236959997999975],
            [23.11690999800004, -27.20108000099998],
            [23.17809199800007, -27.135831004999943],
            [23.394121518000077, -27.29911970099994],
            [23.476216212000054, -27.29184161099994],
            [23.52745111200005, -27.340882491999935],
            [23.56404368500006, -27.33500288299996],
            [23.610819999000057, -27.472440004999953],
            [23.671480002000067, -27.516129999999976],
            [23.767069999000057, -27.55323999899997],
            [23.81460000000004, -27.478799993999928],
            [23.936559998000064, -27.410819997999965],
            [24.01494999700003, -27.32367000599993],
            [23.89646999400003, -27.252659998999945],
            [23.973560000000077, -27.096379997999975],
            [24.037450000000035, -27.053699998999946],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC451' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.34588994500007, -26.855900061999932],
            [32.22029994500008, -26.832849936999935],
            [32.186330069000064, -26.862990061999938],
            [32.09255994400007, -26.804870061999964],
            [32.015859944000056, -26.81988006199998],
            [31.99595994400005, -26.92414993799997],
            [31.974549944000046, -27.116409937999947],
            [31.97775994400007, -27.31752006299996],
            [32.02069994400006, -27.512840062999942],
            [32.05013994400008, -27.58379993799997],
            [31.986959944000034, -27.579909937999957],
            [31.951619944000072, -27.61907993799997],
            [31.996179944000062, -27.885269937999965],
            [32.031879944000025, -27.92858006299997],
            [32.098209944000075, -27.872570062999955],
            [32.17151994400007, -27.850339937999934],
            [32.19023006900005, -27.784149937999928],
            [32.259768945000076, -27.807365062999963],
            [32.33728794500007, -27.753563062999945],
            [32.41573307700003, -27.661980149999977],
            [32.402282945000024, -27.64807306299997],
            [32.40859994500005, -27.483649062999973],
            [32.25805994500007, -27.50983006299998],
            [32.22306994500008, -27.478569937999964],
            [32.26145994500007, -27.35058006299994],
            [32.220339945000035, -27.33134006299997],
            [32.25333994500005, -27.24967993799993],
            [32.21628007000004, -27.203829937999956],
            [32.26455994500003, -27.080439937999984],
            [32.301769945000046, -27.020810062999942],
            [32.28172994500005, -26.96449006299997],
            [32.32869994500004, -26.942849937999938],
            [32.34588994500007, -26.855900061999932],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN272' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.485275002000037, -25.74938999799997],
            [24.448470003000068, -25.73412000299993],
            [24.380810002000032, -25.764859996999974],
            [24.278469999000038, -25.713250002999928],
            [24.194069996000053, -25.62106999699995],
            [24.003529996000054, -25.650190003999967],
            [23.90337999700006, -25.626810000999967],
            [23.880239999000025, -25.577449999999942],
            [23.816089996000073, -25.55018000299998],
            [23.75825999700004, -25.469259996999938],
            [23.594380000000058, -25.397010000999956],
            [23.500439999000037, -25.33184999599996],
            [23.46826999900003, -25.27946999699998],
            [23.419860003000053, -25.313740001999975],
            [23.36049999200003, -25.28622999299995],
            [23.192250000000058, -25.277310002999968],
            [22.97794000300007, -25.33985999799995],
            [22.96761000400005, -25.38342999599996],
            [22.863750003000064, -25.479619997999976],
            [22.852649991000078, -25.53552000199994],
            [22.81481999600004, -25.57882000099994],
            [22.853459996000026, -25.611629996999966],
            [22.763719990000027, -25.77872999699997],
            [22.781409996000036, -25.828799997999965],
            [22.738069997000025, -25.85504000399993],
            [22.722869997000032, -25.908360001999938],
            [22.72104999800007, -26.018560002999948],
            [22.669180002000076, -26.013910001999932],
            [22.673080010000035, -26.073669996999968],
            [22.632170006000024, -26.121280000999946],
            [22.702940002000048, -26.11985000599998],
            [22.708800001000043, -26.410789998999974],
            [22.803159997000023, -26.453680000999952],
            [22.84187000000003, -26.39330000299998],
            [22.899290004000022, -26.213630000999956],
            [22.90705999900007, -26.14592000199997],
            [22.981149999000024, -26.152559999999937],
            [22.987040000000036, -26.089979995999954],
            [23.064800003000073, -26.099059994999948],
            [23.086910001000035, -25.982559995999964],
            [23.320549997000057, -25.99283999599993],
            [23.387359998000022, -26.006159999999966],
            [23.35388199700003, -26.08947800599998],
            [23.23214999700008, -26.052690002999952],
            [23.215819999000075, -26.115730003999943],
            [23.310979995000025, -26.141849999999977],
            [23.221740004000026, -26.271270000999948],
            [23.28205000300005, -26.339470002999974],
            [23.266410002000043, -26.48539999899998],
            [23.46295999800003, -26.53108999799997],
            [23.583750000000066, -26.617149997999945],
            [23.48713000300006, -26.739709004999952],
            [23.646530002000077, -26.807480001999977],
            [23.760750002000066, -26.840960000999928],
            [23.853230004000068, -26.890140002999942],
            [23.916070004000062, -26.858289997999975],
            [23.97037000100005, -26.894200001999934],
            [24.026019999000027, -26.99928999699995],
            [24.037450000000035, -27.053699998999946],
            [24.13135999800005, -27.011900001999948],
            [24.195789998000066, -27.072600002999934],
            [24.223860002000038, -27.125290002999975],
            [24.32020501200003, -27.082695000999934],
            [24.341410004000068, -27.06802999699994],
            [24.265849997000032, -26.960619995999934],
            [24.304439998000078, -26.94291999999996],
            [24.276980004000052, -26.883239997999965],
            [24.509660004000068, -26.76717999999994],
            [24.701519998000038, -26.685469998999963],
            [24.780250000000024, -26.642580006999935],
            [24.729249999000047, -26.59639999199993],
            [24.657379999000057, -26.48580999799998],
            [24.602179997000064, -26.51544999899994],
            [24.53613000100006, -26.401690000999963],
            [24.677920003000054, -26.329109999999957],
            [24.635080001000063, -26.269699997999965],
            [24.76417999800003, -26.205250000999968],
            [24.804080002000035, -26.158249998999963],
            [24.733850001000064, -26.03957000099996],
            [24.653879999000026, -25.95932000199997],
            [24.667030001000057, -25.921250002999955],
            [24.465069998000047, -25.790170003999947],
            [24.485275002000037, -25.74938999799997],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW397' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.260460005000027, -28.711480002999963],
            [21.191390003000038, -28.60766999899994],
            [21.160369004000074, -28.593195999999978],
            [21.017790001000037, -28.44387000699993],
            [21.00117999500003, -28.400709999999947],
            [20.926249993000056, -28.412699997999937],
            [20.849555002000045, -28.350969994999957],
            [20.805000008000036, -28.354829999999936],
            [20.712329863000036, -28.281499865999933],
            [20.638014890000022, -28.17485348899993],
            [20.579980727000077, -28.181939240999952],
            [20.55798912000006, -28.034820556999932],
            [20.51177024800006, -27.95871925399996],
            [20.433149338000078, -27.903619765999963],
            [20.411949158000027, -27.853340148999962],
            [20.270820618000073, -27.91489028899997],
            [20.24860000600006, -27.790569304999963],
            [20.15366935700007, -27.852560042999983],
            [20.000210001000028, -27.77401999899996],
            [19.999159993000035, -28.42768000199993],
            [19.84723000400004, -28.46005000499997],
            [19.812989999000024, -28.508339992999936],
            [19.730049999000073, -28.487909996999974],
            [19.670849996000072, -28.529369997999936],
            [19.621900002000075, -28.511010002999967],
            [19.54847999800006, -28.540839999999946],
            [19.509289998000042, -28.596540000999937],
            [19.61911000400005, -28.690560009999956],
            [19.666229997000073, -28.82979000399996],
            [19.779510006000066, -28.87642000699998],
            [19.681050007000067, -28.99260000199996],
            [19.576690000000042, -29.09468199899993],
            [19.60131999600003, -29.27185000099996],
            [19.65699000500007, -29.32103000199993],
            [19.74025000200004, -29.428609989999984],
            [19.766989996000063, -29.539970000999972],
            [19.76216999600007, -29.58204000199993],
            [19.585969998000053, -29.609920000999978],
            [19.610899998000036, -29.68085999599998],
            [19.574820000000045, -29.72529000299994],
            [19.659080006000067, -29.793019999999956],
            [19.88141577600004, -29.777029720999963],
            [19.995640000000037, -29.86673000099995],
            [20.046140007000076, -29.861769997999943],
            [20.175209997000024, -29.76437999799998],
            [20.156710000000032, -29.65250999799997],
            [20.27338000000003, -29.64354999699998],
            [20.385830001000045, -29.603769995999983],
            [20.436840005000022, -29.615849998999977],
            [20.519840011000042, -29.71901999399995],
            [20.594470001000047, -29.63484000099993],
            [20.66141000400006, -29.643069998999977],
            [20.63684999800006, -29.75214000099993],
            [20.626389998000036, -29.86317000899993],
            [20.708139995000067, -29.985630003999972],
            [20.754809997000052, -29.98265000599997],
            [20.803750000000036, -29.942299994999928],
            [20.85758000000004, -29.858560000999944],
            [20.898560003000057, -29.85031999599994],
            [20.96151999800003, -29.796230004999984],
            [21.19539999400007, -29.63724999699997],
            [21.226200104000043, -29.523880004999967],
            [21.27092000500005, -29.46521999899994],
            [21.24951999900003, -29.404230000999974],
            [21.274170001000073, -29.35798000699998],
            [21.182412257000067, -29.25857309299994],
            [21.301664241000026, -29.154666990999942],
            [21.308571252000036, -29.06743649799995],
            [21.211321918000067, -29.00890848699993],
            [21.251049996000063, -28.930944996999983],
            [21.139804997000056, -28.863139993999937],
            [21.125769997000077, -28.831600006999963],
            [21.260460005000027, -28.711480002999963],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC082' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.083110653000062, -30.342430426999954],
            [19.091310501000066, -30.30965995799994],
            [19.010570526000038, -30.164569854999968],
            [19.011909485000047, -30.074069976999965],
            [18.908290863000047, -30.063850402999947],
            [18.859159470000066, -29.94660949699994],
            [18.86706924400005, -29.845760344999974],
            [18.808450699000048, -29.83167076099994],
            [18.725596495000048, -29.864108638999937],
            [18.605489997000063, -29.86041000199998],
            [18.493659973000035, -29.91807937599998],
            [18.36712000500006, -29.934800000999928],
            [18.333249994000028, -29.89559999399995],
            [18.219024793000074, -29.91100935199995],
            [18.208803792000026, -30.000553882999952],
            [18.12719000000004, -30.016509999999982],
            [18.000010002000067, -30.06589999399995],
            [17.959109996000052, -30.028689998999937],
            [17.88778000800005, -30.038649994999957],
            [17.863600003000045, -30.06668999599998],
            [17.779109998000024, -30.054319995999947],
            [17.732490003000066, -30.020719999999983],
            [17.603879995000057, -30.012490001999936],
            [17.561650000000043, -30.047149997999952],
            [17.519239995000078, -29.949870000999965],
            [17.439129999000045, -30.03308999899997],
            [17.396130001000074, -30.018939994999982],
            [17.312240005000035, -30.092839996999942],
            [17.247240000000033, -30.003180004999933],
            [17.181000002000076, -30.061730000999944],
            [17.25831000100004, -30.256460003999962],
            [17.273790002000055, -30.33460000399998],
            [17.37074999500004, -30.49933999999996],
            [17.442349996000075, -30.596300000999975],
            [17.433960005000074, -30.620780001999947],
            [17.523589997000045, -30.735550001999968],
            [17.595329993000064, -30.90001000099994],
            [17.679419990000042, -30.99910000099993],
            [17.757580003000044, -31.15196999999995],
            [17.834419999000033, -31.176519999999982],
            [17.81132000100007, -31.09253999999993],
            [17.926409999000043, -31.011390002999974],
            [17.880299998000055, -30.92393999899997],
            [17.99337999900007, -30.91874000399997],
            [18.006479003000038, -30.791239995999945],
            [18.08917999700003, -30.787869995999984],
            [18.169180004000054, -30.848559998999974],
            [18.213540000000023, -30.810439991999942],
            [18.264169999000046, -30.818319993999978],
            [18.37103999900006, -30.659629996999968],
            [18.371150003000025, -30.592089999999928],
            [18.413759999000035, -30.527349999999956],
            [18.483619995000026, -30.52190999499993],
            [18.502150001000075, -30.44442000199996],
            [18.570120003000056, -30.43025999799994],
            [18.65514954100007, -30.556709298999976],
            [18.758710861000054, -30.56786918599994],
            [18.795869998000057, -30.62486000399997],
            [18.794500351000067, -30.667619704999936],
            [18.862970352000048, -30.717119216999947],
            [18.951480022000055, -30.74443989799994],
            [19.00597000600004, -30.49702999999994],
            [19.083110653000062, -30.342430426999954],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC064' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.902079997000044, -33.36495998799995],
            [21.82723999700005, -33.391039999999975],
            [21.611950001000025, -33.39679999999993],
            [21.521819993000065, -33.41440999699995],
            [21.43310000200006, -33.39417000299994],
            [21.00971000100003, -33.43926999599995],
            [20.921800000000076, -33.43065000099995],
            [20.762000002000036, -33.490839989999984],
            [20.547599998000067, -33.51951999599993],
            [20.574350000000038, -33.538760002999936],
            [20.503258997000046, -33.63700000199998],
            [20.66602000200004, -33.621970003999934],
            [20.71892000400004, -33.64061999699993],
            [20.800259999000048, -33.71500999899996],
            [20.934120000000064, -33.72464001199995],
            [21.010339999000053, -33.75656000099997],
            [20.943380000000047, -33.85187000199994],
            [20.99155999800007, -33.868000001999974],
            [21.084609999000065, -33.82291999699993],
            [21.371060003000025, -33.81989999799998],
            [21.423320000000047, -33.84758999899998],
            [21.548260004000042, -33.82284000299995],
            [21.64827000400004, -33.83040999599996],
            [21.740035060000025, -33.79614592699994],
            [21.72279999600005, -33.70531999599996],
            [21.837480004000042, -33.737309996999954],
            [21.935039999000026, -33.66770000399998],
            [21.936273998000047, -33.524975996999956],
            [21.902079997000044, -33.36495998799995],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC041' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.014210001000038, -30.005780001999938],
            [21.938354994000065, -30.024279999999976],
            [21.914559999000062, -29.99111000199997],
            [21.832669999000075, -30.02786999799997],
            [21.694749994000063, -29.99543999699995],
            [21.59218000000004, -30.01155999699995],
            [21.575279997000052, -30.04440999899998],
            [21.507410005000054, -30.031300002999956],
            [21.425669999000036, -29.98637999899995],
            [21.371340002000068, -30.017459995999957],
            [21.242980001000035, -30.039089993999937],
            [21.165240002000075, -30.08564999999993],
            [21.143060010000056, -30.25622992199993],
            [21.074880005000068, -30.302569994999942],
            [21.072910000000036, -30.332249996999963],
            [21.219809997000027, -30.332930002999944],
            [21.251485715000058, -30.39702336299996],
            [21.265219999000067, -30.47443999899997],
            [21.308110001000045, -30.543559998999967],
            [21.270914998000023, -30.58946999799997],
            [21.336420000000032, -30.63831999599995],
            [21.420920005000028, -30.728590003999955],
            [21.493310000000065, -30.82814000199994],
            [21.469610001000035, -30.87523999499996],
            [21.501979997000035, -30.914809995999974],
            [21.483030000000042, -30.993860000999973],
            [21.509820001000037, -31.057220004999976],
            [21.588089996000065, -31.061920001999965],
            [21.670689993000053, -31.09759999099998],
            [21.700109998000073, -31.063510004999955],
            [21.84595000400003, -31.064089998999975],
            [22.003210005000028, -31.01237000599997],
            [22.082209996000074, -31.05149999899993],
            [22.077040002000047, -31.13426999799998],
            [22.18747999200008, -31.168899995999936],
            [22.214509991000057, -31.216260002999945],
            [22.31849000400007, -31.14293999499995],
            [22.443519997000067, -31.13095000499993],
            [22.49762999400008, -31.095800003999955],
            [22.462409981000064, -31.00684083599998],
            [22.664740004000066, -30.954339997999966],
            [22.690140002000078, -30.975499997999975],
            [22.78191000100003, -30.947620006999955],
            [22.896609996000052, -30.879749998999955],
            [22.896850003000054, -30.856329996999932],
            [23.056190006000065, -30.88226999899996],
            [23.109370006000063, -30.828209998999967],
            [23.067449999000075, -30.799329997999962],
            [23.05554999800006, -30.728529997999942],
            [23.01329200400005, -30.658792997999967],
            [23.064460002000033, -30.65116999299994],
            [23.094329997000045, -30.56744999899996],
            [23.242530001000034, -30.54131999699996],
            [23.224300001000074, -30.488249998999947],
            [23.230259997000076, -30.39873000199998],
            [23.133210000000076, -30.381469997999943],
            [23.06678000100004, -30.391630001999943],
            [22.997989996000058, -30.377350010999976],
            [22.959189998000056, -30.27322998699998],
            [22.982039997000072, -30.238129999999956],
            [22.954920001000062, -30.222150001999978],
            [22.93757000000005, -30.123549999999966],
            [22.748339995000038, -30.079269994999947],
            [22.64779999500007, -30.130230000999973],
            [22.673860000000047, -30.188599995999937],
            [22.60809000000006, -30.199300002999962],
            [22.523539997000057, -30.15835999899997],
            [22.466299999000057, -30.190420005999954],
            [22.299599989000058, -30.196430008999982],
            [22.208989994000035, -30.12486999799995],
            [22.13551999200007, -30.113150004999966],
            [22.034579999000073, -30.05758999899996],
            [22.014210001000038, -30.005780001999938],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC074' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.670689993000053, -31.09759999099998],
            [21.588089996000065, -31.061920001999965],
            [21.509820001000037, -31.057220004999976],
            [21.483030000000042, -30.993860000999973],
            [21.501979997000035, -30.914809995999974],
            [21.469610001000035, -30.87523999499996],
            [21.493310000000065, -30.82814000199994],
            [21.420920005000028, -30.728590003999955],
            [21.336420000000032, -30.63831999599995],
            [21.270914998000023, -30.58946999799997],
            [21.308110001000045, -30.543559998999967],
            [21.265219999000067, -30.47443999899997],
            [21.251485715000058, -30.39702336299996],
            [21.14261744600003, -30.42651687999995],
            [21.082062173000054, -30.401837343999944],
            [21.055962842000042, -30.485085638999976],
            [20.92542594300005, -30.50003415699996],
            [20.910101455000074, -30.519768485999975],
            [20.938535434000073, -30.61665292799995],
            [20.799292618000038, -30.63632193099994],
            [20.789986370000065, -30.588234641999975],
            [20.691008769000064, -30.640038010999945],
            [20.615560091000077, -30.654913388999944],
            [20.60949726800004, -30.73684884299996],
            [20.573284940000065, -30.78459416499993],
            [20.53151949200003, -30.70610269399998],
            [20.45392980200006, -30.765678068999932],
            [20.412269999000046, -30.758160002999944],
            [20.383159999000043, -30.81525999799993],
            [20.459320002000027, -30.898930002999975],
            [20.389879999000073, -30.95676499399997],
            [20.351190004000046, -31.090939996999964],
            [20.403079998000067, -31.18552000099993],
            [20.460529996000048, -31.17679999799998],
            [20.54742999700005, -31.201530005999928],
            [20.59158000700006, -31.310629998999957],
            [20.54627000200003, -31.33152999999993],
            [20.57931999500005, -31.41523999499998],
            [20.527689999000074, -31.424849995999978],
            [20.564139999000076, -31.494099998999957],
            [20.624150003000068, -31.520099997999978],
            [20.557600001000026, -31.604780003999963],
            [20.610494997000046, -31.657463999999948],
            [20.562474999000074, -31.72275300299998],
            [20.62104000200003, -31.765809997999952],
            [20.648430004000033, -31.84450000099997],
            [20.55933999800004, -31.852660000999947],
            [20.475589997000043, -31.840609996999945],
            [20.474689999000077, -31.806159992999937],
            [20.371859999000037, -31.822040002999984],
            [20.317649997000046, -31.86409000499998],
            [20.326710003000073, -31.903549993999945],
            [20.280049993000034, -32.012410003999946],
            [20.27734815100007, -32.08378968099993],
            [20.16472000600004, -32.087359996999965],
            [20.151830002000054, -32.18651999499997],
            [20.166360001000044, -32.22749000399995],
            [20.240840003000073, -32.22418999599995],
            [20.21603000500005, -32.30315999499993],
            [20.163520004000077, -32.35102000599994],
            [20.132020001000058, -32.42112000299994],
            [20.079690004000042, -32.39749999399993],
            [20.096810000000062, -32.50295999699995],
            [20.14119000200003, -32.643739995999965],
            [20.191720000000032, -32.68575999999996],
            [20.187609997000038, -32.752670002999935],
            [20.219040003000032, -32.78473999499994],
            [20.299899996000022, -32.80495999899995],
            [20.38004999900005, -32.90184999999997],
            [20.43859999500006, -32.940060003999974],
            [20.499299989000065, -32.941629992999935],
            [20.561230000000023, -32.880969998999944],
            [20.59210000400003, -32.92646999899995],
            [20.731170002000056, -32.944994994999945],
            [20.798560000000066, -32.89474999999993],
            [20.832430000000045, -32.81737000299995],
            [20.792200000000037, -32.73503001199998],
            [20.84410000400004, -32.66243999499994],
            [20.962780000000066, -32.639299996999966],
            [21.06028999600005, -32.65550000199994],
            [21.156979997000064, -32.62893999399995],
            [21.14011000200003, -32.58976999399994],
            [21.188309998000022, -32.50304999499997],
            [21.269479997000076, -32.45029000099993],
            [21.303010011000026, -32.402440001999935],
            [21.40839999700006, -32.368769999999984],
            [21.475640003000024, -32.33145000199994],
            [21.561809999000047, -32.314730001999976],
            [21.536010000000033, -32.22922000999995],
            [21.64457999800004, -32.20871000099993],
            [21.691649995000034, -32.24857000199995],
            [21.73589000000004, -32.20502000099998],
            [21.78061999700003, -32.25092999999998],
            [21.855109998000046, -32.275509994999936],
            [21.92460000600005, -32.26196000099998],
            [21.936205003000055, -32.22288000399993],
            [21.995920002000048, -32.20298000399998],
            [22.016439990000038, -32.11425999499994],
            [22.069560000000024, -32.08144999899997],
            [22.094980004000035, -32.00105999899995],
            [22.07133000300007, -31.939299996999978],
            [22.101439998000046, -31.898719994999965],
            [22.166599999000027, -31.893089998999983],
            [22.20401000000004, -31.76403000199997],
            [22.049580002000027, -31.76997999899993],
            [21.915515003000053, -31.645715000999928],
            [21.949710001000028, -31.600979996999968],
            [22.01165999500006, -31.590449999999976],
            [21.961949997000033, -31.512200003999965],
            [21.865479994000054, -31.49732000499995],
            [21.849879997000073, -31.45643999799995],
            [21.880160001000036, -31.399520003999953],
            [21.822829999000078, -31.35351000099996],
            [21.76240000300004, -31.27140000099996],
            [21.614755002000038, -31.24990099799993],
            [21.621859994000033, -31.15135999399996],
            [21.702214997000056, -31.164755001999936],
            [21.670689993000053, -31.09759999099998],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC066' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.75470000000007, -28.52878000399994],
            [23.767250000000047, -28.47146999299997],
            [23.828049990000068, -28.39098000299998],
            [23.81438000000003, -28.333800002999965],
            [23.891420002000075, -28.12594000599995],
            [23.79066000200004, -28.082849995999936],
            [23.834599996000065, -28.015079999999955],
            [23.580930004000038, -27.879310000999965],
            [23.443899998000063, -27.955179999999928],
            [23.416550002000065, -27.915849997999942],
            [23.362025980000055, -27.942167130999962],
            [23.441180006000025, -28.085999994999952],
            [23.523630001000072, -28.095299999999952],
            [23.442049997000026, -28.203040004999934],
            [23.398839991000045, -28.282359999999983],
            [23.388720001000024, -28.371629989999974],
            [23.56819000300004, -28.449910000999978],
            [23.54312900000008, -28.517288002999976],
            [23.706969999000023, -28.58772000099998],
            [23.75470000000007, -28.52878000399994],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC086' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.00336000200008, -25.38999000399997],
            [26.760519996000028, -25.359200002999955],
            [26.687510002000067, -25.393569997999975],
            [26.648690002000023, -25.44761000099993],
            [26.652760003000026, -25.522289998999952],
            [26.60825999700006, -25.524379996999983],
            [26.59473900100005, -25.46985000199993],
            [26.53544000000005, -25.469649997999966],
            [26.506016002000024, -25.501890998999954],
            [26.511230003000037, -25.65521999999993],
            [26.462370000000078, -25.745369995999965],
            [26.580030006000072, -25.782679995999956],
            [26.643680003000043, -25.837984998999957],
            [26.643529998000076, -25.868000000999928],
            [26.77055000200005, -25.95232999999996],
            [26.76358000400006, -25.991090009999937],
            [26.807079999000052, -26.084029998999938],
            [26.84792999900003, -26.059699998999974],
            [26.974799999000027, -26.065050000999975],
            [27.053780004000032, -26.10068999899994],
            [27.142029999000044, -26.10068999899994],
            [27.169850000000054, -26.080229996999947],
            [27.165166000000056, -25.992083996999952],
            [27.18817400300003, -25.931308996999974],
            [27.17379999900004, -25.884939997999936],
            [27.20817000200003, -25.85476999699995],
            [27.132670001000065, -25.80929999799997],
            [27.119770999000025, -25.752234002999955],
            [27.16710000100005, -25.720329996999965],
            [27.158510000000035, -25.668479997999953],
            [27.01506000200004, -25.46314999599997],
            [27.00336000200008, -25.38999000399997],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW374' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.88141577600004, -29.777029720999963],
            [19.659080006000067, -29.793019999999956],
            [19.574820000000045, -29.72529000299994],
            [19.610899998000036, -29.68085999599998],
            [19.585969998000053, -29.609920000999978],
            [19.76216999600007, -29.58204000199993],
            [19.766989996000063, -29.539970000999972],
            [19.74025000200004, -29.428609989999984],
            [19.65699000500007, -29.32103000199993],
            [19.60131999600003, -29.27185000099996],
            [19.576690000000042, -29.09468199899993],
            [19.681050007000067, -28.99260000199996],
            [19.779510006000066, -28.87642000699998],
            [19.666229997000073, -28.82979000399996],
            [19.61911000400005, -28.690560009999956],
            [19.509289998000042, -28.596540000999937],
            [19.489680003000046, -28.681990000999974],
            [19.405399998000064, -28.73625999999996],
            [19.269790002000036, -28.74202999599993],
            [19.239820002000044, -28.805799999999977],
            [19.284870002000048, -28.90855999599995],
            [19.22988000600003, -28.912279997999974],
            [19.196660003000034, -28.947019998999963],
            [19.118289996000044, -28.969439998999974],
            [19.005929999000045, -28.924270003999936],
            [18.98360999500005, -28.878840002999937],
            [18.93564000400005, -28.857239995999976],
            [18.728670004000037, -28.83170000299998],
            [18.532780006000053, -28.868249998999943],
            [18.51208000400004, -28.88948000399995],
            [18.54304000600007, -28.961600001999955],
            [18.606329997000046, -28.964029996999955],
            [18.619520005000027, -29.01807000499997],
            [18.595510002000026, -29.138489997999955],
            [18.642949998000063, -29.218010000999982],
            [18.63228000600003, -29.354069996999954],
            [18.651000003000036, -29.421729995999954],
            [18.74867000000006, -29.418060000999958],
            [18.776649517000067, -29.48357621799994],
            [18.761089325000057, -29.675640105999946],
            [18.799179077000076, -29.76052093499993],
            [18.808450699000048, -29.83167076099994],
            [18.86706924400005, -29.845760344999974],
            [18.859159470000066, -29.94660949699994],
            [18.908290863000047, -30.063850402999947],
            [19.011909485000047, -30.074069976999965],
            [19.010570526000038, -30.164569854999968],
            [19.091310501000066, -30.30965995799994],
            [19.083110653000062, -30.342430426999954],
            [19.135780000000068, -30.37691999499998],
            [19.187160005000067, -30.298500005999983],
            [19.298139999000057, -30.25407999899994],
            [19.368379996000044, -30.296359999999936],
            [19.533789999000078, -30.316980004999948],
            [19.65014999500005, -30.37897000499993],
            [19.752279998000063, -30.394199998999966],
            [19.80409999500006, -30.38556000099993],
            [20.002280002000077, -30.279270004999944],
            [20.02635000300006, -30.238669994999952],
            [19.878073176000044, -30.228297167999983],
            [19.839409490000037, -30.14641333399993],
            [19.888157084000056, -30.093689299999937],
            [19.846224647000042, -30.03267587299996],
            [19.760719851000033, -30.021520489999943],
            [19.746426859000053, -29.980047491999983],
            [19.81688524300006, -29.952238611999974],
            [19.786281221000024, -29.87555758299993],
            [19.88141577600004, -29.777029720999963],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC067' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.123329994000073, -28.76320000299995],
            [22.09886000000006, -28.70975001299996],
            [22.045949997000037, -28.681650005999984],
            [21.926629994000052, -28.520519999999976],
            [21.90071000000006, -28.425209999999936],
            [21.837610093000023, -28.38274006399996],
            [21.786999999000045, -28.50508999699997],
            [21.738519995000047, -28.47525000099995],
            [21.70155999800005, -28.512470002999976],
            [21.65343999600003, -28.50586999899997],
            [21.609987000000046, -28.551045001999967],
            [21.531649999000024, -28.563430000999972],
            [21.34179999400004, -28.631930000999944],
            [21.260460005000027, -28.711480002999963],
            [21.125769997000077, -28.831600006999963],
            [21.139804997000056, -28.863139993999937],
            [21.251049996000063, -28.930944996999983],
            [21.211321918000067, -29.00890848699993],
            [21.308571252000036, -29.06743649799995],
            [21.301664241000026, -29.154666990999942],
            [21.182412257000067, -29.25857309299994],
            [21.274170001000073, -29.35798000699998],
            [21.24951999900003, -29.404230000999974],
            [21.27092000500005, -29.46521999899994],
            [21.226200104000043, -29.523880004999967],
            [21.19539999400007, -29.63724999699997],
            [21.27559999500005, -29.687159994999945],
            [21.27204000300003, -29.736279998999976],
            [21.154130002000045, -29.872619999999984],
            [21.305260006000026, -29.980409994999945],
            [21.242980001000035, -30.039089993999937],
            [21.371340002000068, -30.017459995999957],
            [21.425669999000036, -29.98637999899995],
            [21.507410005000054, -30.031300002999956],
            [21.575279997000052, -30.04440999899998],
            [21.59218000000004, -30.01155999699995],
            [21.694749994000063, -29.99543999699995],
            [21.832669999000075, -30.02786999799997],
            [21.914559999000062, -29.99111000199997],
            [21.938354994000065, -30.024279999999976],
            [22.014210001000038, -30.005780001999938],
            [21.99435999900004, -29.953810002999944],
            [22.010350005000078, -29.90244000499996],
            [21.81141999400006, -29.84196000299994],
            [21.721610000000055, -29.77482000699996],
            [21.778920004000042, -29.66596001299996],
            [21.829969998000024, -29.62319000599996],
            [21.784930006000025, -29.556609996999953],
            [21.89981999400004, -29.44913000599996],
            [21.845669998000062, -29.395889998999962],
            [21.910980000000052, -29.35385000499997],
            [21.979309998000076, -29.277759998999954],
            [21.83810815000004, -29.097364179999943],
            [21.95861999600004, -29.015709998999967],
            [21.990960001000076, -28.94607000299993],
            [22.086310000000026, -28.950620004999962],
            [22.11699999500007, -29.012050002999956],
            [22.217938996000044, -29.098789993999958],
            [22.21206999700007, -29.049899997999944],
            [22.166950000000043, -29.01568999999995],
            [22.17997999800008, -28.97464999999994],
            [22.142559995000056, -28.914550006999946],
            [22.041870001000063, -28.839910001999954],
            [22.123329994000073, -28.76320000299995],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC084' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.75467999700004, -31.485959996999952],
            [28.65908999900006, -31.449470000999952],
            [28.527210000000025, -31.49379999699994],
            [28.405019996000078, -31.50287999799997],
            [28.38231999900006, -31.48055000499994],
            [28.38126500100003, -31.48000000099995],
            [28.38110000300003, -31.558009996999942],
            [28.309010002000036, -31.618319996999958],
            [28.312089998000033, -31.688650002999964],
            [28.344140003000064, -31.716959995999957],
            [28.32386000100007, -31.790759999999977],
            [28.351969998000072, -31.828649999999982],
            [28.427450011000076, -31.870229996999967],
            [28.46518999700004, -31.96782000199994],
            [28.597819996000055, -31.97172999999998],
            [28.661100004000048, -32.00916000299998],
            [28.71277000300006, -32.007660001999966],
            [28.782199997000077, -32.045999999999935],
            [28.86751999300003, -31.960290001999965],
            [28.925870003000057, -31.94461999899994],
            [29.09341000300003, -32.05934999799996],
            [29.186300001000063, -31.949629997999978],
            [29.09648000100003, -31.87912999799994],
            [28.949460000000045, -31.835159999999973],
            [28.887910000000034, -31.757210000999976],
            [28.90588000400004, -31.72078000199997],
            [28.820739999000068, -31.686599996999973],
            [28.837849998000024, -31.626180000999966],
            [28.812939999000037, -31.50752999799994],
            [28.75467999700004, -31.485959996999952],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC157' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.22901000300004, -33.87834999699993],
            [23.076460000000054, -33.80858000199993],
            [22.876550004000023, -33.815959996999936],
            [22.800279998000065, -33.84118000299998],
            [22.77744000000007, -33.92754999999994],
            [22.72685000000007, -33.92477999999994],
            [22.717550000000074, -33.99856999999997],
            [22.770545002000063, -34.02744999899994],
            [22.970259997000028, -34.08607000799998],
            [23.164119998000047, -34.08305000099995],
            [23.168739996000056, -34.006250001999945],
            [23.21071000300003, -33.96288999899997],
            [23.22901000300004, -33.87834999699993],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC048' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.74124000000006, -29.226039999999955],
            [25.611300003000053, -29.22368000199998],
            [25.562775955000063, -29.20628047799994],
            [25.551490001000047, -29.284109987999955],
            [25.48107000300007, -29.30731999799997],
            [25.480219996000073, -29.360870001999956],
            [25.51446999700005, -29.396549999999934],
            [25.487039997000068, -29.558379999999943],
            [25.39433999700003, -29.637959999999964],
            [25.334260004000043, -29.663089998999965],
            [25.290639999000064, -29.594160003999946],
            [25.200680000000034, -29.624979999999937],
            [25.163710003000062, -29.533950001999983],
            [25.099810003000073, -29.565179995999983],
            [25.013330000000053, -29.635550002999935],
            [24.953770001000066, -29.647430002999954],
            [24.955760002000034, -29.788019996999935],
            [24.975579999000047, -29.914909999999963],
            [24.89881000300005, -29.92291000399996],
            [24.90252291300004, -29.97609924099993],
            [24.86915016200004, -30.025550841999973],
            [24.798487668000064, -30.03417014699994],
            [24.86768999700007, -30.130939997999974],
            [24.90156000500008, -30.208240003999947],
            [24.950169006000067, -30.224845002999928],
            [24.98631999500003, -30.289969996999957],
            [25.034980005000023, -30.286870008999983],
            [25.035619999000062, -30.34420999799994],
            [25.09371999700005, -30.37145999699993],
            [25.151909997000075, -30.45729999699995],
            [25.23710999900004, -30.50122999299998],
            [25.307119999000065, -30.57707999799993],
            [25.376580002000026, -30.55988999699997],
            [25.467099997000048, -30.624210010999946],
            [25.556280000000072, -30.61662999999993],
            [25.60308999700004, -30.594389999999976],
            [25.63086000000004, -30.65934999999996],
            [25.700139996000075, -30.679509999999937],
            [25.778900001000068, -30.67587999999995],
            [25.799829998000064, -30.63479000199993],
            [25.851229999000054, -30.62933000399994],
            [25.973089990000062, -30.53938999299993],
            [26.097999999000024, -30.516500005999944],
            [26.162559999000052, -30.483489996999936],
            [26.193830002000027, -30.52797999699993],
            [26.259649999000032, -30.540720000999954],
            [26.280609999000035, -30.57835999799994],
            [26.323570003000043, -30.502430001999983],
            [26.259029999000063, -30.426419996999982],
            [26.25497000400003, -30.38722999199996],
            [26.202160002000028, -30.334880002999967],
            [26.14298999700003, -30.307850002999942],
            [26.167120000000068, -30.272320001999958],
            [26.144799998000053, -30.166320002999953],
            [26.20313000300007, -30.086300001999973],
            [26.26020000400007, -30.03568000399997],
            [26.19140999900003, -29.93883999999997],
            [26.25246000100003, -29.87956999599993],
            [26.250320007000028, -29.83436999299994],
            [26.310709985000074, -29.778429994999954],
            [26.38681000200006, -29.74058999999994],
            [26.42430999900006, -29.661220000999947],
            [26.38225999900004, -29.61614000399993],
            [26.285309993000055, -29.59818999199996],
            [26.284100008000053, -29.525069993999978],
            [26.22419000900004, -29.47957999399995],
            [26.163440000000037, -29.46777999699998],
            [26.07777000300007, -29.47969000599994],
            [26.032304999000075, -29.41709499899997],
            [25.95942000200006, -29.36545999699996],
            [26.023510007000027, -29.33931999699996],
            [25.992639989000054, -29.27310999799994],
            [25.914850001000048, -29.306079997999973],
            [25.905540001000077, -29.254309999999975],
            [25.84150000300008, -29.232280000999936],
            [25.74124000000006, -29.226039999999955],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS162' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.499620832000062, -33.77845492599994],
            [24.290979996000033, -33.71189999999996],
            [24.26291999800003, -33.74431499999997],
            [24.187689996000074, -33.764760000999956],
            [24.057160002000046, -33.72594000099997],
            [24.060740003000035, -33.69838999899997],
            [23.842809996000028, -33.65044999799994],
            [23.76049000200004, -33.60931999999997],
            [23.72229000300007, -33.61748999699995],
            [23.61687000300003, -33.570239998999966],
            [23.674980000000062, -33.62587001199995],
            [23.670440004000056, -33.67255999799994],
            [23.555529998000054, -33.67295999799995],
            [23.54127000400007, -33.699539999999956],
            [23.43994000200007, -33.717390000999956],
            [23.395039996000037, -33.79263999899996],
            [23.468049999000073, -33.80747999999994],
            [23.517920004000075, -33.78562000299996],
            [23.65522999800004, -33.88738999699996],
            [23.647020000000055, -33.98055999999997],
            [23.846519999000066, -34.02708999999993],
            [24.193609999000046, -34.066030001999934],
            [24.323920001000033, -34.103380002999984],
            [24.38194999700005, -34.10308000099997],
            [24.444949999000073, -34.14358999899997],
            [24.51490000000007, -34.11078999999995],
            [24.62037999900008, -34.01379000099996],
            [24.494579999000052, -33.95100999899995],
            [24.517700000000048, -33.88763000199998],
            [24.57730999900008, -33.898549998999954],
            [24.632519999000067, -33.87440999699993],
            [24.661859998000068, -33.80725000199993],
            [24.499620832000062, -33.77845492599994],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC109' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.235029991000033, -33.83690000099995],
            [25.081420003000062, -33.78668000299996],
            [24.97553000000005, -33.71649000299993],
            [24.829460003000065, -33.64256999699995],
            [24.730740001000072, -33.62038000199993],
            [24.53532000000007, -33.66285999999997],
            [24.536700000000053, -33.72649999999993],
            [24.499620832000062, -33.77845492599994],
            [24.661859998000068, -33.80725000199993],
            [24.632519999000067, -33.87440999699993],
            [24.57730999900008, -33.898549998999954],
            [24.517700000000048, -33.88763000199998],
            [24.494579999000052, -33.95100999899995],
            [24.62037999900008, -34.01379000099996],
            [24.51490000000007, -34.11078999999995],
            [24.444949999000073, -34.14358999899997],
            [24.599060000000065, -34.18793000199997],
            [24.65895000300003, -34.174910000999944],
            [24.827279997000062, -34.211150001999954],
            [24.842940002000034, -34.141580001999955],
            [24.921540004000065, -34.078840000999946],
            [24.93680000100005, -34.005540002999965],
            [25.07785000000007, -33.964749998999935],
            [25.221490003000042, -33.97076999999996],
            [25.200819999000032, -33.899209998999936],
            [25.235029991000033, -33.83690000099995],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC108' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.47476994400006, -29.25055006499997],
            [31.41535999100006, -29.225680044999933],
            [31.369890000000055, -29.248049999999978],
            [31.33246000300005, -29.210579965999955],
            [31.31832098900003, -29.15002999999996],
            [31.288724944000023, -29.16400993999997],
            [31.234284944000024, -29.180706939999936],
            [31.25604994400004, -29.245400064999956],
            [31.16599294400004, -29.25839093999997],
            [31.152559944000075, -29.325864939999974],
            [31.182687944000065, -29.352972939999972],
            [31.05069994300004, -29.48628006499996],
            [31.094409943000073, -29.538089939999963],
            [31.135839943000065, -29.501130064999984],
            [31.18312994400003, -29.528020064999964],
            [31.185754944000053, -29.57178493999993],
            [31.22351994400003, -29.536579939999967],
            [31.34081994400003, -29.382049939999945],
            [31.47476994400006, -29.25055006499997],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN292' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [21.432109997000055, -32.75672999699998],
            [21.426580004000073, -32.66712999799995],
            [21.35224000100004, -32.65772999899997],
            [21.25053000300005, -32.547910000999934],
            [21.188309998000022, -32.50304999499997],
            [21.14011000200003, -32.58976999399994],
            [21.156979997000064, -32.62893999399995],
            [21.06028999600005, -32.65550000199994],
            [20.962780000000066, -32.639299996999966],
            [20.84410000400004, -32.66243999499994],
            [20.792200000000037, -32.73503001199998],
            [20.832430000000045, -32.81737000299995],
            [20.798560000000066, -32.89474999999993],
            [20.731170002000056, -32.944994994999945],
            [20.59210000400003, -32.92646999899995],
            [20.561230000000023, -32.880969998999944],
            [20.499299989000065, -32.941629992999935],
            [20.43859999500006, -32.940060003999974],
            [20.383750003000046, -33.03627999999998],
            [20.302549999000064, -33.067999992999944],
            [20.306440000000066, -33.15933999899994],
            [20.202179999000066, -33.17010999799993],
            [20.257969999000068, -33.18844999099997],
            [20.235620002000076, -33.26241999699994],
            [20.251180001000023, -33.29151000099995],
            [20.209170001000075, -33.379799996999964],
            [20.368039999000075, -33.36626999999993],
            [20.335609990000023, -33.42564000099998],
            [20.336220000000026, -33.48781999099998],
            [20.49801999700003, -33.463870002999954],
            [20.547599998000067, -33.51951999599993],
            [20.762000002000036, -33.490839989999984],
            [20.921800000000076, -33.43065000099995],
            [21.00971000100003, -33.43926999599995],
            [21.43310000200006, -33.39417000299994],
            [21.521819993000065, -33.41440999699995],
            [21.611950001000025, -33.39679999999993],
            [21.62895999400007, -33.30542999199997],
            [21.637269998000022, -33.14128000299996],
            [21.578090002000067, -33.11589000299995],
            [21.48345000000006, -33.013909997999974],
            [21.442850002000057, -33.00051000199994],
            [21.395930001000067, -32.937919997999984],
            [21.478480002000026, -32.902299995999954],
            [21.43005000100004, -32.84901999899995],
            [21.432109997000055, -32.75672999699998],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC051' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.547599998000067, -33.51951999599993],
            [20.49801999700003, -33.463870002999954],
            [20.336220000000026, -33.48781999099998],
            [20.24153099700004, -33.53804599699998],
            [20.173060001000067, -33.52624699699993],
            [20.125414309000064, -33.55628514099993],
            [19.992483868000022, -33.556838168999946],
            [19.91710001100006, -33.51927000099994],
            [19.83878999700005, -33.56594999799995],
            [19.79846999700004, -33.53789999799994],
            [19.637590002000024, -33.536550001999956],
            [19.645191003000036, -33.604601000999935],
            [19.69963000100006, -33.63793000199996],
            [19.70207000100004, -33.71842998899996],
            [19.659639997000056, -33.77508999999998],
            [19.681389998000043, -33.79936999999995],
            [19.532279998000035, -33.878429998999934],
            [19.54539999800005, -33.91564999899998],
            [19.506889998000077, -33.97169999999994],
            [19.589830000000063, -34.01236000299997],
            [19.680660002000025, -34.009140000999935],
            [19.700139997000065, -34.046400001999984],
            [19.986540003000073, -34.07817000199998],
            [20.007460002000073, -34.09391999899998],
            [20.008499998000048, -34.06390000999994],
            [20.14169000000004, -34.05921000099994],
            [20.19609000300005, -34.03999999699994],
            [20.221800001000076, -34.11110000899998],
            [20.29133999900006, -34.09129999999993],
            [20.290759999000045, -34.041939998999965],
            [20.324430000000064, -33.94957000299996],
            [20.436040003000073, -33.95774000799997],
            [20.468250003000037, -33.880289998999956],
            [20.43534999900004, -33.82639999999998],
            [20.472821000000067, -33.72916899699993],
            [20.469152004000023, -33.681952001999946],
            [20.503258997000046, -33.63700000199998],
            [20.574350000000038, -33.538760002999936],
            [20.547599998000067, -33.51951999599993],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC026' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.842960000000062, -26.799460003999968],
            [29.869910007000044, -26.65014999999994],
            [29.82264400200006, -26.669365995999954],
            [29.640350003000037, -26.62790999899994],
            [29.61916999500005, -26.52905999799998],
            [29.568310001000043, -26.56155000299998],
            [29.486830000000054, -26.55331000299998],
            [29.456320004000077, -26.59155000399994],
            [29.459380003000035, -26.64670999699996],
            [29.32549000000006, -26.66126000099996],
            [29.29099799200003, -26.64005999799997],
            [29.22379999900005, -26.658330002999946],
            [29.24139999700003, -26.716839999999934],
            [28.99120000000005, -26.685969996999972],
            [28.99211000400004, -26.608889999999974],
            [28.897497628000053, -26.62397787699996],
            [28.93213999900007, -26.71104999599993],
            [28.88269999700003, -26.75741000299996],
            [28.921739996000042, -26.797610000999953],
            [28.917940002000023, -26.843039999999974],
            [28.851600003000044, -26.923019998999962],
            [28.854440002000047, -26.97061999899995],
            [28.911099997000065, -27.01854000299994],
            [28.967530001000057, -26.991459995999946],
            [29.015141792000065, -27.00995693699997],
            [29.05723000000006, -27.00929999899995],
            [29.061030001000063, -27.07175000199993],
            [29.136369999000067, -27.154220002999978],
            [29.22980999400005, -27.16722999899997],
            [29.331470000000024, -27.21010000299998],
            [29.33958000000007, -27.252730001999964],
            [29.418859999000063, -27.254519999999957],
            [29.49258000100008, -27.19468999299994],
            [29.55040000300005, -27.18561000099993],
            [29.572769996000034, -27.105379995999954],
            [29.620230004000064, -27.074550002999956],
            [29.665229999000076, -26.943229998999982],
            [29.657430000000033, -26.86930000199993],
            [29.750240004000034, -26.83184999499997],
            [29.798540012000046, -26.848449997999978],
            [29.842960000000062, -26.799460003999968],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP305' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.830239996000046, -27.566190002999974],
            [25.834820001000026, -27.51179000099995],
            [25.75372000300007, -27.53448999799997],
            [25.73867000000007, -27.469160000999977],
            [25.804979996000043, -27.446359996999945],
            [25.797030000000063, -27.390649998999947],
            [25.824801989000036, -27.363042002999975],
            [25.77230000000003, -27.209251999999935],
            [25.674375057000077, -27.222110529999952],
            [25.646509998000056, -27.271070003999967],
            [25.683379998000078, -27.336409999999944],
            [25.570959998000035, -27.373369998999976],
            [25.46993999600005, -27.391249994999953],
            [25.272590001000026, -27.40545999699998],
            [25.25516000400006, -27.45063000199997],
            [25.188980000000072, -27.448070000999962],
            [25.146449999000026, -27.533039995999957],
            [25.094339999000056, -27.462959999999953],
            [25.015900000000045, -27.492889996999963],
            [25.006389997000042, -27.524169997999934],
            [25.08783999600007, -27.657509996999977],
            [25.047909998000023, -27.69973999599995],
            [24.829840000000047, -27.931289999999933],
            [24.847410723000053, -27.957974664999938],
            [24.950559998000074, -28.11313999999993],
            [25.028080000000045, -28.07348000199994],
            [25.074650009000038, -28.064249995999944],
            [25.09060000200003, -27.984029998999972],
            [25.20094000100005, -27.886589998999966],
            [25.277410003000057, -27.795319995999932],
            [25.323529997000037, -27.793790000999934],
            [25.364029997000046, -27.750540000999933],
            [25.47943000300006, -27.69338000099998],
            [25.55583000200005, -27.686659997999982],
            [25.596609999000066, -27.65506999699994],
            [25.657800000000066, -27.69485999699998],
            [25.677420002000076, -27.630789996999965],
            [25.830239996000046, -27.566190002999974],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW396' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.321530000000052, -24.12969000099997],
            [30.294890001000056, -24.09587000299996],
            [30.23826000100007, -24.139269998999964],
            [30.215620001000048, -24.085699998999928],
            [30.074549997000076, -24.01201999699998],
            [30.043104998000047, -23.972489997999958],
            [29.997470001000067, -24.000659999999982],
            [29.86374999900005, -23.95138000099996],
            [29.810139998000068, -23.96854999699997],
            [29.82726000300005, -24.040580000999967],
            [29.735890003000065, -24.107239997999955],
            [29.59651999600004, -24.18110998999998],
            [29.446100001000048, -24.240659998999945],
            [29.332289996000043, -24.296910002999937],
            [29.266469999000037, -24.28388000399997],
            [29.232960001000038, -24.234430002999943],
            [29.18896999900005, -24.256940002999954],
            [29.147989997000025, -24.22377999799994],
            [29.07267000400003, -24.20644999899997],
            [29.032040003000077, -24.247829999999965],
            [29.06316000000004, -24.29984000199994],
            [29.050850007000065, -24.37110999899994],
            [29.112219999000047, -24.374110001999952],
            [29.230420004000052, -24.337659997999936],
            [29.292169999000066, -24.44974000299993],
            [29.334540006000054, -24.55575000099998],
            [29.400489983000057, -24.608530019999932],
            [29.470755001000043, -24.640615002999937],
            [29.48119002100003, -24.605179979999946],
            [29.55023002100006, -24.552119981999965],
            [29.562850022000077, -24.505139982999935],
            [29.613280021000037, -24.459469980999927],
            [29.696560009000052, -24.46678998899995],
            [29.72029000300006, -24.45821000199993],
            [29.769109997000044, -24.272990001999972],
            [30.04109999600007, -24.20681999599998],
            [30.06775999900003, -24.23697999899997],
            [30.139430004000076, -24.247240002999945],
            [30.177500003000034, -24.304190000999938],
            [30.237589994000075, -24.283440002999953],
            [30.27315999700005, -24.320040002999974],
            [30.366215000000068, -24.283094996999978],
            [30.337189997000053, -24.23403001099996],
            [30.27532999700003, -24.212960006999936],
            [30.361639998000044, -24.16828000199996],
            [30.321530000000052, -24.12969000099997],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM355' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.595938052000065, -23.40472805199994],
            [28.47404000000006, -23.31218999999993],
            [28.413290000000075, -23.351669999999956],
            [28.355540000000076, -23.28344999999996],
            [28.32009000000005, -23.204019999999957],
            [28.353290000000072, -23.18414999999993],
            [28.33707000000004, -23.12283999999994],
            [28.291180000000054, -23.090979999999945],
            [28.25177000000008, -23.10865999999993],
            [28.22434000000004, -23.04932999999994],
            [28.234560000000045, -22.96703999999994],
            [28.147640000000024, -22.916039999999953],
            [28.096936971000048, -22.811053028999936],
            [28.039140004000046, -22.841910006999967],
            [28.036819999000045, -22.913029998999946],
            [27.935290001000055, -22.965570001999936],
            [27.943490000000054, -23.036219998999968],
            [27.92054999800007, -23.067779996999946],
            [27.765299995000078, -23.142420001999938],
            [27.78458000200004, -23.17247999899996],
            [27.741619998000033, -23.230410003999964],
            [27.672009997000032, -23.20047999899998],
            [27.575579998000023, -23.261340003999976],
            [27.563889997000047, -23.34816000099994],
            [27.528649999000038, -23.385269997999956],
            [27.46120999900006, -23.384000002999983],
            [27.427040000000034, -23.42577999599996],
            [27.34881000300004, -23.397520001999965],
            [27.30296000100003, -23.46266000199995],
            [27.19207999500003, -23.49847000099993],
            [27.13405000000006, -23.53663998999997],
            [27.081149998000058, -23.643310002999954],
            [26.999659998000027, -23.65244000299998],
            [27.001056619000053, -23.68903439199994],
            [27.011089325000057, -23.790990828999952],
            [27.10601997400005, -23.90827941899994],
            [27.12767982500003, -23.953420638999944],
            [27.245080948000066, -24.013860702999978],
            [27.318460464000054, -24.028549193999936],
            [27.44191932700005, -24.10434913599994],
            [27.494911694000052, -24.07828224499997],
            [27.538343234000024, -24.16780973799996],
            [27.502357483000026, -24.219268798999963],
            [27.49366569500006, -24.355215072999954],
            [27.513957977000075, -24.41621971099994],
            [27.57467000300005, -24.42819999699998],
            [27.564050000000066, -24.382300002999955],
            [27.648829998000053, -24.35488000099997],
            [27.698289997000074, -24.394199998999966],
            [27.757870008000054, -24.404029999999977],
            [27.818930000000023, -24.34943999999996],
            [27.800519996000048, -24.308380003999957],
            [27.921590002000073, -24.29754000199995],
            [27.99956700300004, -24.308558000999938],
            [28.009690001000024, -24.232670000999974],
            [27.990230002000033, -24.180269996999982],
            [28.12216999800006, -24.17598000399994],
            [28.15887000400005, -24.15757999799996],
            [28.19244999700004, -24.068540000999974],
            [28.23605999600005, -24.005709999999965],
            [28.27964000000003, -23.99290999899995],
            [28.356344996000075, -24.01612999899993],
            [28.41582599900005, -23.99717700399998],
            [28.341249997000034, -23.918999998999936],
            [28.29962000100005, -23.804319998999972],
            [28.258699997000065, -23.78091000099994],
            [28.251760002000026, -23.730359999999962],
            [28.162660000000074, -23.63243999799994],
            [28.166709997000055, -23.508380003999946],
            [28.22142999700003, -23.477190002999976],
            [28.256079998000075, -23.494430001999945],
            [28.383020000000045, -23.438269996999963],
            [28.41600999600007, -23.51561000199996],
            [28.464309996000054, -23.54534001099995],
            [28.540630001000068, -23.469260001999942],
            [28.59164000000004, -23.452079999999967],
            [28.595938052000065, -23.40472805199994],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM362' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.838440003000073, -26.340750001999936],
            [28.805080002000068, -26.30659000199995],
            [28.710120010000026, -26.34124000099996],
            [28.62690000200007, -26.292439996999974],
            [28.622290003000046, -26.24837999799996],
            [28.53053999900004, -26.225309994999975],
            [28.52715000300003, -26.178740003999962],
            [28.51363000400005, -26.22143000099993],
            [28.517879997000023, -26.361959997999975],
            [28.49908000000005, -26.43930000199998],
            [28.45023000200007, -26.440749996999955],
            [28.370294998000077, -26.393630996999946],
            [28.27401000100008, -26.358679997999957],
            [28.271099998000068, -26.41369999999995],
            [28.22039999900005, -26.43628000399997],
            [28.19973000300007, -26.462530000999948],
            [28.27136999700008, -26.50299999799995],
            [28.17946999700007, -26.57937000299995],
            [28.219370001000073, -26.63629999699998],
            [28.28172999900005, -26.67601000299993],
            [28.40009999700004, -26.655044999999973],
            [28.483250001000044, -26.618379999999945],
            [28.641620001000035, -26.507569995999972],
            [28.763910003000035, -26.518009998999958],
            [28.789930001000073, -26.426450002999957],
            [28.861289998000075, -26.398569995999935],
            [28.838440003000073, -26.340750001999936],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'GT423' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.745260002000066, -28.90640000299993],
            [25.625970003000077, -28.893979997999963],
            [25.529370003000054, -28.852530000999934],
            [25.39003999700003, -28.91682000199995],
            [25.33468000000005, -28.894679998999948],
            [25.24056999800007, -28.907160001999955],
            [25.112190000000055, -28.961339996999982],
            [25.085560000000044, -28.907610000999966],
            [25.00593999800003, -28.908099999999934],
            [24.959300002000077, -28.944860003999963],
            [24.86914999800007, -28.89466999299998],
            [24.811040001000038, -28.913079996999954],
            [24.80182700000006, -28.828258003999963],
            [24.691780003000076, -29.025719998999932],
            [24.34662000000003, -29.65592999599994],
            [24.34866000100004, -29.70198999799993],
            [24.411580000000072, -29.79073999999997],
            [24.470020000000034, -29.811780003999957],
            [24.60792999800003, -29.91126000299994],
            [24.667799998000078, -29.906509994999965],
            [24.67129999900004, -29.971449999999948],
            [24.793970003000027, -29.99897999799998],
            [24.798487668000064, -30.03417014699994],
            [24.86915016200004, -30.025550841999973],
            [24.90252291300004, -29.97609924099993],
            [24.89881000300005, -29.92291000399996],
            [24.975579999000047, -29.914909999999963],
            [24.955760002000034, -29.788019996999935],
            [24.953770001000066, -29.647430002999954],
            [25.013330000000053, -29.635550002999935],
            [25.099810003000073, -29.565179995999983],
            [25.163710003000062, -29.533950001999983],
            [25.200680000000034, -29.624979999999937],
            [25.290639999000064, -29.594160003999946],
            [25.334260004000043, -29.663089998999965],
            [25.39433999700003, -29.637959999999964],
            [25.487039997000068, -29.558379999999943],
            [25.51446999700005, -29.396549999999934],
            [25.480219996000073, -29.360870001999956],
            [25.48107000300007, -29.30731999799997],
            [25.551490001000047, -29.284109987999955],
            [25.562775955000063, -29.20628047799994],
            [25.611300003000053, -29.22368000199998],
            [25.74124000000006, -29.226039999999955],
            [25.73134000300007, -29.077020007999977],
            [25.760919999000066, -29.025799998999958],
            [25.719359998000073, -29.006290000999968],
            [25.745260002000066, -28.90640000299993],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS161' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.821660003000034, -24.974580001999982],
            [27.597490003000075, -24.984869999999944],
            [27.594040002000042, -25.029440000999955],
            [27.54359999600007, -25.09587999799993],
            [27.486900001000038, -25.07841999799996],
            [27.490199997000047, -25.197209999999927],
            [27.42797999800007, -25.289660004999973],
            [27.471009997000067, -25.286629999999946],
            [27.521150001000024, -25.341440000999967],
            [27.519299999000054, -25.41993999699997],
            [27.58464000300006, -25.429040001999965],
            [27.619709999000065, -25.475030002999972],
            [27.646519999000077, -25.65016000099996],
            [27.570410004000053, -25.63129000799995],
            [27.501219999000057, -25.637849999999958],
            [27.532289998000067, -25.849960000999943],
            [27.643549999000072, -25.79591999799993],
            [27.684930000000065, -25.875400000999946],
            [27.744549997000036, -25.894620002999943],
            [27.831470000000024, -25.86017299799994],
            [27.898200001000077, -25.859740003999946],
            [27.960169997000037, -25.815989996999974],
            [27.948190000000068, -25.695210003999932],
            [27.98056001200007, -25.632800006999958],
            [27.95763000100004, -25.59261999699993],
            [27.99243999500004, -25.518029999999953],
            [28.03595000400003, -25.470589996999934],
            [27.945639996000068, -25.40670000299997],
            [27.970759997000073, -25.362949989999947],
            [27.913082193000037, -25.312845856999957],
            [27.831360962000076, -25.20962038999994],
            [27.890609995000034, -25.14877999999993],
            [27.86459999500005, -25.080539999999928],
            [27.824360004000027, -25.11088000199993],
            [27.80484000000007, -25.01836000199995],
            [27.821660003000034, -24.974580001999982],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW372' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.109244997000076, -25.70210999799997],
            [26.09541000300004, -25.617779998999936],
            [25.88693999900005, -25.675309996999943],
            [25.845599999000058, -25.66563999799996],
            [25.796552999000028, -25.524967999999944],
            [25.740669999000033, -25.51385000199997],
            [25.62979000100006, -25.53782000299998],
            [25.580879999000047, -25.63879998799996],
            [25.513660007000055, -25.684339997999928],
            [25.339327000000026, -25.769283996999945],
            [25.329000999000073, -25.832097998999927],
            [25.26481586600005, -25.870540888999983],
            [25.406140003000075, -25.954729997999948],
            [25.50102000100003, -26.061799995999934],
            [25.457980003000046, -26.103429999999946],
            [25.486530001000062, -26.21668999999997],
            [25.422349996000037, -26.270750000999953],
            [25.50287999300008, -26.380110000999935],
            [25.54601999700003, -26.32766999599994],
            [25.65525999500005, -26.296639997999932],
            [25.71304000300006, -26.22758000999994],
            [25.766663003000076, -26.085166002999983],
            [25.738300003000063, -26.047219995999967],
            [25.78735000300003, -26.019609996999975],
            [25.801900001000035, -25.90005999599998],
            [25.924569998000038, -25.911579996999933],
            [25.907500000000027, -25.857660002999978],
            [25.98815800400007, -25.865067307999936],
            [26.022920708000072, -25.837961614999983],
            [26.079337389000045, -25.88272286499995],
            [26.115150782000057, -25.830554450999955],
            [26.071660002000044, -25.76797000399995],
            [26.109244997000076, -25.70210999799997],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW383' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.911099997000065, -27.01854000299994],
            [28.81085999800007, -27.038610003999963],
            [28.646920004000037, -26.953039996999962],
            [28.585470052000062, -27.035860016999948],
            [28.549689998000076, -27.04159999999996],
            [28.485850002000063, -26.971109997999974],
            [28.413320002000034, -27.00685999999996],
            [28.312929998000072, -27.036760009999966],
            [28.315930000000037, -27.091210003999947],
            [28.26423999700006, -27.18622000299996],
            [28.28708000100005, -27.204120002999957],
            [28.227359999000043, -27.28761000199995],
            [28.283239998000056, -27.359689996999975],
            [28.250889999000037, -27.497789999999952],
            [28.258040004000065, -27.572180001999982],
            [28.426999996000063, -27.50639999799995],
            [28.511149970000076, -27.59688988399995],
            [28.597549997000044, -27.56243999999998],
            [28.625509237000074, -27.61142924099994],
            [28.674970004000045, -27.590480001999936],
            [28.74292009100003, -27.599048583999945],
            [28.785535812000035, -27.462493895999955],
            [28.880750656000032, -27.44350051899994],
            [28.927360535000048, -27.402475356999958],
            [28.916881561000025, -27.345794677999947],
            [28.967029572000058, -27.280010222999977],
            [29.005649567000034, -27.166900634999934],
            [28.99651908900006, -27.079660415999967],
            [29.015141792000065, -27.00995693699997],
            [28.967530001000057, -26.991459995999946],
            [28.911099997000065, -27.01854000299994],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS205' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.615819999000053, -27.903600000999973],
            [24.62935000300007, -27.994309999999928],
            [24.56281000000007, -28.036220000999947],
            [24.534639003000052, -28.092088995999973],
            [24.547930000000065, -28.11784000299997],
            [24.656249999000067, -28.202390005999973],
            [24.63005000000004, -28.227100005999944],
            [24.697969998000076, -28.27782999699997],
            [24.733319382000047, -28.341136328999937],
            [24.70390999500006, -28.37660000099993],
            [24.726490004000027, -28.449739990999944],
            [24.899329996000063, -28.430469998999968],
            [24.93761998900004, -28.324919989999955],
            [24.890329997000038, -28.31023000099998],
            [24.926679998000054, -28.24689999499998],
            [24.964569994000044, -28.25073999899996],
            [25.028080000000045, -28.07348000199994],
            [24.950559998000074, -28.11313999999993],
            [24.847410723000053, -27.957974664999938],
            [24.775210000000072, -27.994110000999967],
            [24.73283566400005, -27.92022534499995],
            [24.615819999000053, -27.903600000999973],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC093' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.85622999700007, -33.11492000199996],
            [26.825500001000023, -33.03946999999994],
            [26.74819999700003, -33.030940003999945],
            [26.641930006000052, -33.05028999799998],
            [26.630109996000044, -33.00432999999998],
            [26.48500000200005, -32.98181999999997],
            [26.436340003000055, -32.94746000299995],
            [26.274939998000036, -32.93697999899996],
            [26.135669990000054, -32.96016999699998],
            [26.096130001000063, -32.98309000299997],
            [26.021529997000073, -33.081929997999964],
            [25.96258000000006, -33.109969999999976],
            [25.948189998000032, -33.17266000199993],
            [25.970839996000052, -33.23293000099994],
            [26.016490003000058, -33.25040999699996],
            [25.98793999700007, -33.306610002999946],
            [26.063190003000045, -33.33309999599993],
            [26.037439996000046, -33.42363000399996],
            [26.05127000400006, -33.47475999699998],
            [26.12555000100008, -33.492749996999976],
            [26.10971500000005, -33.53468000299995],
            [26.26350000000008, -33.52023999399995],
            [26.329530996000074, -33.52756900099996],
            [26.38071999700003, -33.56256000199994],
            [26.415459997000028, -33.540809999999965],
            [26.547319999000024, -33.551599995999936],
            [26.61773000000005, -33.425029998999946],
            [26.723570003000077, -33.38443000099994],
            [26.719749989000036, -33.35235999899993],
            [26.80180000000007, -33.28460999899994],
            [26.882989998000028, -33.30600999899997],
            [26.968949999000074, -33.267660002999946],
            [26.962560000000053, -33.20239000199996],
            [26.878159998000058, -33.170909997999956],
            [26.85622999700007, -33.11492000199996],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC104' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.32371994300007, -22.653220058999977],
            [30.18847994400005, -22.69361005899998],
            [30.10561994300008, -22.703980058999946],
            [29.985949942000047, -22.69295993399993],
            [29.928169943000057, -22.664810057999944],
            [29.884679943000037, -22.710220058999937],
            [29.798509942000067, -22.758070058999976],
            [29.787879942000075, -22.700420057999963],
            [29.748249943000076, -22.680130058999964],
            [29.61883994200008, -22.65944993399995],
            [29.538529942000025, -22.61510005799994],
            [29.36867994200003, -22.65197005899995],
            [29.308779968000067, -22.60204007799996],
            [29.20935997500004, -22.66278004299994],
            [29.204719984000064, -22.712639956999965],
            [29.244899942000075, -22.735260058999927],
            [29.222919942000033, -22.807430058999955],
            [29.166969942000037, -22.91779005899997],
            [29.18333000000007, -22.973549999999932],
            [29.246350000000064, -22.93838999999997],
            [29.31015000000008, -23.07379999999995],
            [29.251730000000066, -23.107069999999965],
            [29.267809965000026, -23.238640029999942],
            [29.44050997200003, -23.246330029999967],
            [29.427749972000072, -23.280030027999942],
            [29.59185997000003, -23.268260030999954],
            [29.622079970000073, -23.32841002899994],
            [29.616749971000047, -23.396450030999972],
            [29.741869973000064, -23.435250027999928],
            [29.866839981000055, -23.43741001999996],
            [30.03769998200005, -23.33871002199993],
            [30.14675997200004, -23.341400027999953],
            [30.151606737000066, -23.31379967999993],
            [30.159646492000036, -23.256312615999946],
            [30.245272930000056, -23.253729017999945],
            [30.189781400000072, -23.158214874999942],
            [30.23791194300003, -23.12428205899994],
            [30.357790943000055, -23.117338058999962],
            [30.410079943000028, -23.09472005899994],
            [30.355329943000072, -23.027190058999963],
            [30.164799943000048, -22.92501005899993],
            [30.18736994300008, -22.88469005899998],
            [30.205389943000057, -22.78258005899994],
            [30.32371994300007, -22.653220058999977],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM344' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.696560009000052, -24.46678998899995],
            [29.613280021000037, -24.459469980999927],
            [29.562850022000077, -24.505139982999935],
            [29.55023002100006, -24.552119981999965],
            [29.48119002100003, -24.605179979999946],
            [29.470755001000043, -24.640615002999937],
            [29.434069945000033, -24.709770056999957],
            [29.478030018000027, -24.763619981999966],
            [29.63471994400004, -24.80052005999994],
            [29.744279943000038, -24.791230060999965],
            [29.63672994600006, -24.95306005699996],
            [29.685049943000024, -24.932350059999976],
            [29.71831994300004, -25.000330059999953],
            [29.782550021000077, -24.978789983999945],
            [29.88128794800008, -24.977264050999963],
            [29.90509600200005, -24.93239899899993],
            [29.895950021000033, -24.858469983999953],
            [29.934160027000075, -24.81397497699993],
            [30.021230020000075, -24.83914998399996],
            [30.08351002200004, -24.779409980999958],
            [30.119780013000025, -24.699679987999957],
            [30.087270011000044, -24.62058998699996],
            [30.018693683000038, -24.616479676999973],
            [29.990285012000072, -24.580809984999973],
            [29.943590021000034, -24.621719982999934],
            [29.901710021000042, -24.594599982999966],
            [29.776340022000056, -24.60466998199996],
            [29.773490020000054, -24.55074998499998],
            [29.72030002100007, -24.526669982999977],
            [29.696560009000052, -24.46678998899995],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM473' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.50992004400007, -28.26543993699994],
            [29.564000003000046, -28.189130001999956],
            [29.405129998000064, -28.078000001999953],
            [29.380470002000038, -28.12025999599996],
            [29.314459999000064, -28.072810002999972],
            [29.311139998000044, -28.011539999999968],
            [29.27083000400006, -27.99672000399994],
            [29.16113000100006, -28.011769998999966],
            [29.117639997000026, -28.048949997999955],
            [29.006870003000074, -28.02075999999994],
            [28.998910000000024, -28.074540001999935],
            [28.879109997000057, -28.13766998899996],
            [28.76977000100004, -28.12457999999998],
            [28.72764999700007, -28.155810001999953],
            [28.71572999700004, -28.235520002999976],
            [28.65504001000005, -28.251870002999965],
            [28.63140999600006, -28.34299999899997],
            [28.582755000000077, -28.39132499799996],
            [28.58237000200006, -28.449420001999954],
            [28.651800003000062, -28.496539998999936],
            [28.63148000700005, -28.582509997999978],
            [28.682359998000038, -28.590410003999978],
            [28.704609997000034, -28.67130999799997],
            [28.794959997000035, -28.699749999999938],
            [28.807780002000072, -28.770869999999945],
            [28.873626972000068, -28.77071189999998],
            [28.896229979000054, -28.69473998199993],
            [28.942769955000074, -28.650900028999956],
            [28.973990977000028, -28.574560038999948],
            [29.096319970000025, -28.54509003399994],
            [29.134999968000045, -28.566299966999964],
            [29.21624995700006, -28.519049953999968],
            [29.19149997900007, -28.493779977999964],
            [29.248749971000052, -28.42489996699993],
            [29.29009997000003, -28.437890033999963],
            [29.375559977000023, -28.37210997099993],
            [29.50992004400007, -28.26543993699994],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS194' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.665629995000074, -26.96272000099998],
            [25.665810002000057, -26.899133998999957],
            [25.569260001000032, -26.936329997999962],
            [25.492609999000024, -26.917870001999972],
            [25.38267999800007, -26.861659997999936],
            [25.42153999800007, -26.920099999999934],
            [25.349139997000066, -26.952440000999957],
            [25.399110000000064, -27.037699999999973],
            [25.365439998000056, -27.063650002999964],
            [25.324459997000076, -27.01425999199995],
            [25.22257999800007, -27.029270001999976],
            [25.18737000300007, -26.979389991999938],
            [25.10806000200006, -27.017920002999972],
            [25.15361000200005, -27.158729997999956],
            [25.07638999900007, -27.201509993999935],
            [25.007300001000033, -27.093260001999965],
            [24.895249998000054, -27.178990003999957],
            [24.834989997000037, -27.273110003999932],
            [24.777190000000076, -27.333240003999947],
            [24.782400004000067, -27.406860000999927],
            [24.892087678000053, -27.39611040099993],
            [24.91898000200007, -27.459239999999966],
            [24.976990001000047, -27.464519998999947],
            [25.006389997000042, -27.524169997999934],
            [25.015900000000045, -27.492889996999963],
            [25.094339999000056, -27.462959999999953],
            [25.146449999000026, -27.533039995999957],
            [25.188980000000072, -27.448070000999962],
            [25.25516000400006, -27.45063000199997],
            [25.272590001000026, -27.40545999699998],
            [25.46993999600005, -27.391249994999953],
            [25.570959998000035, -27.373369998999976],
            [25.683379998000078, -27.336409999999944],
            [25.646509998000056, -27.271070003999967],
            [25.674375057000077, -27.222110529999952],
            [25.616329999000072, -27.14289999999994],
            [25.68710999700005, -27.09796999899993],
            [25.632190008000066, -26.988569997999946],
            [25.665629995000074, -26.96272000099998],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW393' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.675313944000038, -29.05489306499993],
            [31.529589944000065, -29.056689939999956],
            [31.458979944000077, -28.991679938999937],
            [31.38785994400007, -28.99687993899994],
            [31.37239994400005, -29.05944993999998],
            [31.31832098900003, -29.15002999999996],
            [31.33246000300005, -29.210579965999955],
            [31.369890000000055, -29.248049999999978],
            [31.41535999100006, -29.225680044999933],
            [31.47476994400006, -29.25055006499997],
            [31.57352994400003, -29.165789939999968],
            [31.675313944000038, -29.05489306499993],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN291' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.81813001100005, -28.92713999299997],
            [26.752690010000038, -29.003049992999934],
            [26.71639000400006, -29.072379997999974],
            [26.634340001000055, -29.059649999999976],
            [26.56694999900003, -28.968080003999944],
            [26.517350002000057, -28.98311999999993],
            [26.47193000200008, -28.94802999999996],
            [26.403060004000054, -28.989195003999953],
            [26.33497999900004, -28.901170003999937],
            [26.280670004000058, -28.940369997999937],
            [26.233819998000058, -28.88089999899995],
            [26.165279996000038, -28.854570000999956],
            [26.09992689300003, -28.768368151999937],
            [26.148880017000067, -28.760730578999983],
            [26.09837590500007, -28.66505945399996],
            [26.042539960000056, -28.66661566199997],
            [26.01306594500005, -28.715056066999978],
            [26.02003337800005, -28.799857198999973],
            [25.926540002000024, -28.826529998999945],
            [25.93077999700006, -28.77113000099996],
            [25.87866999700003, -28.760059998999964],
            [25.856310009000026, -28.86763000299993],
            [25.745260002000066, -28.90640000299993],
            [25.719359998000073, -29.006290000999968],
            [25.760919999000066, -29.025799998999958],
            [25.73134000300007, -29.077020007999977],
            [25.74124000000006, -29.226039999999955],
            [25.84150000300008, -29.232280000999936],
            [25.905540001000077, -29.254309999999975],
            [25.914850001000048, -29.306079997999973],
            [25.992639989000054, -29.27310999799994],
            [26.023510007000027, -29.33931999699996],
            [25.95942000200006, -29.36545999699996],
            [26.032304999000075, -29.41709499899997],
            [26.07777000300007, -29.47969000599994],
            [26.163440000000037, -29.46777999699998],
            [26.22419000900004, -29.47957999399995],
            [26.284100008000053, -29.525069993999978],
            [26.285309993000055, -29.59818999199996],
            [26.38225999900004, -29.61614000399993],
            [26.454190005000044, -29.584799997999937],
            [26.551089999000055, -29.571759999999983],
            [26.562070000000062, -29.647920001999978],
            [26.62698000200004, -29.63453000399994],
            [26.660210002000042, -29.726830003999964],
            [26.715499996000062, -29.711219997999933],
            [26.78034000200006, -29.73902000299995],
            [26.733299999000053, -29.84219000099995],
            [26.82395000100007, -29.964710000999958],
            [26.81517001000003, -30.03037999299994],
            [26.946799990000045, -30.108569989999978],
            [26.991300012000067, -30.111849993999954],
            [27.06537998700003, -30.07578999499998],
            [27.091950000000054, -30.026769996999974],
            [27.216360004000023, -29.982970000999956],
            [27.09657999700005, -29.729929995999953],
            [27.013910002000046, -29.661750000999973],
            [27.12743000300003, -29.574670002999937],
            [27.06071000000003, -29.522830001999978],
            [26.998999998000045, -29.519759995999948],
            [26.96291001000003, -29.428039988999956],
            [27.010959998000033, -29.39513999899998],
            [27.06765000300004, -29.441589996999937],
            [27.085640004000027, -29.38566999699998],
            [26.976920000000064, -29.374089998999978],
            [26.942780008000057, -29.315669990999936],
            [26.96328998900003, -29.25693999599997],
            [26.91720999200004, -29.18209999299995],
            [27.051339996000024, -29.070609996999963],
            [26.962429994000047, -29.021940014999927],
            [26.94632000400003, -28.93972000399998],
            [26.81813001100005, -28.92713999299997],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'MAN' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.18630500200004, -28.80526299899998],
            [27.15217000000007, -28.756599999999935],
            [27.04626999900006, -28.769909996999957],
            [27.029680003000067, -28.743889998999975],
            [26.911089997000033, -28.76833000199997],
            [26.85373000000004, -28.886280003999957],
            [26.81813001100005, -28.92713999299997],
            [26.94632000400003, -28.93972000399998],
            [26.962429994000047, -29.021940014999927],
            [27.051339996000024, -29.070609996999963],
            [26.91720999200004, -29.18209999299995],
            [26.96328998900003, -29.25693999599997],
            [26.942780008000057, -29.315669990999936],
            [26.976920000000064, -29.374089998999978],
            [27.085640004000027, -29.38566999699998],
            [27.06765000300004, -29.441589996999937],
            [27.010959998000033, -29.39513999899998],
            [26.96291001000003, -29.428039988999956],
            [26.998999998000045, -29.519759995999948],
            [27.06071000000003, -29.522830001999978],
            [27.12743000300003, -29.574670002999937],
            [27.277870003000032, -29.526259998999933],
            [27.370469997000043, -29.44874999999996],
            [27.472289998000065, -29.318460002999984],
            [27.54762998900003, -29.24636000299995],
            [27.551400004000072, -29.196160001999942],
            [27.61416999900007, -29.16417999999993],
            [27.65024999800005, -29.10998000099994],
            [27.59219999800007, -29.03204999899998],
            [27.527670000000057, -29.01283899699996],
            [27.47835999800003, -28.87330000299994],
            [27.401770002000035, -28.870789999999943],
            [27.268109997000067, -28.838639996999973],
            [27.18630500200004, -28.80526299899998],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS196' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.029826943000046, -28.90152293899996],
            [30.993349943000055, -28.85647993899994],
            [30.91921994300003, -28.908489938999935],
            [30.92207994300003, -28.94841993899996],
            [30.980179943000053, -28.969889938999984],
            [31.02377994300008, -29.078830064999977],
            [30.93671994300007, -29.080199939999943],
            [30.86271994300006, -29.14751006499995],
            [30.984729943000048, -29.22410993999995],
            [30.98118994300006, -29.269259939999984],
            [31.02651006800005, -29.26789993999995],
            [31.088529943000026, -29.34710993999994],
            [31.13716994300006, -29.207599939999966],
            [31.234284944000024, -29.180706939999936],
            [31.288724944000023, -29.16400993999997],
            [31.175409944000023, -29.073129939999944],
            [31.118280068000047, -28.993340063999938],
            [31.125059943000053, -28.958989938999935],
            [31.04917994300007, -28.949120063999942],
            [31.029826943000046, -28.90152293899996],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN294' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.07676000200007, -26.862330004999933],
            [26.00418999900006, -26.855189997999958],
            [25.833310002000076, -26.936159995999958],
            [25.809709999000063, -26.901179998999964],
            [25.665629995000074, -26.96272000099998],
            [25.632190008000066, -26.988569997999946],
            [25.68710999700005, -27.09796999899993],
            [25.616329999000072, -27.14289999999994],
            [25.674375057000077, -27.222110529999952],
            [25.77230000000003, -27.209251999999935],
            [25.824801989000036, -27.363042002999975],
            [25.797030000000063, -27.390649998999947],
            [25.804979996000043, -27.446359996999945],
            [25.73867000000007, -27.469160000999977],
            [25.75372000300007, -27.53448999799997],
            [25.834820001000026, -27.51179000099995],
            [25.830239996000046, -27.566190002999974],
            [25.85260999700006, -27.620979999999975],
            [25.92687999700007, -27.60387000099996],
            [26.002289998000037, -27.648889992999955],
            [26.003179998000064, -27.708049999999957],
            [26.075840000000028, -27.710650002999955],
            [26.055059999000036, -27.670060002999946],
            [26.125510000000077, -27.564780009999936],
            [26.22724000200003, -27.51340999599995],
            [26.22041000300004, -27.47300000399997],
            [26.267750000000035, -27.416309997999974],
            [26.345160001000067, -27.38542999799995],
            [26.423090004000073, -27.40686999899998],
            [26.496769998000048, -27.26495999499997],
            [26.419900003000066, -27.171359996999968],
            [26.390610003000063, -27.180885001999968],
            [26.301089997000076, -27.030529998999953],
            [26.270249997000064, -27.04090999699997],
            [26.22949000400007, -26.96963999999997],
            [26.139579996000066, -26.977389991999928],
            [26.190640002000066, -26.908319997999968],
            [26.129410000000064, -26.86912000199993],
            [26.07676000200007, -26.862330004999933],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW404' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.063430002000075, -24.091459998999937],
            [31.012669998000035, -24.12941999399993],
            [30.940210000000036, -24.053039998999964],
            [30.846260002000065, -24.098319999999944],
            [30.77604999700003, -24.092389998999977],
            [30.675509997000063, -24.14592999699994],
            [30.480120000000056, -23.980880010999954],
            [30.453314593000073, -23.958283071999972],
            [30.380299998000055, -24.06934999899994],
            [30.321530000000052, -24.12969000099997],
            [30.361639998000044, -24.16828000199996],
            [30.27532999700003, -24.212960006999936],
            [30.337189997000053, -24.23403001099996],
            [30.366215000000068, -24.283094996999978],
            [30.40920000400007, -24.333629997999935],
            [30.518180001000076, -24.40563999699998],
            [30.533529998000063, -24.439709997999955],
            [30.758979999000076, -24.460219998999946],
            [30.871709999000075, -24.538500002999967],
            [30.954330011000025, -24.521279999999933],
            [30.95931999900006, -24.582070000999977],
            [31.226180011000054, -24.556010001999937],
            [31.25366000200006, -24.499120000999937],
            [31.159969998000065, -24.37557000199996],
            [31.242029998000078, -24.365430000999936],
            [31.200059999000075, -24.304949991999933],
            [31.05602000500005, -24.32188999699997],
            [31.04993999800007, -24.187319996999975],
            [31.10726999900004, -24.145730000999947],
            [31.120569998000065, -24.090259999999944],
            [31.063430002000075, -24.091459998999937],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM335' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.212212100000045, -28.57798826399994],
            [27.156730001000028, -28.558290002999968],
            [27.187440001000027, -28.482290003999935],
            [27.13731000300004, -28.476670001999935],
            [27.10645999700006, -28.401780002999942],
            [26.949080002000073, -28.382789998999954],
            [26.97855000100003, -28.345160000999954],
            [26.96328999700006, -28.27620000299993],
            [26.885040004000075, -28.22281000199996],
            [26.876839996000058, -28.168945002999976],
            [26.767530003000047, -28.22905000299994],
            [26.74118999800004, -28.285789999999963],
            [26.688859998000055, -28.234640001999935],
            [26.639371002000075, -28.218144002999964],
            [26.60966999900006, -28.30523999199994],
            [26.538000002000047, -28.29099000499997],
            [26.423150001000067, -28.31269999699998],
            [26.434859999000025, -28.368919998999957],
            [26.320170001000065, -28.41966999699997],
            [26.28804000100007, -28.46858999699998],
            [26.219069000000047, -28.468846997999947],
            [26.14789999800007, -28.557899992999978],
            [26.033569999000065, -28.586269998999967],
            [25.976949997000077, -28.615439996999953],
            [25.87866999700003, -28.760059998999964],
            [25.93077999700006, -28.77113000099996],
            [25.926540002000024, -28.826529998999945],
            [26.02003337800005, -28.799857198999973],
            [26.01306594500005, -28.715056066999978],
            [26.042539960000056, -28.66661566199997],
            [26.09837590500007, -28.66505945399996],
            [26.148880017000067, -28.760730578999983],
            [26.09992689300003, -28.768368151999937],
            [26.165279996000038, -28.854570000999956],
            [26.233819998000058, -28.88089999899995],
            [26.280670004000058, -28.940369997999937],
            [26.33497999900004, -28.901170003999937],
            [26.403060004000054, -28.989195003999953],
            [26.47193000200008, -28.94802999999996],
            [26.517350002000057, -28.98311999999993],
            [26.56694999900003, -28.968080003999944],
            [26.634340001000055, -29.059649999999976],
            [26.71639000400006, -29.072379997999974],
            [26.752690010000038, -29.003049992999934],
            [26.81813001100005, -28.92713999299997],
            [26.85373000000004, -28.886280003999957],
            [26.911089997000033, -28.76833000199997],
            [27.029680003000067, -28.743889998999975],
            [27.04626999900006, -28.769909996999957],
            [27.15217000000007, -28.756599999999935],
            [27.18630500200004, -28.80526299899998],
            [27.190079996000065, -28.66763999699998],
            [27.212212100000045, -28.57798826399994],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS181' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.13525000100003, -30.605139977999954],
            [29.19835997000007, -30.46233996899997],
            [29.196769982000035, -30.43439003499998],
            [29.305009976000065, -30.379859949999968],
            [29.301859965000062, -30.320119956999974],
            [29.13716997100005, -30.26233997199995],
            [29.10368997300003, -30.180540035999968],
            [29.117240037000045, -30.10018996799994],
            [29.044949978000034, -30.01296998199996],
            [29.01473997200003, -30.00179996999998],
            [28.985330004000048, -30.031369998999935],
            [28.858790001000045, -30.088229996999928],
            [28.68988999800007, -30.124289998999984],
            [28.667609997000056, -30.140710001999935],
            [28.568249999000045, -30.122860000999935],
            [28.451470002000065, -30.15783999799993],
            [28.365100003000066, -30.168620003999933],
            [28.340290003000064, -30.234610001999954],
            [28.23643000100003, -30.259939996999947],
            [28.268770003000043, -30.37372999699994],
            [28.480840004000072, -30.422299996999982],
            [28.569840000000056, -30.49629000599998],
            [28.540550008000025, -30.588989998999978],
            [28.560369998000056, -30.655260001999977],
            [28.655906997000045, -30.649993001999974],
            [28.699170003000063, -30.582563996999966],
            [28.759363000000064, -30.588210002999972],
            [28.86030099800007, -30.685753998999928],
            [28.924677001000077, -30.68729899599998],
            [28.95614058800004, -30.57247770799995],
            [29.084270282000034, -30.61232883699995],
            [29.13525000100003, -30.605139977999954],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC441' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.38786999900003, -28.214080001999946],
            [27.37005000100004, -28.17026999899997],
            [27.433770001000028, -28.049759995999977],
            [27.363450000000057, -28.001459987999965],
            [27.35898200200006, -27.932452998999963],
            [27.19277999700006, -27.899749998999937],
            [27.15779000200007, -27.93333999799995],
            [27.052500003000034, -27.85931000399995],
            [27.04476999800005, -27.749099996999973],
            [26.969940004000023, -27.69444999899997],
            [26.97448999900007, -27.642909999999972],
            [27.01632999700007, -27.598240000999965],
            [26.950050003000058, -27.522500002999948],
            [26.870359998000026, -27.53378999699993],
            [26.857710002000033, -27.58600000299998],
            [26.83663000000007, -27.622960001999957],
            [26.74193000100007, -27.693630002999953],
            [26.636299999000073, -27.65908000099995],
            [26.560879991000036, -27.724080001999937],
            [26.54876000300004, -27.873959998999965],
            [26.505480001000024, -27.952089996999973],
            [26.509679995000056, -27.993220003999966],
            [26.472630004000052, -28.078289996999956],
            [26.414640001000066, -28.092130002999966],
            [26.408300002000033, -28.123919998999952],
            [26.46707999800003, -28.21218000099998],
            [26.408589997000036, -28.259540002999984],
            [26.423150001000067, -28.31269999699998],
            [26.538000002000047, -28.29099000499997],
            [26.60966999900006, -28.30523999199994],
            [26.639371002000075, -28.218144002999964],
            [26.688859998000055, -28.234640001999935],
            [26.74118999800004, -28.285789999999963],
            [26.767530003000047, -28.22905000299994],
            [26.876839996000058, -28.168945002999976],
            [26.885040004000075, -28.22281000199996],
            [26.96328999700006, -28.27620000299993],
            [26.97855000100003, -28.345160000999954],
            [26.949080002000073, -28.382789998999954],
            [27.10645999700006, -28.401780002999942],
            [27.13731000300004, -28.476670001999935],
            [27.187440001000027, -28.482290003999935],
            [27.156730001000028, -28.558290002999968],
            [27.212212100000045, -28.57798826399994],
            [27.271187403000056, -28.509724881999944],
            [27.288969775000055, -28.457538326999952],
            [27.265908787000058, -28.377004906999957],
            [27.27682999800004, -28.282779998999956],
            [27.326239998000062, -28.22645999899993],
            [27.38786999900003, -28.214080001999946],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS184' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.951480022000055, -30.74443989799994],
            [18.862970352000048, -30.717119216999947],
            [18.794500351000067, -30.667619704999936],
            [18.795869998000057, -30.62486000399997],
            [18.758710861000054, -30.56786918599994],
            [18.65514954100007, -30.556709298999976],
            [18.570120003000056, -30.43025999799994],
            [18.502150001000075, -30.44442000199996],
            [18.483619995000026, -30.52190999499993],
            [18.413759999000035, -30.527349999999956],
            [18.371150003000025, -30.592089999999928],
            [18.37103999900006, -30.659629996999968],
            [18.264169999000046, -30.818319993999978],
            [18.213540000000023, -30.810439991999942],
            [18.169180004000054, -30.848559998999974],
            [18.08917999700003, -30.787869995999984],
            [18.006479003000038, -30.791239995999945],
            [17.99337999900007, -30.91874000399997],
            [17.880299998000055, -30.92393999899997],
            [17.926409999000043, -31.011390002999974],
            [17.81132000100007, -31.09253999999993],
            [17.834419999000033, -31.176519999999982],
            [17.757580003000044, -31.15196999999995],
            [17.877319999000065, -31.27877000199993],
            [17.90044000100005, -31.352060002999963],
            [18.09782999600003, -31.55937999799994],
            [18.222789996000074, -31.74432000099995],
            [18.23358999800007, -31.82071000899998],
            [18.28007999700003, -31.898170000999983],
            [18.265459989000078, -31.934039996999957],
            [18.29026699700006, -32.00665299999997],
            [18.411920003000034, -31.94558999999998],
            [18.395689997000034, -31.873970001999965],
            [18.451599999000052, -31.84381999699997],
            [18.56123999700003, -31.87885999899993],
            [18.62286000000006, -31.95634000299998],
            [18.740900001000057, -31.878890001999935],
            [18.875510003000045, -31.85241999599998],
            [18.981950002000076, -31.85570000399997],
            [19.02622000100007, -31.876639998999963],
            [19.030459997000037, -31.83361999899995],
            [19.08627000200005, -31.794479999999965],
            [19.06556000300003, -31.706309998999984],
            [19.085420003000024, -31.526930000999982],
            [19.01968000100004, -31.499250003999975],
            [19.042989999000042, -31.424969999999973],
            [18.980130002000067, -31.355239989999973],
            [19.013010002000044, -31.305680002999964],
            [18.944460003000074, -31.237319997999975],
            [18.947600004000037, -31.112910003999957],
            [18.903470002000063, -31.041779994999956],
            [18.911770010000055, -30.978929996999966],
            [18.98449000100004, -30.945810002999963],
            [18.875390009000057, -30.887059999999963],
            [18.960470000000043, -30.866109999999935],
            [18.951480022000055, -30.74443989799994],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC011' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.351969998000072, -31.828649999999982],
            [28.263330001000043, -31.791320002999953],
            [28.19468000300003, -31.96641000099993],
            [28.01884885800007, -32.043181292999975],
            [28.06126000200004, -32.06570000299996],
            [28.136500003000037, -32.06173999799995],
            [28.18719000300007, -32.02583999899997],
            [28.25133999800005, -32.068510007999976],
            [28.235070651000058, -32.20815914999997],
            [28.31674000000004, -32.24349999999998],
            [28.438396725000075, -32.34183440399994],
            [28.409342736000042, -32.38941658699997],
            [28.502339636000045, -32.392263997999976],
            [28.55106099300008, -32.42085674699996],
            [28.675563002000047, -32.44858800199995],
            [28.831739997000057, -32.30548000099998],
            [28.882419999000035, -32.27984999699993],
            [28.94644000100004, -32.20481999899994],
            [29.09341000300003, -32.05934999799996],
            [28.925870003000057, -31.94461999899994],
            [28.86751999300003, -31.960290001999965],
            [28.782199997000077, -32.045999999999935],
            [28.71277000300006, -32.007660001999966],
            [28.661100004000048, -32.00916000299998],
            [28.597819996000055, -31.97172999999998],
            [28.46518999700004, -31.96782000199994],
            [28.427450011000076, -31.870229996999967],
            [28.351969998000072, -31.828649999999982],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC121' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.57220004100003, -30.655149972999936],
            [29.543550296000035, -30.647186529999942],
            [29.522201133000067, -30.699014831999932],
            [29.554329989000053, -30.740589996999972],
            [29.53088999700003, -30.812890007999954],
            [29.56229999800007, -30.882500000999983],
            [29.511410002000048, -30.929870007999966],
            [29.609759998000072, -30.983210002999954],
            [29.584300002000077, -31.038030008999954],
            [29.726020000000062, -31.086869999999976],
            [29.76168000200005, -31.11933000399995],
            [29.846460000000036, -31.13512000099996],
            [29.90544999800005, -31.179870001999973],
            [30.047640000000058, -31.24755999699994],
            [30.193859794000048, -31.081260201999953],
            [30.142759983000076, -31.022820026999966],
            [30.146350037000047, -30.931069969999953],
            [30.092709971000033, -30.86222996799995],
            [29.961164980000035, -30.82316997199996],
            [29.94686997200006, -30.76994996999997],
            [29.852609983000036, -30.76160002699993],
            [29.70792995900007, -30.70478996099996],
            [29.675369982000063, -30.669939978999935],
            [29.599509973000067, -30.689519969999935],
            [29.57220004100003, -30.655149972999936],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC443' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.61089389600005, -24.98924693999993],
            [31.564248501000066, -24.96042203299993],
            [31.421579361000056, -24.972740172999977],
            [31.317630768000072, -24.96453094499998],
            [31.24930000300003, -25.018360137999935],
            [31.15310809500005, -25.02240632099995],
            [31.14072748700005, -24.98202324199997],
            [31.060699999000065, -24.99540000299993],
            [31.025230003000047, -25.030099993999954],
            [30.941120004000027, -25.128888003999975],
            [30.917219999000054, -25.20830999599997],
            [30.978155999000023, -25.29015400299994],
            [30.900940002000027, -25.321039995999968],
            [30.88181000000003, -25.38371000199993],
            [30.79067999600005, -25.353310001999944],
            [30.703239998000072, -25.361539995999976],
            [30.629890009000064, -25.28499999899998],
            [30.53197099700003, -25.349590001999957],
            [30.449239999000042, -25.34495999799998],
            [30.442429997000033, -25.38082000299994],
            [30.48011000200006, -25.45239000199996],
            [30.565345999000044, -25.481235995999953],
            [30.534120003000055, -25.53600000299997],
            [30.593709997000076, -25.554130001999965],
            [30.665619998000068, -25.672980000999928],
            [30.64662999500007, -25.71242000899997],
            [30.732650001000025, -25.741350001999933],
            [30.773649999000042, -25.86193999099993],
            [30.823059998000076, -25.876519997999935],
            [30.849860000000035, -25.92634000399994],
            [30.968099997000024, -25.93476000399994],
            [31.03951999900005, -25.86626000299998],
            [31.055690997000056, -25.92392099799997],
            [31.12657000300004, -25.92114999699993],
            [31.263569997000047, -25.80963000299994],
            [31.315939998000033, -25.74304000099994],
            [31.26208000200006, -25.69231999799996],
            [31.33077999900007, -25.608980003999932],
            [31.275849996000034, -25.560240002999933],
            [31.33545000400005, -25.522559997999963],
            [31.48267936700006, -25.496629714999983],
            [31.536829999000076, -25.46408000399998],
            [31.581319809000036, -25.343969344999948],
            [31.627029419000053, -25.272920608999982],
            [31.62281990100007, -25.18737983699998],
            [31.586380005000024, -25.025129317999983],
            [31.61089389600005, -24.98924693999993],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP326' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.579600001000074, -26.60752999899995],
            [27.604370001000063, -26.59196000199995],
            [27.607150003000072, -26.491600000999938],
            [27.557090001000063, -26.456379998999978],
            [27.537280001000056, -26.40585999999996],
            [27.54784999700007, -26.34328000199997],
            [27.48190999800005, -26.28444000099995],
            [27.47151000300005, -26.24495499799997],
            [27.48995700000006, -26.127970998999956],
            [27.46734000400005, -26.09226999899994],
            [27.425220000000024, -26.089389998999934],
            [27.361720000000048, -26.115669998999977],
            [27.291409998000063, -26.144620003999933],
            [27.330071000000032, -26.28181499899995],
            [27.187952000000053, -26.377862998999944],
            [27.22484999900007, -26.44396999999998],
            [27.231421002000047, -26.50548099599996],
            [27.158760003000054, -26.52541999899995],
            [27.182637003000025, -26.574619995999967],
            [27.22835999700004, -26.571050000999946],
            [27.241869998000027, -26.636459999999943],
            [27.378349998000033, -26.610679997999966],
            [27.569090002000053, -26.647160003999943],
            [27.579600001000074, -26.60752999899995],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'GT484' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.000489998000035, -26.703320000999952],
            [27.940960001000064, -26.675899998999967],
            [27.873640003000048, -26.747630000999948],
            [27.716306001000078, -26.761676999999963],
            [27.71045999900008, -26.842270002999953],
            [27.772700003000068, -26.924949995999953],
            [27.802670000000035, -26.997190001999968],
            [27.92860998900005, -26.96601099199995],
            [27.973670000000027, -27.042430001999946],
            [28.065730003000056, -27.046560000999932],
            [28.12675000300004, -27.137859997999954],
            [28.26423999700006, -27.18622000299996],
            [28.315930000000037, -27.091210003999947],
            [28.312929998000072, -27.036760009999966],
            [28.413320002000034, -27.00685999999996],
            [28.392150000000072, -26.93142000299997],
            [28.300429999000073, -26.94016000199997],
            [28.24428000000006, -26.88477999899993],
            [28.119130003000066, -26.889280011999972],
            [28.008180001000028, -26.770149998999955],
            [28.000489998000035, -26.703320000999952],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS204' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.41476794500005, -28.476392938999936],
            [32.30519994500003, -28.51851006399994],
            [32.212189944000045, -28.45894993899998],
            [32.11193994400003, -28.43622993899993],
            [31.990779944000053, -28.388589938999928],
            [31.981432944000062, -28.35041993899995],
            [31.96252994400004, -28.406219938999982],
            [31.811069944000053, -28.431680938999932],
            [31.793650505000073, -28.48310668599993],
            [31.782424409000043, -28.523163242999942],
            [31.829450548000068, -28.569551926999964],
            [31.896699944000034, -28.571540063999976],
            [31.913679944000023, -28.62874506399993],
            [31.95930994400004, -28.664079938999976],
            [32.022419944000035, -28.64644993899998],
            [32.06850994400003, -28.703410063999968],
            [32.14421994400004, -28.702037063999967],
            [32.147119392000036, -28.758805396999946],
            [32.368949945000054, -28.568400063999945],
            [32.41476794500005, -28.476392938999936],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN281' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.641113076000067, -30.772916348999956],
            [28.63861000000003, -30.920929998999952],
            [28.591649998000037, -30.93111000099998],
            [28.57724999800007, -30.992910002999963],
            [28.52592000100003, -31.048859997999955],
            [28.53957999900007, -31.090389995999942],
            [28.600980010000058, -31.088230001999932],
            [28.67548000000005, -31.134970003999968],
            [28.682269998000038, -31.179259999999942],
            [28.61938999800003, -31.236869998999964],
            [28.497800006000034, -31.250270003999958],
            [28.45598999400005, -31.306839998999976],
            [28.49925999800007, -31.33262999899995],
            [28.443980002000046, -31.38646999799994],
            [28.38231999900006, -31.48055000499994],
            [28.405019996000078, -31.50287999799997],
            [28.527210000000025, -31.49379999699994],
            [28.65908999900006, -31.449470000999952],
            [28.75467999700004, -31.485959996999952],
            [28.857829999000046, -31.480310000999964],
            [28.890780002000042, -31.31501000399993],
            [28.979800002000047, -31.28696000399998],
            [29.04294000300007, -31.32214400199996],
            [29.09396399800005, -31.298698000999934],
            [29.155575000000056, -31.319332002999943],
            [29.190579996000054, -31.274674003999962],
            [29.179240003000075, -31.20833999799993],
            [29.13230999600006, -31.09143999899993],
            [29.06473800200007, -31.037947419999966],
            [28.978939997000055, -31.025019997999948],
            [28.905729999000073, -31.077709997999932],
            [28.86458000400006, -31.051410001999955],
            [28.873959998000032, -31.005519998999944],
            [28.836249999000074, -30.941860003999977],
            [28.72983999400003, -30.844120001999954],
            [28.657989997000072, -30.81152999699998],
            [28.641113076000067, -30.772916348999956],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC156' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.067101999000045, -26.34194000399998],
            [27.969980002000057, -26.34170000699993],
            [27.912229996000065, -26.35894999599998],
            [27.869074999000077, -26.44480099799995],
            [27.887210001000028, -26.526250000999937],
            [27.983020000000067, -26.555829996999933],
            [27.962234996000063, -26.644136996999976],
            [28.000489998000035, -26.703320000999952],
            [28.008180001000028, -26.770149998999955],
            [28.119130003000066, -26.889280011999972],
            [28.24428000000006, -26.88477999899993],
            [28.325010001000066, -26.84107000299997],
            [28.319410004000076, -26.79266999699996],
            [28.406850002000056, -26.761710001999973],
            [28.40009999700004, -26.655044999999973],
            [28.28172999900005, -26.67601000299993],
            [28.219370001000073, -26.63629999699998],
            [28.17946999700007, -26.57937000299995],
            [28.27136999700008, -26.50299999799995],
            [28.19973000300007, -26.462530000999948],
            [28.22039999900005, -26.43628000399997],
            [28.076060002000077, -26.415370002999964],
            [28.067101999000045, -26.34194000399998],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'GT422' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.673752943000068, -29.619902064999962],
            [30.61805994300005, -29.549960064999937],
            [30.568739943000026, -29.547399939999934],
            [30.540799943000025, -29.618230064999977],
            [30.491969943000072, -29.625569939999934],
            [30.466039943000055, -29.67220006499997],
            [30.49535994300004, -29.70545993999997],
            [30.399539943000036, -29.748629939999944],
            [30.446469943000068, -29.81063993999993],
            [30.394650796000064, -29.867253956999946],
            [30.493019943000036, -29.899560064999946],
            [30.50305994300004, -29.96643993999993],
            [30.453340068000045, -30.01394006499993],
            [30.509079943000074, -30.034909939999977],
            [30.513780068000074, -30.08713993999993],
            [30.59611407400007, -30.12389829899996],
            [30.675250068000025, -29.92222093999993],
            [30.575999943000056, -29.831499939999958],
            [30.569389943000033, -29.731649939999954],
            [30.58375092400007, -29.654322830999945],
            [30.622169943000074, -29.668349939999928],
            [30.673752943000068, -29.619902064999962],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN226' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.27432998000006, -27.24317002099997],
            [31.150550002000045, -27.202080002999935],
            [31.06132999700003, -27.096290005999947],
            [30.984759997000026, -27.03698000199995],
            [30.958326003000025, -26.99212899799994],
            [30.973559995000073, -26.908210001999976],
            [30.90742000000006, -26.859929998999974],
            [30.88728499900003, -26.803584998999952],
            [30.81321999900007, -26.844480003999934],
            [30.790799998000068, -26.71228999699997],
            [30.800260002000073, -26.504059998999935],
            [30.717919996000035, -26.48579000099994],
            [30.66630199800005, -26.540408998999965],
            [30.629450000000077, -26.505039996999983],
            [30.56106000300008, -26.505720002999965],
            [30.468950001000053, -26.558599999999956],
            [30.56054000100005, -26.66385999599993],
            [30.544490003000078, -26.712350001999937],
            [30.45916999800005, -26.75693999999993],
            [30.340419997000026, -26.774899997999967],
            [30.322750004000056, -26.824240001999954],
            [30.25076000100006, -26.824759995999955],
            [30.24370000300007, -26.85984999599998],
            [30.295749998000076, -27.016160000999946],
            [30.360678009000026, -26.97004899999996],
            [30.39947999900005, -27.021520000999942],
            [30.380580011000063, -27.11703999499997],
            [30.31546000000003, -27.146259999999984],
            [30.328069995000078, -27.183920000999933],
            [30.44848999900006, -27.207199997999965],
            [30.499740002000067, -27.170890000999975],
            [30.566910003000032, -27.16951000299997],
            [30.50226000300006, -27.283549997999955],
            [30.527049997000063, -27.315749989999972],
            [30.587739989000056, -27.322949980999965],
            [30.706799990000036, -27.283289986999932],
            [30.829679989000056, -27.350149981999948],
            [30.922159988000033, -27.305049981999957],
            [30.95578998900004, -27.35970998299996],
            [31.100959988000056, -27.335760020999942],
            [31.14086502400005, -27.362659979999933],
            [31.16586999200007, -27.368520012999966],
            [31.27432998000006, -27.24317002099997],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP303' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.675563002000047, -32.44858800199995],
            [28.55106099300008, -32.42085674699996],
            [28.502339636000045, -32.392263997999976],
            [28.409342736000042, -32.38941658699997],
            [28.438396725000075, -32.34183440399994],
            [28.31674000000004, -32.24349999999998],
            [28.235070651000058, -32.20815914999997],
            [28.25133999800005, -32.068510007999976],
            [28.18719000300007, -32.02583999899997],
            [28.136500003000037, -32.06173999799995],
            [28.06126000200004, -32.06570000299996],
            [28.01884885800007, -32.043181292999975],
            [28.010034442000062, -32.03639166599993],
            [27.950199997000027, -32.08188999999993],
            [27.889110002000052, -32.04975000299993],
            [27.775190001000055, -32.10948000299993],
            [27.812770000000057, -32.183239998999966],
            [27.765019997000024, -32.25881000299995],
            [27.758832939000058, -32.331968064999955],
            [27.893980003000024, -32.45614999999998],
            [27.955580002000033, -32.50652999999994],
            [28.047360000000026, -32.53638000299998],
            [28.14542000000006, -32.50955998899997],
            [28.16893000400006, -32.56817999799995],
            [28.222740001000034, -32.578090000999964],
            [28.38763500300007, -32.67960000199997],
            [28.431509998000024, -32.63318999699993],
            [28.511730003000025, -32.60318999699996],
            [28.615889998000057, -32.49260000299995],
            [28.675563002000047, -32.44858800199995],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC122' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.41582599900005, -23.99717700399998],
            [28.356344996000075, -24.01612999899993],
            [28.27964000000003, -23.99290999899995],
            [28.23605999600005, -24.005709999999965],
            [28.19244999700004, -24.068540000999974],
            [28.15887000400005, -24.15757999799996],
            [28.12216999800006, -24.17598000399994],
            [27.990230002000033, -24.180269996999982],
            [28.009690001000024, -24.232670000999974],
            [27.99956700300004, -24.308558000999938],
            [27.921590002000073, -24.29754000199995],
            [27.800519996000048, -24.308380003999957],
            [27.818930000000023, -24.34943999999996],
            [27.757870008000054, -24.404029999999977],
            [27.698289997000074, -24.394199998999966],
            [27.648829998000053, -24.35488000099997],
            [27.564050000000066, -24.382300002999955],
            [27.57467000300005, -24.42819999699998],
            [27.580939999000066, -24.471110000999943],
            [27.675859998000078, -24.50072999799994],
            [27.70070000100003, -24.59910999599998],
            [27.89511999700005, -24.582679994999978],
            [27.996049999000036, -24.63843000199995],
            [28.09486000000004, -24.63025999699994],
            [28.176136017000033, -24.681600570999933],
            [28.21060999900004, -24.730619997999952],
            [28.276230000000055, -24.751969998999982],
            [28.29210999700007, -24.795669997999937],
            [28.36611800000003, -24.78649399699998],
            [28.50488000000007, -24.87354000299996],
            [28.65762999800006, -24.837700001999963],
            [28.713779997000074, -24.95362000199998],
            [28.759379997000053, -24.91135000099996],
            [28.837390001000074, -24.91600999999997],
            [28.924069974000076, -24.901529977999928],
            [29.05592998000003, -24.912259990999928],
            [29.082879972000057, -24.981209941999964],
            [29.183149963000062, -24.939920040999937],
            [29.229779971000028, -24.81264996599998],
            [29.275580000000048, -24.791369999999972],
            [29.247380000000078, -24.71360999999996],
            [29.369900037000036, -24.663356028999942],
            [29.400489983000057, -24.608530019999932],
            [29.334540006000054, -24.55575000099998],
            [29.292169999000066, -24.44974000299993],
            [29.230420004000052, -24.337659997999936],
            [29.112219999000047, -24.374110001999952],
            [29.050850007000065, -24.37110999899994],
            [29.002900000000068, -24.359040001999972],
            [28.913170007000076, -24.414780002999976],
            [28.801270001000034, -24.331610001999934],
            [28.85087999800004, -24.25673999999998],
            [28.77441000300007, -24.25265000099995],
            [28.74005999800005, -24.206479999999942],
            [28.66531000300006, -24.200009999999963],
            [28.692878603000054, -24.11648151099996],
            [28.578759998000066, -24.05692000199997],
            [28.525850005000052, -24.07546999799996],
            [28.434529997000027, -24.043500001999973],
            [28.41582599900005, -23.99717700399998],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM368' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.969249811000054, -23.59783252699998],
            [28.910059971000067, -23.544460029999982],
            [28.795609971000033, -23.416060028999937],
            [28.73576997200007, -23.330910030999974],
            [28.68511998500003, -23.336130020999974],
            [28.659700001000033, -23.385749998999927],
            [28.595938052000065, -23.40472805199994],
            [28.59164000000004, -23.452079999999967],
            [28.540630001000068, -23.469260001999942],
            [28.464309996000054, -23.54534001099995],
            [28.41600999600007, -23.51561000199996],
            [28.383020000000045, -23.438269996999963],
            [28.256079998000075, -23.494430001999945],
            [28.22142999700003, -23.477190002999976],
            [28.166709997000055, -23.508380003999946],
            [28.162660000000074, -23.63243999799994],
            [28.251760002000026, -23.730359999999962],
            [28.258699997000065, -23.78091000099994],
            [28.29962000100005, -23.804319998999972],
            [28.341249997000034, -23.918999998999936],
            [28.41582599900005, -23.99717700399998],
            [28.434529997000027, -24.043500001999973],
            [28.525850005000052, -24.07546999799996],
            [28.578759998000066, -24.05692000199997],
            [28.692878603000054, -24.11648151099996],
            [28.66531000300006, -24.200009999999963],
            [28.74005999800005, -24.206479999999942],
            [28.77441000300007, -24.25265000099995],
            [28.85087999800004, -24.25673999999998],
            [28.801270001000034, -24.331610001999934],
            [28.913170007000076, -24.414780002999976],
            [29.002900000000068, -24.359040001999972],
            [29.050850007000065, -24.37110999899994],
            [29.06316000000004, -24.29984000199994],
            [29.032040003000077, -24.247829999999965],
            [29.07267000400003, -24.20644999899997],
            [29.147989997000025, -24.22377999799994],
            [29.18896999900005, -24.256940002999954],
            [29.191719998000053, -24.17028000099998],
            [29.23004000000003, -24.109059997999964],
            [29.162150001000043, -24.079280005999976],
            [29.148509999000055, -24.009139996999977],
            [29.09343000000007, -23.984650001999967],
            [29.044929996000064, -23.905569998999965],
            [28.982110001000024, -23.877799996999954],
            [28.998438002000057, -23.841155000999947],
            [28.921390003000056, -23.81122000099998],
            [28.90540000200008, -23.85863999999998],
            [28.843200000000024, -23.833979995999982],
            [28.884350003000065, -23.784689998999966],
            [28.857810002000065, -23.757229996999968],
            [28.875519997000026, -23.64661999799995],
            [28.931419993000077, -23.598279996999963],
            [28.969249811000054, -23.59783252699998],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM367' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.898200001000077, -25.859740003999946],
            [27.831470000000024, -25.86017299799994],
            [27.744549997000036, -25.894620002999943],
            [27.684930000000065, -25.875400000999946],
            [27.643549999000072, -25.79591999799993],
            [27.532289998000067, -25.849960000999943],
            [27.461947001000055, -25.867606000999956],
            [27.457009997000057, -25.981849997999973],
            [27.425220000000024, -26.089389998999934],
            [27.46734000400005, -26.09226999899994],
            [27.706580004000045, -26.11557000099998],
            [27.75092999700007, -26.16246999699996],
            [27.71826999700005, -26.198929998999972],
            [27.77199000300004, -26.21320999699998],
            [27.83881000300005, -26.12021999999996],
            [27.84964000000008, -26.06238001099996],
            [27.912640002000046, -26.02820999599993],
            [27.932119998000076, -25.916300000999968],
            [27.898200001000077, -25.859740003999946],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'GT481' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.216360004000023, -29.982970000999956],
            [27.091950000000054, -30.026769996999974],
            [27.06537998700003, -30.07578999499998],
            [26.991300012000067, -30.111849993999954],
            [26.946799990000045, -30.108569989999978],
            [26.81517001000003, -30.03037999299994],
            [26.82395000100007, -29.964710000999958],
            [26.733299999000053, -29.84219000099995],
            [26.78034000200006, -29.73902000299995],
            [26.715499996000062, -29.711219997999933],
            [26.660210002000042, -29.726830003999964],
            [26.62698000200004, -29.63453000399994],
            [26.562070000000062, -29.647920001999978],
            [26.551089999000055, -29.571759999999983],
            [26.454190005000044, -29.584799997999937],
            [26.38225999900004, -29.61614000399993],
            [26.42430999900006, -29.661220000999947],
            [26.38681000200006, -29.74058999999994],
            [26.310709985000074, -29.778429994999954],
            [26.250320007000028, -29.83436999299994],
            [26.25246000100003, -29.87956999599993],
            [26.19140999900003, -29.93883999999997],
            [26.26020000400007, -30.03568000399997],
            [26.20313000300007, -30.086300001999973],
            [26.144799998000053, -30.166320002999953],
            [26.167120000000068, -30.272320001999958],
            [26.14298999700003, -30.307850002999942],
            [26.202160002000028, -30.334880002999967],
            [26.25497000400003, -30.38722999199996],
            [26.259029999000063, -30.426419996999982],
            [26.323570003000043, -30.502430001999983],
            [26.280609999000035, -30.57835999799994],
            [26.34891000400006, -30.594969998999943],
            [26.425180002000047, -30.56523999799998],
            [26.490230002000033, -30.596010002999947],
            [26.481230003000064, -30.627629998999964],
            [26.629450004000034, -30.693879997999943],
            [26.70656000200006, -30.685679997999955],
            [26.814140004000024, -30.642670002999978],
            [26.847679997000057, -30.68386999699993],
            [26.94301000200005, -30.66214999799996],
            [26.94789999900007, -30.607639999999947],
            [27.034309991000043, -30.599859995999964],
            [27.00364999800007, -30.538309995999953],
            [27.188450002000025, -30.52379000199994],
            [27.284489999000073, -30.503400002999967],
            [27.29353999800003, -30.456750000999932],
            [27.34458999700007, -30.397330000999943],
            [27.403009994000058, -30.39297000399995],
            [27.37735000300006, -30.327119995999965],
            [27.36585999700003, -30.257939997999983],
            [27.39414999400003, -30.142469996999978],
            [27.326890001000038, -30.14812000099994],
            [27.29654000000005, -30.056109995999975],
            [27.216360004000023, -29.982970000999956],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS163' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.03769998200005, -23.33871002199993],
            [29.866839981000055, -23.43741001999996],
            [29.741869973000064, -23.435250027999928],
            [29.616749971000047, -23.396450030999972],
            [29.622079970000073, -23.32841002899994],
            [29.59185997000003, -23.268260030999954],
            [29.427749972000072, -23.280030027999942],
            [29.44050997200003, -23.246330029999967],
            [29.267809965000026, -23.238640029999942],
            [29.157239969000045, -23.318800003999968],
            [29.082059956000023, -23.299960044999978],
            [29.026280003000068, -23.37662999799994],
            [29.076866997000025, -23.388579999999934],
            [29.066478751000034, -23.554339891999973],
            [29.226550967000037, -23.57999377999994],
            [29.244605996000075, -23.546451996999963],
            [29.348040001000072, -23.527159996999956],
            [29.336510002000068, -23.576990000999956],
            [29.35543000200005, -23.640049999999974],
            [29.41371999900008, -23.621129999999937],
            [29.46594000300007, -23.76349000199997],
            [29.500759989000073, -23.81135999999998],
            [29.547610002000056, -23.80595000099993],
            [29.675980003000063, -23.75132999799996],
            [29.79523000100005, -23.68082999799998],
            [29.887920003000033, -23.67941999599998],
            [29.961120004000065, -23.66007000199994],
            [29.94901999600006, -23.62769999799997],
            [30.03643999800005, -23.57296999899995],
            [30.047347004000073, -23.535237001999974],
            [30.00599999700006, -23.447810002999972],
            [30.043259998000053, -23.42565000299993],
            [30.03769998200005, -23.33871002199993],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM353' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.389485000000036, -26.906384999999943],
            [27.306050003000053, -26.85333999599993],
            [27.219160002000024, -26.944359995999946],
            [27.17366000100003, -26.96759000199995],
            [27.11343000200003, -26.926359996999963],
            [27.013929998000037, -26.932050001999983],
            [26.947220010000024, -26.89200999899998],
            [26.90868000000006, -26.945709999999963],
            [26.866440002000047, -26.91906000299997],
            [26.80502000200005, -26.931979998999964],
            [26.67182000200006, -26.99573000099997],
            [26.621069997000063, -27.00272000299998],
            [26.581820003000075, -27.05311999999998],
            [26.585619997000038, -27.106029999999976],
            [26.521619999000052, -27.104389999999967],
            [26.575410000000034, -27.183319997999945],
            [26.635249997000074, -27.171569999999974],
            [26.72758999000007, -27.230809999999963],
            [26.746320000000026, -27.395339999999976],
            [26.789719997000077, -27.51083998799993],
            [26.763320011000076, -27.564250008999977],
            [26.857710002000033, -27.58600000299998],
            [26.870359998000026, -27.53378999699993],
            [26.950050003000058, -27.522500002999948],
            [27.01632999700007, -27.598240000999965],
            [26.97448999900007, -27.642909999999972],
            [26.969940004000023, -27.69444999899997],
            [27.04476999800005, -27.749099996999973],
            [27.052500003000034, -27.85931000399995],
            [27.15779000200007, -27.93333999799995],
            [27.19277999700006, -27.899749998999937],
            [27.35898200200006, -27.932452998999963],
            [27.363450000000057, -28.001459987999965],
            [27.433770001000028, -28.049759995999977],
            [27.37005000100004, -28.17026999899997],
            [27.38786999900003, -28.214080001999946],
            [27.56962000200008, -28.282529995999937],
            [27.61115999900005, -28.24146000299993],
            [27.596290003000036, -28.175989998999967],
            [27.659850000000063, -28.184120002999975],
            [27.65376000400005, -28.12658999699994],
            [27.703459999000074, -28.040389999999945],
            [27.695399998000028, -28.002620002999947],
            [27.737719998000046, -27.92817000399998],
            [27.778309998000054, -27.910370008999962],
            [27.872599999000045, -27.933779998999967],
            [27.862840001000052, -27.78952000399994],
            [27.74175999700003, -27.806370000999948],
            [27.633371002000047, -27.803171000999953],
            [27.566809998000053, -27.738040001999934],
            [27.639429999000072, -27.681559998999944],
            [27.576810000000023, -27.61853999999994],
            [27.478570000000047, -27.63120999299997],
            [27.435974999000052, -27.570466000999943],
            [27.44342000200004, -27.482919996999954],
            [27.311070001000076, -27.488239995999947],
            [27.232079998000074, -27.47461999899997],
            [27.171790002000023, -27.39759000199996],
            [27.170259998000063, -27.316760002999956],
            [27.214510002000054, -27.278579999999977],
            [27.378709997000044, -27.29129999999998],
            [27.393750002000047, -27.23834999899998],
            [27.37408000100004, -27.149809999999945],
            [27.38991999700005, -27.111380001999976],
            [27.340810000000033, -27.019300001999966],
            [27.351530000000025, -26.942309997999928],
            [27.389485000000036, -26.906384999999943],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS201' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.298160001000042, -25.310370001999956],
            [28.246270001000028, -25.212855003999948],
            [28.13571999900006, -25.20563999799998],
            [28.128970002000074, -25.145689989999937],
            [28.15393000000006, -25.086780000999966],
            [28.19827000300006, -25.12759000099993],
            [28.25975999700006, -25.050449999999955],
            [27.983559998000032, -24.957849997999972],
            [27.946469998000055, -25.001219999999932],
            [27.821660003000034, -24.974580001999982],
            [27.80484000000007, -25.01836000199995],
            [27.824360004000027, -25.11088000199993],
            [27.86459999500005, -25.080539999999928],
            [27.890609995000034, -25.14877999999993],
            [27.831360962000076, -25.20962038999994],
            [27.913082193000037, -25.312845856999957],
            [27.970759997000073, -25.362949989999947],
            [28.04473000400003, -25.401739994999957],
            [28.298060004000035, -25.33933999599998],
            [28.298160001000042, -25.310370001999956],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW371' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.486900001000038, -25.07841999799996],
            [27.424600000000055, -25.068910002999928],
            [27.33695000000006, -25.08781999699994],
            [27.313600000000065, -25.042089996999948],
            [27.203468000000044, -25.033182997999972],
            [27.22609200200003, -24.963937001999966],
            [27.143852999000046, -24.946151003999944],
            [27.101150003000043, -24.90004000299996],
            [27.041219999000077, -24.88697000299993],
            [27.02632999900004, -24.71863000199994],
            [26.975909998000077, -24.720670001999963],
            [26.980720002000055, -24.77576999799993],
            [26.77954000300008, -24.837690002999977],
            [26.751259996000044, -24.88295999899998],
            [26.69930000100004, -24.867290003999983],
            [26.62201000300007, -24.809860003999972],
            [26.566450002000067, -24.819899998999972],
            [26.458280002000038, -24.809470001999955],
            [26.44212999800004, -24.935469997999974],
            [26.455109999000058, -24.95284999699993],
            [26.418109999000023, -25.046799994999958],
            [26.384980004000056, -25.05934000299993],
            [26.422679998000035, -25.132544998999947],
            [26.40502000200007, -25.28592999899996],
            [26.466040001000067, -25.29066999899993],
            [26.419300000000078, -25.477640003999966],
            [26.506016002000024, -25.501890998999954],
            [26.53544000000005, -25.469649997999966],
            [26.59473900100005, -25.46985000199993],
            [26.60825999700006, -25.524379996999983],
            [26.652760003000026, -25.522289998999952],
            [26.648690002000023, -25.44761000099993],
            [26.687510002000067, -25.393569997999975],
            [26.760519996000028, -25.359200002999955],
            [27.00336000200008, -25.38999000399997],
            [27.13292672800003, -25.357453496999938],
            [27.18851999800006, -25.368219997999972],
            [27.25648200300003, -25.337444997999967],
            [27.364950001000068, -25.32539000299994],
            [27.42797999800007, -25.289660004999973],
            [27.490199997000047, -25.197209999999927],
            [27.486900001000038, -25.07841999799996],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW375' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.233749998000064, -33.888240003999954],
            [22.123679998000057, -33.84637000299995],
            [21.932780007000076, -33.86542000399993],
            [21.70035000200005, -33.85285000099998],
            [21.65139000100004, -33.92818999899998],
            [21.666649998000025, -34.00936000099995],
            [21.715360004000047, -34.043579998999974],
            [21.71243143600003, -34.127638167999976],
            [21.792579998000065, -34.28613000099995],
            [21.88696999700005, -34.34357999699995],
            [21.930929997000078, -34.30416999999994],
            [21.932249999000078, -34.24513000299993],
            [22.010339996000027, -34.211060001999954],
            [22.112190008000027, -34.20380999899993],
            [22.12594999600003, -34.11492999799998],
            [22.23446999600003, -34.058169996999936],
            [22.35457000100007, -34.05442999999997],
            [22.27986000100003, -34.02149000299994],
            [22.26786000000004, -33.925020003999975],
            [22.233749998000064, -33.888240003999954],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC043' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.32774164600005, -28.946712600999945],
            [30.287469943000076, -28.91489993899995],
            [30.223689943000068, -28.94574993899994],
            [30.229629943000077, -28.984039938999956],
            [30.086179943000047, -28.966530063999983],
            [30.027989942000033, -29.05932006499995],
            [29.926899942000034, -29.121849939999947],
            [29.854859942000076, -29.21807993999994],
            [29.75571994200004, -29.206939939999984],
            [29.753790067000068, -29.283259939999937],
            [29.652099942000063, -29.297079939999946],
            [29.609740067000075, -29.24864993999995],
            [29.56982994200007, -29.29037993999998],
            [29.578629942000077, -29.33552006499997],
            [29.506799942000043, -29.33977993999997],
            [29.61328005200005, -29.408469929999967],
            [29.689915942000027, -29.402831939999942],
            [29.841689942000073, -29.357959939999944],
            [29.930689942000072, -29.319069939999963],
            [30.00558706700008, -29.338471939999977],
            [30.011779942000032, -29.296710064999957],
            [30.122739943000056, -29.245109939999963],
            [30.20822894300005, -29.25164093999996],
            [30.221389943000077, -29.292090064999968],
            [30.276299943000026, -29.30914993999994],
            [30.335870068000077, -29.163850064999963],
            [30.36360994300003, -29.12302993999998],
            [30.309049318000064, -29.09782518999998],
            [30.342568193000034, -29.050260564999974],
            [30.300251082000045, -28.95597004299998],
            [30.32774164600005, -28.946712600999945],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN223' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.505729943000063, -28.262689938999983],
            [30.44915994300004, -28.28189006399998],
            [30.35194994300008, -28.266459938999958],
            [30.23359494300007, -28.408709938999948],
            [30.337770068000054, -28.47392006399997],
            [30.300659943000028, -28.53409993899993],
            [30.220729943000038, -28.57331993899993],
            [30.27860994300005, -28.683799938999982],
            [30.267529943000056, -28.731019938999964],
            [30.287469943000076, -28.91489993899995],
            [30.32774164600005, -28.946712600999945],
            [30.36396994300003, -28.942870063999976],
            [30.45184994300007, -28.88077993899998],
            [30.563990068000066, -28.879339938999976],
            [30.62528194300006, -28.80475993899995],
            [30.69907394300003, -28.771935938999945],
            [30.650109943000075, -28.720729938999966],
            [30.67031594300005, -28.642552063999972],
            [30.615209943000025, -28.626400063999938],
            [30.602349943000036, -28.57084993899997],
            [30.681739943000025, -28.54084993899994],
            [30.635649943000033, -28.407980063999958],
            [30.530769943000053, -28.334409938999954],
            [30.505729943000063, -28.262689938999983],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN244' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.717919996000035, -26.48579000099994],
            [30.698690012000043, -26.444570002999967],
            [30.74868000300006, -26.374510003999944],
            [30.755520997000076, -26.332773003999932],
            [30.688579997000033, -26.306109999999933],
            [30.61073000400006, -26.316950003999978],
            [30.624160003000043, -26.25877000299994],
            [30.592760000000055, -26.207990002999964],
            [30.493890002000057, -26.23303999999996],
            [30.35802000500007, -26.17068999999998],
            [30.209469999000078, -26.220130001999962],
            [30.06185499700007, -26.209603000999948],
            [29.96906000200005, -26.243360000999928],
            [29.94110000200004, -26.216639999999927],
            [29.844699998000067, -26.22162999699998],
            [29.80468999800007, -26.189510002999953],
            [29.758840003000046, -26.225410001999933],
            [29.715359997000064, -26.203849998999942],
            [29.66762999900004, -26.244640001999983],
            [29.540350001000036, -26.253879996999956],
            [29.47029000200007, -26.303209995999964],
            [29.468669998000053, -26.352490001999968],
            [29.566180002000067, -26.442750003999947],
            [29.629110001000072, -26.48149000099994],
            [29.61916999500005, -26.52905999799998],
            [29.640350003000037, -26.62790999899994],
            [29.82264400200006, -26.669365995999954],
            [29.869910007000044, -26.65014999999994],
            [29.842960000000062, -26.799460003999968],
            [29.963759999000047, -26.770670001999974],
            [29.994810001000076, -26.69772000399996],
            [30.111160004000055, -26.736320001999957],
            [30.13794000100006, -26.834820003999937],
            [30.25076000100006, -26.824759995999955],
            [30.322750004000056, -26.824240001999954],
            [30.340419997000026, -26.774899997999967],
            [30.45916999800005, -26.75693999999993],
            [30.544490003000078, -26.712350001999937],
            [30.56054000100005, -26.66385999599993],
            [30.468950001000053, -26.558599999999956],
            [30.56106000300008, -26.505720002999965],
            [30.629450000000077, -26.505039996999983],
            [30.66630199800005, -26.540408998999965],
            [30.717919996000035, -26.48579000099994],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP302' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.811069944000053, -28.431680938999932],
            [31.74105994400003, -28.433460063999973],
            [31.70206494400003, -28.371455063999974],
            [31.670649944000047, -28.402399938999963],
            [31.610439944000063, -28.37686993899996],
            [31.53595994400007, -28.394330063999973],
            [31.504399944000056, -28.471979938999937],
            [31.41087394400006, -28.458562938999933],
            [31.358509944000048, -28.393950063999966],
            [31.32945094400003, -28.449164938999957],
            [31.249139944000035, -28.462209938999933],
            [31.18952994400007, -28.499379938999937],
            [31.15853994400004, -28.551114938999945],
            [31.19879994400003, -28.649230063999937],
            [31.237179944000047, -28.636759938999944],
            [31.280059944000072, -28.716419938999934],
            [31.328169944000024, -28.720260063999945],
            [31.346229944000072, -28.77463993899994],
            [31.450219944000025, -28.762239938999983],
            [31.520879944000058, -28.713409938999973],
            [31.651483091000046, -28.70387308599993],
            [31.719700620000026, -28.49808504899994],
            [31.793650505000073, -28.48310668599993],
            [31.811069944000053, -28.431680938999932],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN285' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.614832748000026, -28.133148029999973],
            [32.443477631000064, -28.109577178999928],
            [32.349838945000045, -28.052269063999972],
            [32.339399945000025, -28.098979938999946],
            [32.26751994500006, -28.145899938999946],
            [32.12099994400006, -28.117189938999957],
            [32.02841994400006, -28.220219938999946],
            [31.981432944000062, -28.35041993899995],
            [31.990779944000053, -28.388589938999928],
            [32.11193994400003, -28.43622993899993],
            [32.212189944000045, -28.45894993899998],
            [32.30519994500003, -28.51851006399994],
            [32.41476794500005, -28.476392938999936],
            [32.47060794500004, -28.48533593899998],
            [32.48299794500008, -28.388292063999984],
            [32.56621894500006, -28.24935006399994],
            [32.614832748000026, -28.133148029999973],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN275' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.344896727000048, -22.534532147999982],
            [31.30923000300004, -22.427559989999963],
            [31.273680004000028, -22.37476000199996],
            [31.220869995000044, -22.369809999999973],
            [31.161999998000056, -22.328419999999937],
            [31.094109999000068, -22.348689995999962],
            [30.99967999900008, -22.31641998999993],
            [30.83917000200006, -22.29208000099993],
            [30.626089943000068, -22.336340056999973],
            [30.491889943000047, -22.316590057999974],
            [30.379009944000074, -22.351300056999946],
            [30.28287994300007, -22.354010056999982],
            [30.227539944000057, -22.294980056999975],
            [30.121569944000044, -22.308670056999972],
            [30.019849942000064, -22.23344005799993],
            [29.923119943000074, -22.189180057999977],
            [29.80522994300003, -22.165500057999964],
            [29.773589942000058, -22.141420057999937],
            [29.67703994200008, -22.138970057999927],
            [29.541009942000073, -22.152270057999942],
            [29.331989942000064, -22.20417005799993],
            [29.217199943000026, -22.178310057999965],
            [29.154999942000074, -22.214520057999948],
            [29.03693994200006, -22.21631005699993],
            [28.966579942000067, -22.307540057999972],
            [28.97144994100006, -22.37698005799996],
            [28.92327896200004, -22.457035037999958],
            [28.932910066000034, -22.521060056999943],
            [28.979110066000032, -22.581130058999975],
            [29.107339942000067, -22.539250057999936],
            [29.16587994200006, -22.553120057999934],
            [29.20935997500004, -22.66278004299994],
            [29.308779968000067, -22.60204007799996],
            [29.36867994200003, -22.65197005899995],
            [29.538529942000025, -22.61510005799994],
            [29.61883994200008, -22.65944993399995],
            [29.748249943000076, -22.680130058999964],
            [29.787879942000075, -22.700420057999963],
            [29.798509942000067, -22.758070058999976],
            [29.884679943000037, -22.710220058999937],
            [29.928169943000057, -22.664810057999944],
            [29.985949942000047, -22.69295993399993],
            [30.10561994300008, -22.703980058999946],
            [30.18847994400005, -22.69361005899998],
            [30.32371994300007, -22.653220058999977],
            [30.396049943000037, -22.62489005799995],
            [30.43528248000007, -22.659607723999954],
            [30.564607694000074, -22.64298730799993],
            [30.67689304000004, -22.61348912699998],
            [30.719974457000035, -22.64690742199997],
            [30.787693653000076, -22.592604974999972],
            [30.81725288800004, -22.500636356999962],
            [30.888754806000065, -22.48032150499995],
            [30.997443205000025, -22.49533602899993],
            [30.95811997800007, -22.54894001799994],
            [30.989229968000075, -22.608260023999946],
            [30.931249982000054, -22.64124002899996],
            [30.88948059100005, -22.71283912699994],
            [31.013439178000056, -22.72781944199994],
            [30.977773666000076, -22.81967163099995],
            [31.070337296000048, -22.802122115999964],
            [31.17854309100005, -22.672002791999944],
            [31.344896727000048, -22.534532147999982],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM341' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.857710002000033, -27.58600000299998],
            [26.763320011000076, -27.564250008999977],
            [26.789719997000077, -27.51083998799993],
            [26.746320000000026, -27.395339999999976],
            [26.72758999000007, -27.230809999999963],
            [26.635249997000074, -27.171569999999974],
            [26.575410000000034, -27.183319997999945],
            [26.521619999000052, -27.104389999999967],
            [26.473629999000025, -27.15375999899993],
            [26.419900003000066, -27.171359996999968],
            [26.496769998000048, -27.26495999499997],
            [26.423090004000073, -27.40686999899998],
            [26.345160001000067, -27.38542999799995],
            [26.267750000000035, -27.416309997999974],
            [26.22041000300004, -27.47300000399997],
            [26.22724000200003, -27.51340999599995],
            [26.125510000000077, -27.564780009999936],
            [26.055059999000036, -27.670060002999946],
            [26.075840000000028, -27.710650002999955],
            [26.12547600000005, -27.818566998999984],
            [26.217400003000023, -27.88307999999995],
            [26.183160000000044, -27.941849997999952],
            [26.188231002000066, -28.001318002999938],
            [26.335010001000057, -28.05271999799993],
            [26.35466999600004, -28.08602000199994],
            [26.414640001000066, -28.092130002999966],
            [26.472630004000052, -28.078289996999956],
            [26.509679995000056, -27.993220003999966],
            [26.505480001000024, -27.952089996999973],
            [26.54876000300004, -27.873959998999965],
            [26.560879991000036, -27.724080001999937],
            [26.636299999000073, -27.65908000099995],
            [26.74193000100007, -27.693630002999953],
            [26.83663000000007, -27.622960001999957],
            [26.857710002000033, -27.58600000299998],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS185' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.16958999700006, -26.519929997999952],
            [25.06620299900004, -26.55029499999995],
            [24.991200003000074, -26.39093999199997],
            [24.930210000000045, -26.42062999999996],
            [24.900730000000067, -26.363449999999943],
            [24.85785000000004, -26.394999999999982],
            [24.76417999800003, -26.205250000999968],
            [24.635080001000063, -26.269699997999965],
            [24.677920003000054, -26.329109999999957],
            [24.53613000100006, -26.401690000999963],
            [24.602179997000064, -26.51544999899994],
            [24.657379999000057, -26.48580999799998],
            [24.729249999000047, -26.59639999199993],
            [24.780250000000024, -26.642580006999935],
            [24.701519998000038, -26.685469998999963],
            [24.509660004000068, -26.76717999999994],
            [24.276980004000052, -26.883239997999965],
            [24.304439998000078, -26.94291999999996],
            [24.265849997000032, -26.960619995999934],
            [24.341410004000068, -27.06802999699994],
            [24.32020501200003, -27.082695000999934],
            [24.415399998000055, -27.211610002999976],
            [24.380169998000042, -27.272490003999962],
            [24.45717000800005, -27.424419997999962],
            [24.612945007000064, -27.337962009999956],
            [24.58572914000007, -27.29284741999993],
            [24.699311089000048, -27.234209972999963],
            [24.777190000000076, -27.333240003999947],
            [24.834989997000037, -27.273110003999932],
            [24.895249998000054, -27.178990003999957],
            [25.007300001000033, -27.093260001999965],
            [25.07638999900007, -27.201509993999935],
            [25.15361000200005, -27.158729997999956],
            [25.10806000200006, -27.017920002999972],
            [25.18737000300007, -26.979389991999938],
            [25.22257999800007, -27.029270001999976],
            [25.324459997000076, -27.01425999199995],
            [25.365439998000056, -27.063650002999964],
            [25.399110000000064, -27.037699999999973],
            [25.349139997000066, -26.952440000999957],
            [25.42153999800007, -26.920099999999934],
            [25.38267999800007, -26.861659997999936],
            [25.320779997000045, -26.886259996999968],
            [25.257490000000075, -26.802249995999944],
            [25.194198080000035, -26.85758167299997],
            [25.120012125000073, -26.79724799199994],
            [25.147649998000077, -26.71401999699998],
            [25.226705002000074, -26.614766277999934],
            [25.16958999700006, -26.519929997999952],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW392' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.51208000400004, -28.88948000399995],
            [18.42346999700004, -28.90082000299998],
            [18.350820003000024, -28.880750001999957],
            [18.263490003000072, -28.879389997999965],
            [18.19382999900006, -28.915270002999932],
            [18.079240000000027, -28.869930006999937],
            [18.04606999400005, -28.874269992999928],
            [17.972239998000077, -28.79161999799993],
            [17.925650002000054, -28.76883999599994],
            [17.735770006000052, -28.756699995999952],
            [17.61867999800006, -28.76416000699993],
            [17.598860003000027, -28.694649996999942],
            [17.49366999600005, -28.69278999599993],
            [17.41870899500003, -28.72198100199995],
            [17.34900900100007, -28.794456993999972],
            [17.462206998000056, -28.85452700299993],
            [17.46046000000007, -29.02768000599997],
            [17.54058999600005, -29.337629999999933],
            [17.565340003000074, -29.397860003999938],
            [17.520850006000046, -29.437430004999953],
            [17.46812000400007, -29.419979998999963],
            [17.32642000000004, -29.404330004999963],
            [17.35744999900004, -29.327950001999966],
            [17.299889997000037, -29.304479993999962],
            [17.238210001000027, -29.240669999999966],
            [17.167259998000077, -29.272849994999945],
            [17.174830005000047, -29.30271999799993],
            [17.091619999000045, -29.333830001999956],
            [17.086770001000048, -29.443699996999953],
            [17.037290002000077, -29.50072001199993],
            [16.994610000000023, -29.515005001999953],
            [17.000729999000043, -29.57596000199993],
            [17.034040006000055, -29.61652999699993],
            [17.076659995000057, -29.815400000999944],
            [17.112550000000056, -29.91450999999995],
            [17.155119998000032, -29.97579999499993],
            [17.181000002000076, -30.061730000999944],
            [17.247240000000033, -30.003180004999933],
            [17.312240005000035, -30.092839996999942],
            [17.396130001000074, -30.018939994999982],
            [17.439129999000045, -30.03308999899997],
            [17.519239995000078, -29.949870000999965],
            [17.561650000000043, -30.047149997999952],
            [17.603879995000057, -30.012490001999936],
            [17.732490003000066, -30.020719999999983],
            [17.779109998000024, -30.054319995999947],
            [17.863600003000045, -30.06668999599998],
            [17.88778000800005, -30.038649994999957],
            [17.959109996000052, -30.028689998999937],
            [18.000010002000067, -30.06589999399995],
            [18.12719000000004, -30.016509999999982],
            [18.208803792000026, -30.000553882999952],
            [18.219024793000074, -29.91100935199995],
            [18.333249994000028, -29.89559999399995],
            [18.36712000500006, -29.934800000999928],
            [18.493659973000035, -29.91807937599998],
            [18.605489997000063, -29.86041000199998],
            [18.725596495000048, -29.864108638999937],
            [18.808450699000048, -29.83167076099994],
            [18.799179077000076, -29.76052093499993],
            [18.761089325000057, -29.675640105999946],
            [18.776649517000067, -29.48357621799994],
            [18.74867000000006, -29.418060000999958],
            [18.651000003000036, -29.421729995999954],
            [18.63228000600003, -29.354069996999954],
            [18.642949998000063, -29.218010000999982],
            [18.595510002000026, -29.138489997999955],
            [18.619520005000027, -29.01807000499997],
            [18.606329997000046, -28.964029996999955],
            [18.54304000600007, -28.961600001999955],
            [18.51208000400004, -28.88948000399995],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC062' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.135600000000068, -33.496329998999954],
            [27.07905000100004, -33.470470010999975],
            [26.98525999800006, -33.35620000199998],
            [27.003760002000035, -33.302029997999966],
            [26.968949999000074, -33.267660002999946],
            [26.882989998000028, -33.30600999899997],
            [26.80180000000007, -33.28460999899994],
            [26.719749989000036, -33.35235999899993],
            [26.723570003000077, -33.38443000099994],
            [26.61773000000005, -33.425029998999946],
            [26.547319999000024, -33.551599995999936],
            [26.415459997000028, -33.540809999999965],
            [26.38071999700003, -33.56256000199994],
            [26.347760004000065, -33.68983999899996],
            [26.461520001000054, -33.70520000199997],
            [26.46286999800003, -33.756590003999975],
            [26.53004999700005, -33.75414999599997],
            [26.625920001000054, -33.71907999999996],
            [26.751729999000077, -33.65000999799997],
            [26.866710001000058, -33.62633000099993],
            [26.93632000200006, -33.58199999599998],
            [27.110969999000076, -33.52534000099996],
            [27.135600000000068, -33.496329998999954],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC105' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.234284944000024, -29.180706939999936],
            [31.13716994300006, -29.207599939999966],
            [31.088529943000026, -29.34710993999994],
            [31.02651006800005, -29.26789993999995],
            [30.98118994300006, -29.269259939999984],
            [30.877189943000076, -29.275589939999975],
            [30.854649943000027, -29.322220064999954],
            [30.88038994300007, -29.367669939999928],
            [30.793549943000073, -29.44954993999994],
            [30.747750068000073, -29.46706993999993],
            [30.702519943000027, -29.561129939999944],
            [30.727179943000067, -29.57093993999996],
            [30.793219943000054, -29.57549993999993],
            [30.84250994300004, -29.62561993999998],
            [31.094409943000073, -29.538089939999963],
            [31.05069994300004, -29.48628006499996],
            [31.182687944000065, -29.352972939999972],
            [31.152559944000075, -29.325864939999974],
            [31.16599294400004, -29.25839093999997],
            [31.25604994400004, -29.245400064999956],
            [31.234284944000024, -29.180706939999936],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN293' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.84900999900003, -33.72245999799998],
            [25.849800001000062, -33.66541000099994],
            [25.78005999900006, -33.69231000099995],
            [25.736790003000067, -33.629929998999955],
            [25.558010000000024, -33.59615999999994],
            [25.43770999900005, -33.553080000999955],
            [25.346299998000063, -33.55707000899997],
            [25.308059998000033, -33.63785000099995],
            [25.35208242400006, -33.70306321099997],
            [25.307228300000077, -33.71735790099996],
            [25.235029991000033, -33.83690000099995],
            [25.200819999000032, -33.899209998999936],
            [25.221490003000042, -33.97076999999996],
            [25.394940001000066, -34.03137000299995],
            [25.58925000000005, -34.05061000199993],
            [25.65292000100004, -34.02803999699995],
            [25.671400001000052, -33.98313000099995],
            [25.61251999900003, -33.948269997999944],
            [25.641490001000022, -33.85165000199993],
            [25.70396000200003, -33.79046000099993],
            [25.84900999900003, -33.72245999799998],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'NMA' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.89913997700006, -27.385490027999936],
            [29.840189999000074, -27.37898998099996],
            [29.810689987000046, -27.444769979999933],
            [29.75867998600006, -27.442570014999944],
            [29.70316998100003, -27.471999970999946],
            [29.71236503700004, -27.518439968999928],
            [29.75835997200005, -27.52711003299993],
            [29.779559971000026, -27.587300031999973],
            [29.67011997900005, -27.67012997699993],
            [29.708990037000035, -27.69849996599993],
            [29.676849959000037, -27.959510042999966],
            [29.832389942000077, -27.99207006399996],
            [29.914110067000024, -27.988790063999943],
            [30.00096994200004, -27.899259937999943],
            [30.07447006800004, -27.874210062999964],
            [30.056739942000036, -27.822649937999984],
            [30.119619943000032, -27.82056993799995],
            [30.208594943000037, -27.788359937999928],
            [30.21058994300006, -27.732319937999932],
            [30.116269943000077, -27.707799937999937],
            [30.081719943000053, -27.724890062999975],
            [29.920159942000055, -27.57922993799997],
            [29.924879942000075, -27.53887993799998],
            [29.89913997700006, -27.385490027999936],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN252' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.217910004000032, -32.89013000099993],
            [27.13023000100003, -32.98660999899994],
            [27.12063999700007, -33.02510000199993],
            [26.975810000000024, -33.04965999999996],
            [26.911820009000053, -33.122150000999966],
            [26.85622999700007, -33.11492000199996],
            [26.878159998000058, -33.170909997999956],
            [26.962560000000053, -33.20239000199996],
            [26.968949999000074, -33.267660002999946],
            [27.003760002000035, -33.302029997999966],
            [26.98525999800006, -33.35620000199998],
            [27.07905000100004, -33.470470010999975],
            [27.135600000000068, -33.496329998999954],
            [27.210620000000063, -33.46248999599993],
            [27.353709999000046, -33.36493000199994],
            [27.49182999900006, -33.28203999799996],
            [27.442949999000064, -33.25837999799995],
            [27.424730001000057, -33.193019997999954],
            [27.37488999900006, -33.180089995999936],
            [27.360132943000053, -33.12994728399997],
            [27.44417001100004, -33.07976000599996],
            [27.503910002000055, -32.995219996999936],
            [27.34307485200003, -32.96295413499996],
            [27.29586428300007, -33.02417272899993],
            [27.239752891000023, -32.95668991699995],
            [27.217910004000032, -32.89013000099993],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC126' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.511410002000048, -30.929870007999966],
            [29.406400000000076, -31.00237999799998],
            [29.437360003000038, -31.10068000299998],
            [29.382760004000033, -31.10879000999995],
            [29.344909990000076, -31.16530999799994],
            [29.284530003000043, -31.18514000199997],
            [29.226369999000042, -31.298329998999975],
            [29.22942000000006, -31.393439995999984],
            [29.27116999100008, -31.395260002999976],
            [29.344959997000046, -31.303140002999953],
            [29.387169992000054, -31.32919000399994],
            [29.50867000100004, -31.340929995999943],
            [29.53715000300008, -31.42488999799997],
            [29.690979999000035, -31.528199994999966],
            [29.759189996000032, -31.45239000099997],
            [29.834459999000046, -31.443250002999946],
            [29.907279996000057, -31.390840000999958],
            [30.047640000000058, -31.24755999699994],
            [29.90544999800005, -31.179870001999973],
            [29.846460000000036, -31.13512000099996],
            [29.76168000200005, -31.11933000399995],
            [29.726020000000062, -31.086869999999976],
            [29.584300002000077, -31.038030008999954],
            [29.609759998000072, -30.983210002999954],
            [29.511410002000048, -30.929870007999966],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC153' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.716306001000078, -26.761676999999963],
            [27.661369998000055, -26.773190002999968],
            [27.590429997000058, -26.73836000299997],
            [27.517359997000028, -26.781970000999934],
            [27.511750002000042, -26.836510002999944],
            [27.418589997000026, -26.92386000099998],
            [27.389485000000036, -26.906384999999943],
            [27.351530000000025, -26.942309997999928],
            [27.340810000000033, -27.019300001999966],
            [27.38991999700005, -27.111380001999976],
            [27.37408000100004, -27.149809999999945],
            [27.393750002000047, -27.23834999899998],
            [27.378709997000044, -27.29129999999998],
            [27.214510002000054, -27.278579999999977],
            [27.170259998000063, -27.316760002999956],
            [27.171790002000023, -27.39759000199996],
            [27.232079998000074, -27.47461999899997],
            [27.311070001000076, -27.488239995999947],
            [27.44342000200004, -27.482919996999954],
            [27.435974999000052, -27.570466000999943],
            [27.478570000000047, -27.63120999299997],
            [27.576810000000023, -27.61853999999994],
            [27.639429999000072, -27.681559998999944],
            [27.566809998000053, -27.738040001999934],
            [27.633371002000047, -27.803171000999953],
            [27.74175999700003, -27.806370000999948],
            [27.862840001000052, -27.78952000399994],
            [27.838089997000054, -27.672621998999944],
            [27.988600000000076, -27.632209995999972],
            [28.007781996000062, -27.563803999999948],
            [28.05687000300003, -27.56421999899993],
            [28.18868999600005, -27.481780002999983],
            [28.250889999000037, -27.497789999999952],
            [28.283239998000056, -27.359689996999975],
            [28.227359999000043, -27.28761000199995],
            [28.28708000100005, -27.204120002999957],
            [28.26423999700006, -27.18622000299996],
            [28.12675000300004, -27.137859997999954],
            [28.065730003000056, -27.046560000999932],
            [27.973670000000027, -27.042430001999946],
            [27.92860998900005, -26.96601099199995],
            [27.802670000000035, -26.997190001999968],
            [27.772700003000068, -26.924949995999953],
            [27.71045999900008, -26.842270002999953],
            [27.716306001000078, -26.761676999999963],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS203' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.15853994400004, -28.551114938999945],
            [31.106360068000072, -28.528069938999977],
            [31.018129943000076, -28.42577006399995],
            [30.96541994300003, -28.406320063999942],
            [30.832659943000067, -28.46372993899996],
            [30.803961943000047, -28.517825938999977],
            [30.82135994300006, -28.58162993899998],
            [30.73243994300003, -28.665199938999933],
            [30.67031594300005, -28.642552063999972],
            [30.650109943000075, -28.720729938999966],
            [30.69907394300003, -28.771935938999945],
            [30.77085994300006, -28.722680063999974],
            [30.833109943000068, -28.771699938999973],
            [30.98679994300005, -28.805120063999937],
            [30.993349943000055, -28.85647993899994],
            [31.029826943000046, -28.90152293899996],
            [31.122709943000075, -28.827950063999936],
            [31.16447994400005, -28.83089006399996],
            [31.219719944000076, -28.78855993899998],
            [31.307469944000047, -28.81210993899998],
            [31.346229944000072, -28.77463993899994],
            [31.328169944000024, -28.720260063999945],
            [31.280059944000072, -28.716419938999934],
            [31.237179944000047, -28.636759938999944],
            [31.19879994400003, -28.649230063999937],
            [31.15853994400004, -28.551114938999945],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN286' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.250889999000037, -27.497789999999952],
            [28.18868999600005, -27.481780002999983],
            [28.05687000300003, -27.56421999899993],
            [28.007781996000062, -27.563803999999948],
            [27.988600000000076, -27.632209995999972],
            [27.838089997000054, -27.672621998999944],
            [27.862840001000052, -27.78952000399994],
            [27.872599999000045, -27.933779998999967],
            [27.778309998000054, -27.910370008999962],
            [27.737719998000046, -27.92817000399998],
            [27.695399998000028, -28.002620002999947],
            [27.703459999000074, -28.040389999999945],
            [27.759940002000064, -28.06191000299998],
            [27.762099996000074, -28.15085000099998],
            [27.80058000100007, -28.15683999999993],
            [27.78866001800003, -28.24798099399993],
            [27.837580009000078, -28.22941998999994],
            [27.992710009000064, -28.23198998999993],
            [28.027990001000035, -28.176749997999934],
            [28.181635002000064, -28.108182003999957],
            [28.27760999900005, -28.119179998999982],
            [28.320419998000034, -28.05972999599993],
            [28.566879998000047, -28.01779999799993],
            [28.635209001000078, -28.030581997999946],
            [28.728190004000055, -28.022859996999955],
            [28.737960000000044, -27.976099998999928],
            [28.72142000200006, -27.91822999799996],
            [28.767929997000067, -27.888709999999946],
            [28.781209999000055, -27.77200999699994],
            [28.744389999000077, -27.728569998999944],
            [28.781120000000044, -27.68709999799995],
            [28.738090000000057, -27.635119998999983],
            [28.74292009100003, -27.599048583999945],
            [28.674970004000045, -27.590480001999936],
            [28.625509237000074, -27.61142924099994],
            [28.597549997000044, -27.56243999999998],
            [28.511149970000076, -27.59688988399995],
            [28.426999996000063, -27.50639999799995],
            [28.258040004000065, -27.572180001999982],
            [28.250889999000037, -27.497789999999952],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS193' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.031979997000064, -25.18309499999998],
            [31.958945011000026, -25.164785999999935],
            [31.942004000000054, -25.124763997999935],
            [31.823160001000076, -25.06190799999996],
            [31.71690900200008, -24.954299998999943],
            [31.61089389600005, -24.98924693999993],
            [31.586380005000024, -25.025129317999983],
            [31.62281990100007, -25.18737983699998],
            [31.627029419000053, -25.272920608999982],
            [31.581319809000036, -25.343969344999948],
            [31.536829999000076, -25.46408000399998],
            [31.48267936700006, -25.496629714999983],
            [31.33545000400005, -25.522559997999963],
            [31.275849996000034, -25.560240002999933],
            [31.33077999900007, -25.608980003999932],
            [31.26208000200006, -25.69231999799996],
            [31.315939998000033, -25.74304000099994],
            [31.416299999000046, -25.718759999999975],
            [31.867860003000033, -25.999600001999966],
            [31.97369000100008, -25.95320000299995],
            [31.93054999700007, -25.84076999699994],
            [31.97856000200005, -25.693670001999976],
            [32.00609900000006, -25.645193999999947],
            [31.979620002000047, -25.457059998999966],
            [32.01464999800004, -25.385560003999956],
            [32.031979997000064, -25.18309499999998],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP324' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.951619944000072, -27.61907993799997],
            [31.805519944000025, -27.624079937999966],
            [31.765319944000055, -27.651370062999945],
            [31.76971994400003, -27.703300062999972],
            [31.658499944000027, -27.761380062999933],
            [31.58836994400008, -27.77412006299994],
            [31.51141294400003, -27.83823406299996],
            [31.488839944000063, -27.85770993799997],
            [31.502409944000078, -27.94646993899994],
            [31.47557994400006, -27.97571993899993],
            [31.49957994400006, -28.118329938999977],
            [31.55785994400003, -28.143010063999952],
            [31.586289944000043, -28.11181006399994],
            [31.645209944000044, -28.150029938999978],
            [31.645149944000025, -28.18640993899993],
            [31.733409944000073, -28.218509938999944],
            [31.807360069000026, -28.216039938999984],
            [31.81923994400006, -28.038040063999972],
            [31.94805994400008, -28.013130063999938],
            [31.968709944000068, -27.930920062999974],
            [32.031879944000025, -27.92858006299997],
            [31.996179944000062, -27.885269937999965],
            [31.951619944000072, -27.61907993799997],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN265' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.950359943000024, -28.143590063999966],
            [30.91399994300008, -28.17016006399996],
            [30.863909943000067, -28.11683993899993],
            [30.790039943000068, -28.141459938999958],
            [30.68689994300007, -28.129299938999964],
            [30.612789943000053, -28.035199938999938],
            [30.68444006800007, -27.971089938999967],
            [30.60214006800004, -27.93359993799993],
            [30.56970006800003, -28.008950063999976],
            [30.51365994300005, -28.171299938999937],
            [30.541949943000077, -28.198219938999955],
            [30.505729943000063, -28.262689938999983],
            [30.530769943000053, -28.334409938999954],
            [30.635649943000033, -28.407980063999958],
            [30.681739943000025, -28.54084993899994],
            [30.602349943000036, -28.57084993899997],
            [30.615209943000025, -28.626400063999938],
            [30.67031594300005, -28.642552063999972],
            [30.73243994300003, -28.665199938999933],
            [30.82135994300006, -28.58162993899998],
            [30.803961943000047, -28.517825938999977],
            [30.832659943000067, -28.46372993899996],
            [30.96541994300003, -28.406320063999942],
            [30.94219994300005, -28.312329938999937],
            [31.047564943000054, -28.200092063999932],
            [30.950359943000024, -28.143590063999966],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN242' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.522201133000067, -30.699014831999932],
            [29.48363000100005, -30.700839996999946],
            [29.46067000200003, -30.78511999799997],
            [29.39245999700006, -30.836789996999983],
            [29.215230002000055, -30.87232999699995],
            [29.165560001000074, -30.81916000399997],
            [29.068309999000064, -30.85512999799994],
            [29.086420059000034, -30.94628906199995],
            [29.145029068000042, -30.971429824999973],
            [29.109115601000042, -31.035037993999936],
            [29.06473800200007, -31.037947419999966],
            [29.13230999600006, -31.09143999899993],
            [29.179240003000075, -31.20833999799993],
            [29.190579996000054, -31.274674003999962],
            [29.226369999000042, -31.298329998999975],
            [29.284530003000043, -31.18514000199997],
            [29.344909990000076, -31.16530999799994],
            [29.382760004000033, -31.10879000999995],
            [29.437360003000038, -31.10068000299998],
            [29.406400000000076, -31.00237999799998],
            [29.511410002000048, -30.929870007999966],
            [29.56229999800007, -30.882500000999983],
            [29.53088999700003, -30.812890007999954],
            [29.554329989000053, -30.740589996999972],
            [29.522201133000067, -30.699014831999932],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC444' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.190579996000054, -31.274674003999962],
            [29.155575000000056, -31.319332002999943],
            [29.09396399800005, -31.298698000999934],
            [29.04294000300007, -31.32214400199996],
            [28.979800002000047, -31.28696000399998],
            [28.890780002000042, -31.31501000399993],
            [28.857829999000046, -31.480310000999964],
            [28.75467999700004, -31.485959996999952],
            [28.812939999000037, -31.50752999799994],
            [28.837849998000024, -31.626180000999966],
            [28.820739999000068, -31.686599996999973],
            [28.90588000400004, -31.72078000199997],
            [28.887910000000034, -31.757210000999976],
            [28.949460000000045, -31.835159999999973],
            [29.09648000100003, -31.87912999799994],
            [29.186300001000063, -31.949629997999978],
            [29.327960002000054, -31.80776000299994],
            [29.254680000000064, -31.775649999999928],
            [29.24662998900004, -31.68664999599997],
            [29.276870001000077, -31.62933000099997],
            [29.263469997000072, -31.588070001999938],
            [29.294810003000066, -31.53747999899997],
            [29.27116999100008, -31.395260002999976],
            [29.22942000000006, -31.393439995999984],
            [29.226369999000042, -31.298329998999975],
            [29.190579996000054, -31.274674003999962],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC155' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.761249942000063, -28.737949938999975],
            [29.669979942000055, -28.74715993899997],
            [29.567449942000053, -28.665359938999984],
            [29.669979942000055, -28.562320063999948],
            [29.610382942000058, -28.532850938999957],
            [29.56564994200005, -28.570809938999957],
            [29.491880942000023, -28.528799938999953],
            [29.519459942000026, -28.471819938999943],
            [29.485419942000078, -28.402649938999957],
            [29.438269942000034, -28.423119938999946],
            [29.375559977000023, -28.37210997099993],
            [29.29009997000003, -28.437890033999963],
            [29.248749971000052, -28.42489996699993],
            [29.19149997900007, -28.493779977999964],
            [29.21624995700006, -28.519049953999968],
            [29.134999968000045, -28.566299966999964],
            [29.096319970000025, -28.54509003399994],
            [28.973990977000028, -28.574560038999948],
            [28.942769955000074, -28.650900028999956],
            [28.896229979000054, -28.69473998199993],
            [28.873626972000068, -28.77071189999998],
            [28.943810066000026, -28.782659938999927],
            [28.939220066000075, -28.859999938999977],
            [28.974890066000057, -28.892939938999973],
            [29.074789942000052, -28.918779938999933],
            [29.215490067000076, -29.02628993999997],
            [29.259249942000054, -29.09045993999996],
            [29.307819942000037, -29.076629939999975],
            [29.357050041000036, -29.134250605999966],
            [29.419982910000044, -29.149206160999938],
            [29.47361006700004, -29.091747939999948],
            [29.540569942000047, -28.93754993899995],
            [29.581069942000056, -28.941119938999975],
            [29.631869942000037, -28.868699938999953],
            [29.67715006700007, -28.866379938999955],
            [29.73842994200004, -28.791759938999974],
            [29.761249942000063, -28.737949938999975],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN235' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.774430000000052, -33.41974000199997],
            [22.581819990000042, -33.404680000999974],
            [22.464739999000074, -33.404519997999955],
            [22.39128999600007, -33.364090000999965],
            [22.213989998000045, -33.31495999899994],
            [21.962879997000073, -33.36619999599998],
            [21.902079997000044, -33.36495998799995],
            [21.936273998000047, -33.524975996999956],
            [21.935039999000026, -33.66770000399998],
            [21.837480004000042, -33.737309996999954],
            [21.72279999600005, -33.70531999599996],
            [21.740035060000025, -33.79614592699994],
            [21.70035000200005, -33.85285000099998],
            [21.932780007000076, -33.86542000399993],
            [22.123679998000057, -33.84637000299995],
            [22.233749998000064, -33.888240003999954],
            [22.36878000400003, -33.792810000999964],
            [22.345270000000028, -33.72525000599995],
            [22.371800003000033, -33.659389991999944],
            [22.588689998000063, -33.636669997999945],
            [22.755659997000066, -33.64072999299998],
            [22.716079999000044, -33.531680000999984],
            [22.728480000000047, -33.45415999599993],
            [22.774430000000052, -33.41974000199997],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC045' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.624219995000033, -34.41871999999995],
            [19.59039000300004, -34.39053999899994],
            [19.495130001000064, -34.39983000199993],
            [19.402970715000038, -34.37560375499993],
            [19.300587522000058, -34.37527932099994],
            [19.302979813000036, -34.32855989799998],
            [19.20698223900007, -34.296731748999946],
            [19.130097852000063, -34.24311964599997],
            [19.039120009000044, -34.27422999799995],
            [18.94773360000005, -34.24541040099996],
            [18.930709386000046, -34.203527863999966],
            [18.845815000000073, -34.26959000299996],
            [18.811909997000043, -34.298769998999944],
            [18.82714999800004, -34.37609999799997],
            [18.96462000300005, -34.36297000099995],
            [19.047080004000065, -34.34218999999996],
            [19.218480003000025, -34.43812000099996],
            [19.275380003000066, -34.40905000099997],
            [19.357739998000056, -34.485480002999964],
            [19.378119998000045, -34.540390000999935],
            [19.32616001100007, -34.61018999999993],
            [19.402229997000063, -34.60641999999996],
            [19.449149999000042, -34.65463000099993],
            [19.515820002000055, -34.66974000099998],
            [19.596049997000023, -34.74666999999994],
            [19.724737004000076, -34.767248998999946],
            [19.719719998000073, -34.59977000099997],
            [19.68816000000004, -34.56220999799996],
            [19.713349996000034, -34.46856000199995],
            [19.69587000000007, -34.43223999899993],
            [19.624219995000033, -34.41871999999995],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC032' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.047909998000023, -27.69973999599995],
            [24.99972000100007, -27.680830003999972],
            [24.80117000000007, -27.70177999699996],
            [24.762060005000023, -27.633239999999944],
            [24.692299998000067, -27.64521999899995],
            [24.69547000400007, -27.718249999999955],
            [24.65866999700006, -27.790939992999938],
            [24.699320003000025, -27.828289996999956],
            [24.615819999000053, -27.903600000999973],
            [24.73283566400005, -27.92022534499995],
            [24.775210000000072, -27.994110000999967],
            [24.847410723000053, -27.957974664999938],
            [24.829840000000047, -27.931289999999933],
            [25.047909998000023, -27.69973999599995],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC094' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.418859999000063, -27.254519999999957],
            [29.33958000000007, -27.252730001999964],
            [29.331470000000024, -27.21010000299998],
            [29.22980999400005, -27.16722999899997],
            [29.136369999000067, -27.154220002999978],
            [29.061030001000063, -27.07175000199993],
            [29.05723000000006, -27.00929999899995],
            [29.015141792000065, -27.00995693699997],
            [28.99651908900006, -27.079660415999967],
            [29.005649567000034, -27.166900634999934],
            [28.967029572000058, -27.280010222999977],
            [28.916881561000025, -27.345794677999947],
            [28.927360535000048, -27.402475356999958],
            [28.880750656000032, -27.44350051899994],
            [28.785535812000035, -27.462493895999955],
            [28.74292009100003, -27.599048583999945],
            [28.738090000000057, -27.635119998999983],
            [28.781120000000044, -27.68709999799995],
            [28.744389999000077, -27.728569998999944],
            [28.781209999000055, -27.77200999699994],
            [28.767929997000067, -27.888709999999946],
            [28.72142000200006, -27.91822999799996],
            [28.737960000000044, -27.976099998999928],
            [28.804749998000034, -28.019829999999956],
            [28.76977000100004, -28.12457999999998],
            [28.879109997000057, -28.13766998899996],
            [28.998910000000024, -28.074540001999935],
            [29.006870003000074, -28.02075999999994],
            [29.117639997000026, -28.048949997999955],
            [29.16113000100006, -28.011769998999966],
            [29.27083000400006, -27.99672000399994],
            [29.311139998000044, -28.011539999999968],
            [29.314459999000064, -28.072810002999972],
            [29.380470002000038, -28.12025999599996],
            [29.405129998000064, -28.078000001999953],
            [29.564000003000046, -28.189130001999956],
            [29.50992004400007, -28.26543993699994],
            [29.619765027000028, -28.241219959999967],
            [29.62633996900007, -28.18573996999993],
            [29.663289934000034, -28.14202004499998],
            [29.655479977000027, -28.090020025999934],
            [29.616861983000035, -28.04683801599998],
            [29.65069997200004, -27.967120034999937],
            [29.676849959000037, -27.959510042999966],
            [29.708990037000035, -27.69849996599993],
            [29.67011997900005, -27.67012997699993],
            [29.779559971000026, -27.587300031999973],
            [29.75835997200005, -27.52711003299993],
            [29.71236503700004, -27.518439968999928],
            [29.70316998100003, -27.471999970999946],
            [29.75867998600006, -27.442570014999944],
            [29.699290002000055, -27.450339998999937],
            [29.704269999000076, -27.489400001999968],
            [29.618910002000064, -27.506020001999957],
            [29.418859999000063, -27.254519999999957],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS195' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.887920003000033, -23.67941999599998],
            [29.79523000100005, -23.68082999799998],
            [29.675980003000063, -23.75132999799996],
            [29.547610002000056, -23.80595000099993],
            [29.500759989000073, -23.81135999999998],
            [29.46594000300007, -23.76349000199997],
            [29.41371999900008, -23.621129999999937],
            [29.35543000200005, -23.640049999999974],
            [29.336510002000068, -23.576990000999956],
            [29.348040001000072, -23.527159996999956],
            [29.244605996000075, -23.546451996999963],
            [29.226550967000037, -23.57999377999994],
            [29.066478751000034, -23.554339891999973],
            [29.01020108000006, -23.620451171999946],
            [28.969249811000054, -23.59783252699998],
            [28.931419993000077, -23.598279996999963],
            [28.875519997000026, -23.64661999799995],
            [28.857810002000065, -23.757229996999968],
            [28.884350003000065, -23.784689998999966],
            [28.843200000000024, -23.833979995999982],
            [28.90540000200008, -23.85863999999998],
            [28.921390003000056, -23.81122000099998],
            [28.998438002000057, -23.841155000999947],
            [28.982110001000024, -23.877799996999954],
            [29.044929996000064, -23.905569998999965],
            [29.09343000000007, -23.984650001999967],
            [29.148509999000055, -24.009139996999977],
            [29.162150001000043, -24.079280005999976],
            [29.23004000000003, -24.109059997999964],
            [29.191719998000053, -24.17028000099998],
            [29.18896999900005, -24.256940002999954],
            [29.232960001000038, -24.234430002999943],
            [29.266469999000037, -24.28388000399997],
            [29.332289996000043, -24.296910002999937],
            [29.446100001000048, -24.240659998999945],
            [29.59651999600004, -24.18110998999998],
            [29.735890003000065, -24.107239997999955],
            [29.82726000300005, -24.040580000999967],
            [29.810139998000068, -23.96854999699997],
            [29.86374999900005, -23.95138000099996],
            [29.89654999700008, -23.898719995999954],
            [29.886520000000075, -23.855119995999928],
            [29.928179999000065, -23.79767999799998],
            [29.88838000000004, -23.741600001999927],
            [29.887920003000033, -23.67941999599998],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM354' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.690979999000035, -31.528199994999966],
            [29.53715000300008, -31.42488999799997],
            [29.50867000100004, -31.340929995999943],
            [29.387169992000054, -31.32919000399994],
            [29.344959997000046, -31.303140002999953],
            [29.27116999100008, -31.395260002999976],
            [29.294810003000066, -31.53747999899997],
            [29.263469997000072, -31.588070001999938],
            [29.276870001000077, -31.62933000099997],
            [29.24662998900004, -31.68664999599997],
            [29.254680000000064, -31.775649999999928],
            [29.327960002000054, -31.80776000299994],
            [29.42226000100004, -31.69168999799996],
            [29.50186999600004, -31.66470999699993],
            [29.62391000300005, -31.586009997999952],
            [29.690979999000035, -31.528199994999966],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC154' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.934090000000026, -33.02165999899995],
            [22.83540000100004, -33.03773999999993],
            [22.78315000200007, -32.93059999899998],
            [22.66463999800004, -32.92879999599995],
            [22.455680003000055, -32.876530000999935],
            [22.38400000000007, -32.87083000599995],
            [22.321340001000067, -32.82061000799996],
            [22.30132999700004, -32.73991000199993],
            [22.21728000400003, -32.744149996999965],
            [22.191380000000038, -32.79061000099995],
            [22.12416999800007, -32.732839997999974],
            [22.065019996000046, -32.71055999699996],
            [22.071850011000038, -32.64271999699997],
            [22.033419997000067, -32.55492999799998],
            [21.945939999000075, -32.609800003999965],
            [21.760430003000067, -32.65843999899994],
            [21.717760002000034, -32.641649997999934],
            [21.691180001000077, -32.71439000099997],
            [21.479760003000024, -32.78659999699994],
            [21.432109997000055, -32.75672999699998],
            [21.43005000100004, -32.84901999899995],
            [21.478480002000026, -32.902299995999954],
            [21.395930001000067, -32.937919997999984],
            [21.442850002000057, -33.00051000199994],
            [21.48345000000006, -33.013909997999974],
            [21.578090002000067, -33.11589000299995],
            [21.637269998000022, -33.14128000299996],
            [21.62895999400007, -33.30542999199997],
            [21.611950001000025, -33.39679999999993],
            [21.82723999700005, -33.391039999999975],
            [21.902079997000044, -33.36495998799995],
            [21.962879997000073, -33.36619999599998],
            [22.213989998000045, -33.31495999899994],
            [22.39128999600007, -33.364090000999965],
            [22.464739999000074, -33.404519997999955],
            [22.581819990000042, -33.404680000999974],
            [22.774430000000052, -33.41974000199997],
            [22.735740001000067, -33.39476999799996],
            [22.892269998000074, -33.14163000399998],
            [22.955310001000043, -33.073140000999956],
            [22.934090000000026, -33.02165999899995],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC052' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.458280002000038, -24.809470001999955],
            [26.426319996000075, -24.771970003999968],
            [26.42731000200007, -24.657520002999945],
            [26.40878000300006, -24.646129995999956],
            [26.39328000100005, -24.63662999899998],
            [26.187000003000037, -24.687499998999954],
            [26.00741000200003, -24.724280005999958],
            [25.964409997000075, -24.749439999999936],
            [25.858310008000046, -24.757180002999974],
            [25.876570000000072, -24.888300001999937],
            [25.729100000000074, -25.256880002999935],
            [25.699819998000066, -25.291000002999965],
            [25.68823000200007, -25.376000001999955],
            [25.62979000100006, -25.53782000299998],
            [25.740669999000033, -25.51385000199997],
            [25.796552999000028, -25.524967999999944],
            [25.845599999000058, -25.66563999799996],
            [25.88693999900005, -25.675309996999943],
            [26.09541000300004, -25.617779998999936],
            [26.109244997000076, -25.70210999799997],
            [26.184520003000046, -25.674620000999937],
            [26.185004758000048, -25.756553752999935],
            [26.25829238500006, -25.774949710999977],
            [26.297702521000076, -25.667500191999977],
            [26.396380002000058, -25.69288999899993],
            [26.390419998000027, -25.757639996999956],
            [26.462370000000078, -25.745369995999965],
            [26.511230003000037, -25.65521999999993],
            [26.506016002000024, -25.501890998999954],
            [26.419300000000078, -25.477640003999966],
            [26.466040001000067, -25.29066999899993],
            [26.40502000200007, -25.28592999899996],
            [26.422679998000035, -25.132544998999947],
            [26.384980004000056, -25.05934000299993],
            [26.418109999000023, -25.046799994999958],
            [26.455109999000058, -24.95284999699993],
            [26.44212999800004, -24.935469997999974],
            [26.458280002000038, -24.809470001999955],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW385' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.71826999700005, -26.198929998999972],
            [27.75092999700007, -26.16246999699996],
            [27.706580004000045, -26.11557000099998],
            [27.46734000400005, -26.09226999899994],
            [27.48995700000006, -26.127970998999956],
            [27.47151000300005, -26.24495499799997],
            [27.48190999800005, -26.28444000099995],
            [27.54784999700007, -26.34328000199997],
            [27.537280001000056, -26.40585999999996],
            [27.557090001000063, -26.456379998999978],
            [27.607150003000072, -26.491600000999938],
            [27.604370001000063, -26.59196000199995],
            [27.579600001000074, -26.60752999899995],
            [27.667929998000034, -26.610549996999964],
            [27.675980000000038, -26.52434999999997],
            [27.709669998000038, -26.45467000399998],
            [27.76128999900004, -26.419150000999934],
            [27.751864003000037, -26.361995002999947],
            [27.811589997000056, -26.36447500299994],
            [27.813679996000076, -26.28564999799994],
            [27.743799996000064, -26.28722000199997],
            [27.71826999700005, -26.198929998999972],
          ],
        ],
      },
      properties: { ADM1_ID: 'GP', ADM3_ID: 'GT485' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.339327000000026, -25.769283996999945],
            [25.17011999700003, -25.765909999999963],
            [25.035730004000072, -25.722750007999934],
            [24.887260001000072, -25.807420001999958],
            [24.796320003000062, -25.824629998999967],
            [24.72967000400007, -25.804090002999942],
            [24.685869999000033, -25.82333000099993],
            [24.56511000100005, -25.77126999999996],
            [24.485275002000037, -25.74938999799997],
            [24.465069998000047, -25.790170003999947],
            [24.667030001000057, -25.921250002999955],
            [24.653879999000026, -25.95932000199997],
            [24.733850001000064, -26.03957000099996],
            [24.804080002000035, -26.158249998999963],
            [24.76417999800003, -26.205250000999968],
            [24.85785000000004, -26.394999999999982],
            [24.900730000000067, -26.363449999999943],
            [24.930210000000045, -26.42062999999996],
            [24.991200003000074, -26.39093999199997],
            [25.06620299900004, -26.55029499999995],
            [25.16958999700006, -26.519929997999952],
            [25.225419998000064, -26.456069998999965],
            [25.224939996000046, -26.38575999699998],
            [25.29733999700005, -26.32175000099994],
            [25.37209999600003, -26.33880000299996],
            [25.422349996000037, -26.270750000999953],
            [25.486530001000062, -26.21668999999997],
            [25.457980003000046, -26.103429999999946],
            [25.50102000100003, -26.061799995999934],
            [25.406140003000075, -25.954729997999948],
            [25.26481586600005, -25.870540888999983],
            [25.329000999000073, -25.832097998999927],
            [25.339327000000026, -25.769283996999945],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW381' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.583549943000037, -30.56070994099997],
            [30.507544943000028, -30.53953994099993],
            [30.508829943000023, -30.59159994099997],
            [30.42733994300005, -30.57786994099996],
            [30.361459943000057, -30.616439940999953],
            [30.218259943000078, -30.65540994099996],
            [30.13629006800005, -30.624449940999966],
            [30.072869943000057, -30.649989940999944],
            [30.082109943000034, -30.696669940999982],
            [30.02099994200006, -30.738349940999967],
            [29.961164980000035, -30.82316997199996],
            [30.092709971000033, -30.86222996799995],
            [30.146350037000047, -30.931069969999953],
            [30.142759983000076, -31.022820026999966],
            [30.193859794000048, -31.081260201999953],
            [30.22747994300005, -31.05828994099994],
            [30.304470068000057, -30.941329940999935],
            [30.40450994300005, -30.82830006599994],
            [30.583549943000037, -30.56070994099997],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN216' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.775780000000054, -32.333279999999945],
            [26.711760000000027, -32.34001999999998],
            [26.735072999000067, -32.39080599799996],
            [26.662449998000056, -32.42792999899996],
            [26.53923999400007, -32.38596500299997],
            [26.53369001200008, -32.36017999799998],
            [26.30962000100004, -32.37600999599994],
            [26.20252000100004, -32.33127000099995],
            [26.191329997000025, -32.285230000999945],
            [26.141285004000054, -32.27174500799998],
            [26.08164000100004, -32.31788000299997],
            [25.951069612000026, -32.36404736299994],
            [25.899359997000033, -32.43292999999994],
            [25.887309997000045, -32.48680000199994],
            [25.939830003000054, -32.53871999699993],
            [26.08084000100007, -32.54658000199993],
            [26.127175000000022, -32.59543999599998],
            [26.047619999000062, -32.63280000299994],
            [26.063979997000047, -32.685599998999976],
            [26.032040003000077, -32.76401000299995],
            [26.06595999900003, -32.78693000099997],
            [26.179510003000075, -32.76344000199998],
            [26.223600003000058, -32.85712999899994],
            [26.28508000000005, -32.89918999799994],
            [26.274939998000036, -32.93697999899996],
            [26.436340003000055, -32.94746000299995],
            [26.48500000200005, -32.98181999999997],
            [26.630109996000044, -33.00432999999998],
            [26.641930006000052, -33.05028999799998],
            [26.74819999700003, -33.030940003999945],
            [26.825500001000023, -33.03946999999994],
            [26.85622999700007, -33.11492000199996],
            [26.911820009000053, -33.122150000999966],
            [26.975810000000024, -33.04965999999996],
            [27.12063999700007, -33.02510000199993],
            [27.13023000100003, -32.98660999899994],
            [27.217910004000032, -32.89013000099993],
            [27.232879997000055, -32.852349997999966],
            [27.15761029300006, -32.83846006899995],
            [27.017230002000076, -32.785150001999966],
            [27.025570001000062, -32.68177000199995],
            [27.004514998000047, -32.60509500099994],
            [27.036430000000053, -32.56634999999994],
            [27.017100002000063, -32.51125000299993],
            [26.950570000000027, -32.547829999999976],
            [26.86515000000003, -32.51154999999994],
            [26.775780000000054, -32.333279999999945],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC129' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.798487668000064, -30.03417014699994],
            [24.793970003000027, -29.99897999799998],
            [24.67129999900004, -29.971449999999948],
            [24.667799998000078, -29.906509994999965],
            [24.60792999800003, -29.91126000299994],
            [24.470020000000034, -29.811780003999957],
            [24.453640001000053, -29.86772000299993],
            [24.29826999900007, -29.897170005999953],
            [24.278819990000045, -29.96430000199996],
            [24.195893005000073, -30.002367995999975],
            [24.056520000000035, -30.003690001999928],
            [24.02964803100008, -30.020761221999976],
            [24.03990068400003, -30.09047150699996],
            [23.94522000300003, -30.10552999999993],
            [23.925759994000032, -30.144139997999957],
            [23.939299997000035, -30.210260000999938],
            [23.84207999800003, -30.195130001999928],
            [23.956340003000037, -30.23662000199994],
            [23.93169000000006, -30.278179997999928],
            [24.018870006000043, -30.339969998999948],
            [24.07665000000003, -30.33099000599998],
            [24.10826000000003, -30.37306999799995],
            [24.277617081000074, -30.448922981999942],
            [24.252580000000023, -30.51215999799996],
            [24.274300003000064, -30.583859995999944],
            [24.452420000000075, -30.658369997999955],
            [24.54078180600004, -30.731442956999956],
            [24.58666000100004, -30.70258999699996],
            [24.644425397000077, -30.751596894999977],
            [24.67957999600003, -30.62595999599995],
            [24.75599677100007, -30.45960166699996],
            [24.84294701600004, -30.366067465999947],
            [24.879171945000053, -30.27109122899998],
            [24.950169006000067, -30.224845002999928],
            [24.90156000500008, -30.208240003999947],
            [24.86768999700007, -30.130939997999974],
            [24.798487668000064, -30.03417014699994],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC075' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.399539943000036, -29.748629939999944],
            [30.37244994300005, -29.726819939999928],
            [30.241209943000058, -29.73138993999993],
            [30.15337994300006, -29.721430064999936],
            [30.092354943000032, -29.747280064999984],
            [30.045361357000047, -29.829961907999973],
            [30.037049942000067, -29.867080064999982],
            [30.105759943000066, -29.97464993999995],
            [30.212429943000075, -30.017339939999943],
            [30.281829943000048, -30.004419939999934],
            [30.396639943000025, -30.10230006599994],
            [30.44548994300004, -30.08436993999993],
            [30.513780068000074, -30.08713993999993],
            [30.509079943000074, -30.034909939999977],
            [30.453340068000045, -30.01394006499993],
            [30.50305994300004, -29.96643993999993],
            [30.493019943000036, -29.899560064999946],
            [30.394650796000064, -29.867253956999946],
            [30.446469943000068, -29.81063993999993],
            [30.399539943000036, -29.748629939999944],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN227' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [17.41870899500003, -28.72198100199995],
            [17.42966000100006, -28.56987000299995],
            [17.389129997000055, -28.57118000099996],
            [17.33308000100004, -28.47490999799993],
            [17.396520002000045, -28.427379996999946],
            [17.41403999700003, -28.376040005999982],
            [17.382260003000056, -28.295899994999957],
            [17.333999998000024, -28.226090004999946],
            [17.214980000000025, -28.248079996999934],
            [17.184150001000035, -28.208820000999935],
            [17.196259995000048, -28.12778999099993],
            [17.082499996000024, -28.033070000999942],
            [16.88459000200004, -28.08993998899996],
            [16.887929995000036, -28.17287999699994],
            [16.80305999600006, -28.22201999999993],
            [16.75501999900007, -28.302000001999943],
            [16.808160001000033, -28.360840002999964],
            [16.769370003000063, -28.39611999899995],
            [16.77682999800004, -28.44006000099995],
            [16.73399000200004, -28.494260002999965],
            [16.688469997000027, -28.47046999899993],
            [16.592459999000027, -28.53542000699997],
            [16.480209999000067, -28.565499993999936],
            [16.45189000000005, -28.63209999399993],
            [16.562309999000036, -28.71905000199996],
            [16.561909998000033, -28.758950005999964],
            [16.60475000200006, -28.876749994999955],
            [16.68981999300007, -28.92697000499993],
            [16.747930006000047, -29.042539998999928],
            [16.81511000000006, -29.09025000899993],
            [16.838039996000077, -29.21097999799997],
            [16.877369998000063, -29.292540002999942],
            [16.935140000000047, -29.35956999399997],
            [16.994610000000023, -29.515005001999953],
            [17.037290002000077, -29.50072001199993],
            [17.086770001000048, -29.443699996999953],
            [17.091619999000045, -29.333830001999956],
            [17.174830005000047, -29.30271999799993],
            [17.167259998000077, -29.272849994999945],
            [17.238210001000027, -29.240669999999966],
            [17.299889997000037, -29.304479993999962],
            [17.35744999900004, -29.327950001999966],
            [17.32642000000004, -29.404330004999963],
            [17.46812000400007, -29.419979998999963],
            [17.520850006000046, -29.437430004999953],
            [17.565340003000074, -29.397860003999938],
            [17.54058999600005, -29.337629999999933],
            [17.46046000000007, -29.02768000599997],
            [17.462206998000056, -28.85452700299993],
            [17.34900900100007, -28.794456993999972],
            [17.41870899500003, -28.72198100199995],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC061' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.532289998000067, -25.849960000999943],
            [27.501219999000057, -25.637849999999958],
            [27.570410004000053, -25.63129000799995],
            [27.646519999000077, -25.65016000099996],
            [27.619709999000065, -25.475030002999972],
            [27.58464000300006, -25.429040001999965],
            [27.519299999000054, -25.41993999699997],
            [27.521150001000024, -25.341440000999967],
            [27.471009997000067, -25.286629999999946],
            [27.42797999800007, -25.289660004999973],
            [27.364950001000068, -25.32539000299994],
            [27.25648200300003, -25.337444997999967],
            [27.18851999800006, -25.368219997999972],
            [27.13292672800003, -25.357453496999938],
            [27.00336000200008, -25.38999000399997],
            [27.01506000200004, -25.46314999599997],
            [27.158510000000035, -25.668479997999953],
            [27.16710000100005, -25.720329996999965],
            [27.119770999000025, -25.752234002999955],
            [27.132670001000065, -25.80929999799997],
            [27.20817000200003, -25.85476999699995],
            [27.17379999900004, -25.884939997999936],
            [27.18817400300003, -25.931308996999974],
            [27.165166000000056, -25.992083996999952],
            [27.169850000000054, -26.080229996999947],
            [27.326239998000062, -26.10072000899993],
            [27.361720000000048, -26.115669998999977],
            [27.425220000000024, -26.089389998999934],
            [27.457009997000057, -25.981849997999973],
            [27.461947001000055, -25.867606000999956],
            [27.532289998000067, -25.849960000999943],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW373' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.931252005000033, -31.234014000999935],
            [27.87179000100008, -31.20327999899996],
            [27.76002000400007, -31.203649996999957],
            [27.736519999000052, -31.235049999999944],
            [27.62412000300003, -31.224029996999946],
            [27.57744999700003, -31.38920000199994],
            [27.59864000300007, -31.443719990999966],
            [27.474440000000072, -31.481229999999982],
            [27.482256434000078, -31.58604907299997],
            [27.43424000400006, -31.596729997999944],
            [27.437136002000045, -31.676665999999955],
            [27.52737471100005, -31.726878330999966],
            [27.694469998000045, -31.713420002999953],
            [27.758459997000045, -31.65649000899998],
            [27.725629997000055, -31.60791000399996],
            [27.746920001000035, -31.556189996999933],
            [27.860509998000055, -31.534439995999946],
            [27.97181999000003, -31.537730001999932],
            [28.04843999700006, -31.50576999599997],
            [28.156989999000075, -31.40189999699993],
            [28.260700004000057, -31.37043999699995],
            [28.216159997000034, -31.31280000299995],
            [28.121219993000068, -31.30012000399995],
            [28.08077000000003, -31.32375000199994],
            [27.988519991000032, -31.24040999999994],
            [27.931252005000033, -31.234014000999935],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC138' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.124805002000073, -32.77778499999994],
            [18.060350003000053, -32.783539996999934],
            [17.957650000000058, -32.718089996999936],
            [17.896990000000073, -32.740649995999945],
            [17.878779999000074, -32.91898999899996],
            [17.891440002000024, -33.028639994999935],
            [17.99274999900007, -32.997160005999945],
            [18.042680001000065, -33.04868000099998],
            [17.955269998000063, -33.110570002999964],
            [18.106490001000054, -33.24069999799997],
            [18.156160009000075, -33.32062999899995],
            [18.226639997000063, -33.30946999799994],
            [18.203279998000028, -33.21544999699995],
            [18.24435999800005, -33.15334999999993],
            [18.30839999600005, -33.179930000999946],
            [18.363739989000067, -33.16022999799998],
            [18.44434000600006, -33.218059996999955],
            [18.516900002000057, -33.198320000999956],
            [18.487109996000072, -33.15866000099993],
            [18.535359997000057, -33.08165000099996],
            [18.503929999000036, -33.04637000199995],
            [18.538549997000075, -33.00508999899995],
            [18.511344003000033, -32.94604598799998],
            [18.340079997000032, -32.94646999799994],
            [18.29260000100004, -32.96199000399997],
            [18.171710002000054, -32.85109000199998],
            [18.124805002000073, -32.77778499999994],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC014' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.117680000000064, -30.668669996999938],
            [27.94052000100004, -30.644109998999966],
            [27.918350003000057, -30.602589998999974],
            [27.78166999900003, -30.617299999999943],
            [27.741910001000065, -30.60390000299998],
            [27.69340999800005, -30.544809998999938],
            [27.623600001000057, -30.506200000999968],
            [27.604400003000023, -30.449459996999963],
            [27.534019998000076, -30.38435999799998],
            [27.474959996000052, -30.356479999999976],
            [27.46458999600003, -30.314029999999946],
            [27.37735000300006, -30.327119995999965],
            [27.403009994000058, -30.39297000399995],
            [27.34458999700007, -30.397330000999943],
            [27.29353999800003, -30.456750000999932],
            [27.284489999000073, -30.503400002999967],
            [27.188450002000025, -30.52379000199994],
            [27.00364999800007, -30.538309995999953],
            [27.034309991000043, -30.599859995999964],
            [27.10711999800003, -30.63177000299993],
            [27.119100003000028, -30.782809998999937],
            [27.179799996000042, -30.802640001999976],
            [27.13111000200007, -30.905224997999937],
            [27.173449998000024, -30.975309996999954],
            [27.141180000000077, -31.001889997999967],
            [27.217830002000028, -31.145989997999948],
            [27.168749999000056, -31.160150001999966],
            [27.165129989000036, -31.25978000699996],
            [27.24217999800004, -31.25994000199995],
            [27.296570003000056, -31.291580001999932],
            [27.275999996000053, -31.339759998999966],
            [27.408460002000027, -31.418459998999936],
            [27.44295999700006, -31.377410001999976],
            [27.45131000200007, -31.25719000199996],
            [27.569559997000056, -31.209089997999968],
            [27.62412000300003, -31.224029996999946],
            [27.736519999000052, -31.235049999999944],
            [27.76002000400007, -31.203649996999957],
            [27.87179000100008, -31.20327999899996],
            [27.931252005000033, -31.234014000999935],
            [27.985490002000063, -31.15199000299998],
            [27.981575001000067, -31.07651500099996],
            [28.063939998000023, -31.012569997999947],
            [28.051139997000064, -30.974329997999973],
            [28.132130000000075, -30.83530000199994],
            [28.12042000200006, -30.778169995999974],
            [28.162290002000077, -30.69279000299997],
            [28.117680000000064, -30.668669996999938],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC142' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.78866001800003, -28.24798099399993],
            [27.80058000100007, -28.15683999999993],
            [27.762099996000074, -28.15085000099998],
            [27.759940002000064, -28.06191000299998],
            [27.703459999000074, -28.040389999999945],
            [27.65376000400005, -28.12658999699994],
            [27.659850000000063, -28.184120002999975],
            [27.596290003000036, -28.175989998999967],
            [27.61115999900005, -28.24146000299993],
            [27.56962000200008, -28.282529995999937],
            [27.38786999900003, -28.214080001999946],
            [27.326239998000062, -28.22645999899993],
            [27.27682999800004, -28.282779998999956],
            [27.265908787000058, -28.377004906999957],
            [27.288969775000055, -28.457538326999952],
            [27.271187403000056, -28.509724881999944],
            [27.212212100000045, -28.57798826399994],
            [27.190079996000065, -28.66763999699998],
            [27.18630500200004, -28.80526299899998],
            [27.268109997000067, -28.838639996999973],
            [27.401770002000035, -28.870789999999943],
            [27.47835999800003, -28.87330000299994],
            [27.527670000000057, -29.01283899699996],
            [27.59219999800007, -29.03204999899998],
            [27.65024999800005, -29.10998000099994],
            [27.682440002000078, -29.00656000099997],
            [27.73076999700004, -28.94571000999997],
            [27.832939999000075, -28.90632999999997],
            [27.888919996000027, -28.91647999999998],
            [27.915960003000066, -28.865149994999967],
            [28.02843000100006, -28.873949997999944],
            [28.050599999000042, -28.81979999799995],
            [28.10165998900004, -28.76714999899997],
            [28.05985000100003, -28.72500999899995],
            [28.03999999000007, -28.624859992999973],
            [27.901350000000036, -28.555850002999932],
            [27.833885998000028, -28.55083700299997],
            [27.846040002000052, -28.47622000399997],
            [27.808520000000044, -28.458240001999968],
            [27.860509998000055, -28.361190002999933],
            [27.830580009000073, -28.283119993999946],
            [27.78866001800003, -28.24798099399993],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS191' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.706969999000023, -28.58772000099998],
            [23.62380999900006, -28.70839000099994],
            [23.668500004000066, -28.766740003999928],
            [23.54240999600006, -28.747439996999958],
            [23.410290002000067, -28.695279996999943],
            [23.379085001000078, -28.63630999399993],
            [23.292009999000072, -28.649940000999948],
            [23.222959996000043, -28.55728999599995],
            [23.128460005000022, -28.596609997999963],
            [22.995730003000062, -28.580289996999966],
            [22.796239998000033, -28.577549997999938],
            [22.72977000000003, -28.517949993999935],
            [22.667240005000053, -28.50268000099993],
            [22.52434499800006, -28.497349996999958],
            [22.460600001000046, -28.44446000099998],
            [22.123329994000073, -28.76320000299995],
            [22.041870001000063, -28.839910001999954],
            [22.142559995000056, -28.914550006999946],
            [22.17997999800008, -28.97464999999994],
            [22.166950000000043, -29.01568999999995],
            [22.21206999700007, -29.049899997999944],
            [22.217938996000044, -29.098789993999958],
            [22.257499997000025, -29.12471000399995],
            [22.277939993000075, -29.230340001999934],
            [22.269739994000076, -29.31937000199997],
            [22.338434994000067, -29.314809999999966],
            [22.355540013000052, -29.231890006999947],
            [22.415639998000074, -29.190760001999934],
            [22.442753002000075, -29.13437299499998],
            [22.63548999300008, -29.13823999999994],
            [22.67999999700004, -29.25846999199996],
            [22.726489998000034, -29.282700001999956],
            [22.852710717000036, -29.273630108999953],
            [22.831020355000078, -29.129850387999966],
            [22.906820006000032, -29.15798999699996],
            [23.07218933100006, -29.18066024799998],
            [23.111280006000072, -29.218230000999938],
            [23.164899826000067, -29.140350341999977],
            [23.223409653000033, -29.129850387999966],
            [23.320719998000072, -29.15115000299994],
            [23.34993743900003, -29.21861267099996],
            [23.33305358900003, -29.274551391999978],
            [23.271100998000065, -29.275550841999973],
            [23.193592220000028, -29.336221230999968],
            [23.24527986100003, -29.39619984099994],
            [23.213120004000075, -29.43754999999993],
            [23.227802277000023, -29.537368773999958],
            [23.27922058100006, -29.47612953199996],
            [23.36450958300003, -29.45270919799998],
            [23.362730026000065, -29.391969680999978],
            [23.447290421000048, -29.314640044999976],
            [23.51452999600008, -29.305870004999974],
            [23.488100006000025, -29.24063500099993],
            [23.573070001000076, -29.184660002999976],
            [23.63938000400003, -29.073959998999953],
            [23.704449999000076, -29.111030006999954],
            [23.713980003000074, -29.19323000299994],
            [23.785390004000078, -29.224849995999932],
            [23.780099998000026, -29.286399996999933],
            [23.86459999400006, -29.286739999999952],
            [23.931199995000043, -29.39648000099993],
            [23.937589999000068, -29.482089994999967],
            [24.01267000300004, -29.518580001999965],
            [24.04506999800003, -29.503449994999983],
            [24.143149996000034, -29.53855000699997],
            [24.195160009000062, -29.522439989999953],
            [24.27311000000003, -29.581140003999963],
            [24.239919996000026, -29.615249996999978],
            [24.30451000100004, -29.661189994999972],
            [24.34662000000003, -29.65592999599994],
            [24.691780003000076, -29.025719998999932],
            [24.667009996000047, -29.038879995999935],
            [24.53524999900003, -29.04220999499995],
            [24.485470003000046, -28.99739000099993],
            [24.433879997000076, -28.997550003999947],
            [24.395520004000048, -28.942399990999945],
            [24.31061935400004, -28.92400932299995],
            [24.26097106900005, -28.947921752999946],
            [24.233560562000036, -28.88238906899994],
            [24.27017021200004, -28.833520888999942],
            [24.108339310000076, -28.777599334999934],
            [24.06201999800004, -28.68571000299994],
            [24.117039961000046, -28.59861322499995],
            [23.949589996000043, -28.603360003999967],
            [23.908660008000027, -28.641440005999982],
            [23.75470000000007, -28.52878000399994],
            [23.706969999000023, -28.58772000099998],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC078' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.217938996000044, -29.098789993999958],
            [22.11699999500007, -29.012050002999956],
            [22.086310000000026, -28.950620004999962],
            [21.990960001000076, -28.94607000299993],
            [21.95861999600004, -29.015709998999967],
            [21.83810815000004, -29.097364179999943],
            [21.979309998000076, -29.277759998999954],
            [21.910980000000052, -29.35385000499997],
            [21.845669998000062, -29.395889998999962],
            [21.89981999400004, -29.44913000599996],
            [21.784930006000025, -29.556609996999953],
            [21.829969998000024, -29.62319000599996],
            [21.778920004000042, -29.66596001299996],
            [21.721610000000055, -29.77482000699996],
            [21.81141999400006, -29.84196000299994],
            [22.010350005000078, -29.90244000499996],
            [21.99435999900004, -29.953810002999944],
            [22.014210001000038, -30.005780001999938],
            [22.034579999000073, -30.05758999899996],
            [22.13551999200007, -30.113150004999966],
            [22.208989994000035, -30.12486999799995],
            [22.299599989000058, -30.196430008999982],
            [22.466299999000057, -30.190420005999954],
            [22.523539997000057, -30.15835999899997],
            [22.60809000000006, -30.199300002999962],
            [22.673860000000047, -30.188599995999937],
            [22.64779999500007, -30.130230000999973],
            [22.748339995000038, -30.079269994999947],
            [22.93757000000005, -30.123549999999966],
            [22.954920001000062, -30.222150001999978],
            [22.982039997000072, -30.238129999999956],
            [23.113139998000065, -30.15642999199997],
            [23.182016000000033, -30.094968995999977],
            [23.206658358000027, -30.039386014999934],
            [23.183677033000038, -29.938064673999975],
            [23.239449998000055, -29.901959990999956],
            [23.345280004000074, -29.896319998999957],
            [23.282869996000045, -29.79066000199998],
            [23.341849999000033, -29.73096000199996],
            [23.29074999900007, -29.70084000099996],
            [23.29991000900003, -29.651290004999964],
            [23.23306999400006, -29.63868999799996],
            [23.227802277000023, -29.537368773999958],
            [23.213120004000075, -29.43754999999993],
            [23.24527986100003, -29.39619984099994],
            [23.193592220000028, -29.336221230999968],
            [23.271100998000065, -29.275550841999973],
            [23.33305358900003, -29.274551391999978],
            [23.34993743900003, -29.21861267099996],
            [23.320719998000072, -29.15115000299994],
            [23.223409653000033, -29.129850387999966],
            [23.164899826000067, -29.140350341999977],
            [23.111280006000072, -29.218230000999938],
            [23.07218933100006, -29.18066024799998],
            [22.906820006000032, -29.15798999699996],
            [22.831020355000078, -29.129850387999966],
            [22.852710717000036, -29.273630108999953],
            [22.726489998000034, -29.282700001999956],
            [22.67999999700004, -29.25846999199996],
            [22.63548999300008, -29.13823999999994],
            [22.442753002000075, -29.13437299499998],
            [22.415639998000074, -29.190760001999934],
            [22.355540013000052, -29.231890006999947],
            [22.338434994000067, -29.314809999999966],
            [22.269739994000076, -29.31937000199997],
            [22.277939993000075, -29.230340001999934],
            [22.257499997000025, -29.12471000399995],
            [22.217938996000044, -29.098789993999958],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC077' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.899329996000063, -28.430469998999968],
            [24.726490004000027, -28.449739990999944],
            [24.688020003000076, -28.51417999599994],
            [24.606599999000025, -28.49547999699996],
            [24.608249999000066, -28.59722000599993],
            [24.54866999500007, -28.71369999899997],
            [24.521699994000073, -28.674599994999937],
            [24.408940005000034, -28.62680000499995],
            [24.33348000700005, -28.560820004999982],
            [24.200259999000025, -28.517570000999967],
            [24.117039961000046, -28.59861322499995],
            [24.06201999800004, -28.68571000299994],
            [24.108339310000076, -28.777599334999934],
            [24.27017021200004, -28.833520888999942],
            [24.233560562000036, -28.88238906899994],
            [24.26097106900005, -28.947921752999946],
            [24.31061935400004, -28.92400932299995],
            [24.395520004000048, -28.942399990999945],
            [24.433879997000076, -28.997550003999947],
            [24.485470003000046, -28.99739000099993],
            [24.53524999900003, -29.04220999499995],
            [24.667009996000047, -29.038879995999935],
            [24.691780003000076, -29.025719998999932],
            [24.80182700000006, -28.828258003999963],
            [24.90184000000005, -28.64803000099994],
            [24.827729996000073, -28.62695999699997],
            [24.899329996000063, -28.430469998999968],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC091' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.21404900600004, -33.857067995999955],
            [19.164570000000026, -33.868519995999975],
            [19.094160008000074, -33.831670000999964],
            [18.981979997000053, -33.85289999999998],
            [18.93153999900005, -33.87908000199997],
            [18.895429998000054, -33.84212999999994],
            [18.89678000300006, -33.79335999699998],
            [18.79257000100006, -33.81921000199998],
            [18.75287000000003, -33.834419999999966],
            [18.729180020000058, -33.96747639199998],
            [18.744430004000037, -34.024820001999956],
            [18.790210003000027, -34.05287999999996],
            [18.955299998000044, -34.010110001999976],
            [18.98713112300004, -34.03526966299995],
            [19.12606000100004, -33.961720001999936],
            [19.20658000000003, -33.950410003999934],
            [19.24380000000008, -33.89744999699997],
            [19.21404900600004, -33.857067995999955],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC024' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.51882997900003, -25.42279002199996],
            [29.36245997900005, -25.407110020999937],
            [29.254379998000047, -25.49591000099997],
            [29.198250011000027, -25.562420000999964],
            [29.232839999000078, -25.623790000999975],
            [29.286859998000068, -25.642199997999967],
            [29.30440999700005, -25.681000000999973],
            [29.289129996000042, -25.74535999799997],
            [29.327979998000046, -25.791719995999983],
            [29.36075000200003, -25.96000999699993],
            [29.329759997000053, -25.986920002999966],
            [29.40244799900006, -26.063212007999937],
            [29.333670003000066, -26.095220001999962],
            [29.391039997000064, -26.14419000199996],
            [29.387970000000053, -26.20490000099994],
            [29.455549999000027, -26.211400001999948],
            [29.493449996000038, -26.16954999899997],
            [29.560225998000078, -26.209207995999975],
            [29.540350001000036, -26.253879996999956],
            [29.66762999900004, -26.244640001999983],
            [29.715359997000064, -26.203849998999942],
            [29.758840003000046, -26.225410001999933],
            [29.80468999800007, -26.189510002999953],
            [29.811059999000065, -26.105299998999953],
            [29.86578999900007, -26.01392999899997],
            [29.876959998000075, -25.965210001999935],
            [29.830569997000055, -25.921929999999975],
            [29.86179000100003, -25.862450002999935],
            [29.80094000300005, -25.84876000199995],
            [29.825900000000047, -25.701420002999953],
            [29.785180000000025, -25.674260001999983],
            [29.776670000000024, -25.619829996999954],
            [29.706420003000062, -25.61342000199994],
            [29.713110003000054, -25.572179999999946],
            [29.58592999600006, -25.581449997999982],
            [29.51146999900004, -25.45881000299994],
            [29.51882997900003, -25.42279002199996],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP313' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.178260000000023, -33.251679999999965],
            [25.13477000300003, -33.295069997999974],
            [24.977809997000065, -33.25656999699993],
            [24.880290003000027, -33.257470001999934],
            [24.839540482000075, -33.35184478799994],
            [24.850391388000048, -33.37798690799997],
            [24.798039996000057, -33.483420001999946],
            [24.804405003000056, -33.53823999999997],
            [24.70185000200007, -33.51453000099997],
            [24.673050002000025, -33.57160000199997],
            [24.730740001000072, -33.62038000199993],
            [24.829460003000065, -33.64256999699995],
            [24.97553000000005, -33.71649000299993],
            [25.081420003000062, -33.78668000299996],
            [25.235029991000033, -33.83690000099995],
            [25.307228300000077, -33.71735790099996],
            [25.35208242400006, -33.70306321099997],
            [25.308059998000033, -33.63785000099995],
            [25.346299998000063, -33.55707000899997],
            [25.43770999900005, -33.553080000999955],
            [25.558010000000024, -33.59615999999994],
            [25.736790003000067, -33.629929998999955],
            [25.78005999900006, -33.69231000099995],
            [25.849800001000062, -33.66541000099994],
            [25.84900999900003, -33.72245999799998],
            [26.015859996000074, -33.70530999799996],
            [26.18834000100003, -33.72618999599996],
            [26.321880004000036, -33.767770000999974],
            [26.468390001000046, -33.77337999699995],
            [26.53004999700005, -33.75414999599997],
            [26.46286999800003, -33.756590003999975],
            [26.461520001000054, -33.70520000199997],
            [26.347760004000065, -33.68983999899996],
            [26.38071999700003, -33.56256000199994],
            [26.329530996000074, -33.52756900099996],
            [26.26350000000008, -33.52023999399995],
            [26.10971500000005, -33.53468000299995],
            [26.12555000100008, -33.492749996999976],
            [26.05127000400006, -33.47475999699998],
            [26.037439996000046, -33.42363000399996],
            [26.063190003000045, -33.33309999599993],
            [25.98793999700007, -33.306610002999946],
            [25.927680004000024, -33.31238000099995],
            [25.78963999800004, -33.28451999899994],
            [25.450720002000025, -33.283530000999974],
            [25.315679998000064, -33.259919999999966],
            [25.178260000000023, -33.251679999999965],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC106' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.939005000000066, -33.19638999799997],
            [18.844649998000023, -33.11732000099994],
            [18.807800003000068, -33.03002000199996],
            [18.72658000200005, -32.95053000099995],
            [18.59600000100005, -32.90072000899994],
            [18.511344003000033, -32.94604598799998],
            [18.538549997000075, -33.00508999899995],
            [18.503929999000036, -33.04637000199995],
            [18.535359997000057, -33.08165000099996],
            [18.487109996000072, -33.15866000099993],
            [18.516900002000057, -33.198320000999956],
            [18.44434000600006, -33.218059996999955],
            [18.363739989000067, -33.16022999799998],
            [18.30839999600005, -33.179930000999946],
            [18.24435999800005, -33.15334999999993],
            [18.203279998000028, -33.21544999699995],
            [18.226639997000063, -33.30946999799994],
            [18.156160009000075, -33.32062999899995],
            [18.166039994000073, -33.36861000099998],
            [18.255050004000054, -33.42675000099996],
            [18.321249996000063, -33.51583000599993],
            [18.343040006000024, -33.570630000999984],
            [18.38881999700004, -33.50890999999996],
            [18.455458003000047, -33.47127600399995],
            [18.524160003000077, -33.52522999699994],
            [18.57642000000004, -33.53147999699996],
            [18.627000000000066, -33.624589999999955],
            [18.73673001000003, -33.68703000199997],
            [18.787539997000067, -33.637630000999934],
            [18.839310002000047, -33.57763000099993],
            [18.938090001000035, -33.545999998999946],
            [18.93405000200005, -33.49215000899994],
            [18.992770001000054, -33.35478999999998],
            [18.997350006000033, -33.307909999999936],
            [18.945750002000068, -33.25269999899996],
            [18.939005000000066, -33.19638999799997],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC015' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.943380000000047, -33.85187000199994],
            [21.010339999000053, -33.75656000099997],
            [20.934120000000064, -33.72464001199995],
            [20.800259999000048, -33.71500999899996],
            [20.71892000400004, -33.64061999699993],
            [20.66602000200004, -33.621970003999934],
            [20.503258997000046, -33.63700000199998],
            [20.469152004000023, -33.681952001999946],
            [20.472821000000067, -33.72916899699993],
            [20.43534999900004, -33.82639999999998],
            [20.468250003000037, -33.880289998999956],
            [20.436040003000073, -33.95774000799997],
            [20.324430000000064, -33.94957000299996],
            [20.290759999000045, -34.041939998999965],
            [20.29133999900006, -34.09129999999993],
            [20.221800001000076, -34.11110000899998],
            [20.19609000300005, -34.03999999699994],
            [20.14169000000004, -34.05921000099994],
            [20.008499998000048, -34.06390000999994],
            [20.007460002000073, -34.09391999899998],
            [19.96572000200007, -34.176270002999956],
            [19.880430000000047, -34.22010999999998],
            [19.940030000000036, -34.23955000299998],
            [20.032429998000055, -34.20359999699997],
            [20.065529998000045, -34.24126999599997],
            [20.244850000000042, -34.288889998999935],
            [20.28633000700006, -34.34515000199997],
            [20.289079999000023, -34.41777000299993],
            [20.35731000000004, -34.38844000199998],
            [20.391979997000078, -34.426290000999984],
            [20.484750001000066, -34.401319988999944],
            [20.53172999900005, -34.360520002999976],
            [20.871390005000023, -34.45243999999997],
            [20.849963002000038, -34.40340599799998],
            [20.735050004000072, -34.38768000299996],
            [20.683379996000042, -34.34666999899997],
            [20.596289999000078, -34.34796999699995],
            [20.599380001000043, -34.27291000399998],
            [20.664950003000058, -34.18847999899998],
            [20.640100002000054, -34.08596000399996],
            [20.754300000000057, -34.09724999699995],
            [20.707270003000076, -33.955120000999955],
            [20.806580002000032, -33.946419995999975],
            [20.833790001000068, -33.971330002999935],
            [20.93403999800006, -33.94762000299994],
            [20.943380000000047, -33.85187000199994],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC034' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.025230003000047, -25.030099993999954],
            [31.026809997000043, -24.914109998999947],
            [31.00542000300004, -24.83701999599998],
            [30.919410003000053, -24.80515999599993],
            [30.88992999800007, -24.70875000199993],
            [30.89888000600007, -24.63033000799993],
            [30.795040001000075, -24.57749000399997],
            [30.871709999000075, -24.538500002999967],
            [30.758979999000076, -24.460219998999946],
            [30.73017999900003, -24.49849999999998],
            [30.730319997000038, -24.608729995999965],
            [30.679240003000075, -24.623670001999983],
            [30.720100002000038, -24.70523800899997],
            [30.67856999600008, -24.735809996999933],
            [30.634880004000024, -24.852770000999953],
            [30.562880003000032, -24.89646000099998],
            [30.45153999200005, -24.912000003999935],
            [30.42507000300003, -24.854859999999974],
            [30.354170003000036, -24.849279998999975],
            [30.297290000000032, -24.867740001999948],
            [30.19197998900006, -24.85547000899993],
            [30.17206999900003, -24.989169998999955],
            [30.148509997000076, -25.032350003999966],
            [30.144389997000076, -25.12378999899994],
            [30.029839997000067, -25.08456999999993],
            [29.978949982000074, -25.09211998199993],
            [30.005409971000063, -25.14438003099997],
            [30.009839971000076, -25.231280030999983],
            [29.990589983000064, -25.33825002599997],
            [30.025460004000024, -25.367719999999963],
            [30.083440000000053, -25.294079998999962],
            [30.143230006000067, -25.245810008999968],
            [30.190750003000062, -25.275810001999957],
            [30.20557999700003, -25.35681999999997],
            [30.251709997000034, -25.357287002999954],
            [30.22945999800004, -25.432410000999937],
            [30.30141999800003, -25.444979995999972],
            [30.35099000100007, -25.492479996999975],
            [30.417800003000025, -25.42350000199997],
            [30.40138999800007, -25.38083999899993],
            [30.449239999000042, -25.34495999799998],
            [30.53197099700003, -25.349590001999957],
            [30.629890009000064, -25.28499999899998],
            [30.703239998000072, -25.361539995999976],
            [30.79067999600005, -25.353310001999944],
            [30.88181000000003, -25.38371000199993],
            [30.900940002000027, -25.321039995999968],
            [30.978155999000023, -25.29015400299994],
            [30.917219999000054, -25.20830999599997],
            [30.941120004000027, -25.128888003999975],
            [31.025230003000047, -25.030099993999954],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP321' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.57467000300005, -24.42819999699998],
            [27.513957977000075, -24.41621971099994],
            [27.49366569500006, -24.355215072999954],
            [27.502357483000026, -24.219268798999963],
            [27.538343234000024, -24.16780973799996],
            [27.494911694000052, -24.07828224499997],
            [27.44191932700005, -24.10434913599994],
            [27.318460464000054, -24.028549193999936],
            [27.245080948000066, -24.013860702999978],
            [27.12767982500003, -23.953420638999944],
            [27.10601997400005, -23.90827941899994],
            [27.011089325000057, -23.790990828999952],
            [27.001056619000053, -23.68903439199994],
            [26.971070000000054, -23.702759998999966],
            [26.908940001000076, -24.029180002999965],
            [26.86320000300003, -24.09972000399995],
            [26.880610003000072, -24.196579996999958],
            [26.868809998000074, -24.243819995999957],
            [26.799930001000064, -24.299959996999974],
            [26.70399000200007, -24.32182000199998],
            [26.64705000200007, -24.38182999999998],
            [26.510520003000067, -24.487909999999943],
            [26.469550000000027, -24.590859997999928],
            [26.40878000300006, -24.646129995999956],
            [26.42731000200007, -24.657520002999945],
            [26.426319996000075, -24.771970003999968],
            [26.458280002000038, -24.809470001999955],
            [26.566450002000067, -24.819899998999972],
            [26.62201000300007, -24.809860003999972],
            [26.69930000100004, -24.867290003999983],
            [26.751259996000044, -24.88295999899998],
            [26.77954000300008, -24.837690002999977],
            [26.980720002000055, -24.77576999799993],
            [26.975909998000077, -24.720670001999963],
            [27.02632999900004, -24.71863000199994],
            [27.041219999000077, -24.88697000299993],
            [27.101150003000043, -24.90004000299996],
            [27.143852999000046, -24.946151003999944],
            [27.22609200200003, -24.963937001999966],
            [27.203468000000044, -25.033182997999972],
            [27.313600000000065, -25.042089996999948],
            [27.33695000000006, -25.08781999699994],
            [27.424600000000055, -25.068910002999928],
            [27.486900001000038, -25.07841999799996],
            [27.54359999600007, -25.09587999799993],
            [27.594040002000042, -25.029440000999955],
            [27.597490003000075, -24.984869999999944],
            [27.821660003000034, -24.974580001999982],
            [27.946469998000055, -25.001219999999932],
            [27.983559998000032, -24.957849997999972],
            [27.977860003000046, -24.90102000199994],
            [27.859920000000045, -24.87137000299998],
            [27.830980001000057, -24.849409999999978],
            [27.87066400300006, -24.768357996999953],
            [27.82673999800005, -24.713320000999943],
            [27.86470999900007, -24.69523000299995],
            [27.89511999700005, -24.582679994999978],
            [27.70070000100003, -24.59910999599998],
            [27.675859998000078, -24.50072999799994],
            [27.580939999000066, -24.471110000999943],
            [27.57467000300005, -24.42819999699998],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM361' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.540799943000025, -29.618230064999977],
            [30.481149943000048, -29.59538993999996],
            [30.431659943000057, -29.54343006499994],
            [30.364679943000056, -29.542879939999978],
            [30.195457457000032, -29.613106869999967],
            [30.10609994300006, -29.629689939999935],
            [30.069199943000058, -29.72404006499994],
            [29.980332055000076, -29.719404435999934],
            [29.957625609000047, -29.78094086699997],
            [30.045361357000047, -29.829961907999973],
            [30.092354943000032, -29.747280064999984],
            [30.15337994300006, -29.721430064999936],
            [30.241209943000058, -29.73138993999993],
            [30.37244994300005, -29.726819939999928],
            [30.399539943000036, -29.748629939999944],
            [30.49535994300004, -29.70545993999997],
            [30.466039943000055, -29.67220006499997],
            [30.491969943000072, -29.625569939999934],
            [30.540799943000025, -29.618230064999977],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN225' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [19.506889998000077, -33.97169999999994],
            [19.455799998000032, -33.99987999999996],
            [19.318860001000075, -33.94719000099997],
            [19.297400003000064, -33.88967999999994],
            [19.24380000000008, -33.89744999699997],
            [19.20658000000003, -33.950410003999934],
            [19.12606000100004, -33.961720001999936],
            [18.98713112300004, -34.03526966299995],
            [19.005338203000065, -34.07427507199998],
            [18.943900000000042, -34.13823999699997],
            [18.930709386000046, -34.203527863999966],
            [18.94773360000005, -34.24541040099996],
            [19.039120009000044, -34.27422999799995],
            [19.130097852000063, -34.24311964599997],
            [19.20698223900007, -34.296731748999946],
            [19.302979813000036, -34.32855989799998],
            [19.300587522000058, -34.37527932099994],
            [19.402970715000038, -34.37560375499993],
            [19.495130001000064, -34.39983000199993],
            [19.59039000300004, -34.39053999899994],
            [19.624219995000033, -34.41871999999995],
            [19.641055394000034, -34.372031739999954],
            [19.740940000000023, -34.31261999999998],
            [19.845399997000072, -34.280439996999974],
            [19.880430000000047, -34.22010999999998],
            [19.96572000200007, -34.176270002999956],
            [20.007460002000073, -34.09391999899998],
            [19.986540003000073, -34.07817000199998],
            [19.700139997000065, -34.046400001999984],
            [19.680660002000025, -34.009140000999935],
            [19.589830000000063, -34.01236000299997],
            [19.506889998000077, -33.97169999999994],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC031' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.34662000000003, -29.65592999599994],
            [24.30451000100004, -29.661189994999972],
            [24.239919996000026, -29.615249996999978],
            [24.27311000000003, -29.581140003999963],
            [24.195160009000062, -29.522439989999953],
            [24.143149996000034, -29.53855000699997],
            [24.04506999800003, -29.503449994999983],
            [24.01267000300004, -29.518580001999965],
            [23.937589999000068, -29.482089994999967],
            [23.931199995000043, -29.39648000099993],
            [23.86459999400006, -29.286739999999952],
            [23.780099998000026, -29.286399996999933],
            [23.785390004000078, -29.224849995999932],
            [23.713980003000074, -29.19323000299994],
            [23.704449999000076, -29.111030006999954],
            [23.63938000400003, -29.073959998999953],
            [23.573070001000076, -29.184660002999976],
            [23.488100006000025, -29.24063500099993],
            [23.51452999600008, -29.305870004999974],
            [23.447290421000048, -29.314640044999976],
            [23.362730026000065, -29.391969680999978],
            [23.36450958300003, -29.45270919799998],
            [23.27922058100006, -29.47612953199996],
            [23.227802277000023, -29.537368773999958],
            [23.23306999400006, -29.63868999799996],
            [23.29991000900003, -29.651290004999964],
            [23.29074999900007, -29.70084000099996],
            [23.341849999000033, -29.73096000199996],
            [23.282869996000045, -29.79066000199998],
            [23.345280004000074, -29.896319998999957],
            [23.239449998000055, -29.901959990999956],
            [23.352890002000038, -30.066130000999976],
            [23.497719998000036, -30.058619999999962],
            [23.64245999800005, -30.14434999799994],
            [23.776339997000036, -30.103039999999964],
            [23.84207999800003, -30.195130001999928],
            [23.939299997000035, -30.210260000999938],
            [23.925759994000032, -30.144139997999957],
            [23.94522000300003, -30.10552999999993],
            [24.03990068400003, -30.09047150699996],
            [24.02964803100008, -30.020761221999976],
            [24.056520000000035, -30.003690001999928],
            [24.195893005000073, -30.002367995999975],
            [24.278819990000045, -29.96430000199996],
            [24.29826999900007, -29.897170005999953],
            [24.453640001000053, -29.86772000299993],
            [24.470020000000034, -29.811780003999957],
            [24.411580000000072, -29.79073999999997],
            [24.34866000100004, -29.70198999799993],
            [24.34662000000003, -29.65592999599994],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC076' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.032259983000074, -25.249330019999945],
            [28.899134004000075, -25.235077002999958],
            [28.79100999800005, -25.328339997999933],
            [28.739590001000067, -25.28853000099997],
            [28.62257999800005, -25.33364999899993],
            [28.625750002000075, -25.52304999599994],
            [28.683779997000045, -25.67537999999996],
            [28.723870000000034, -25.63177000099995],
            [28.76631000200007, -25.64697999899994],
            [28.792730001000052, -25.70242999499993],
            [28.846950004000064, -25.68242000099997],
            [28.851780003000044, -25.501809999999978],
            [28.946540000000027, -25.599799996999934],
            [29.007760003000044, -25.57416000099994],
            [29.03999999800004, -25.617549999999937],
            [29.00829000300007, -25.66057000099994],
            [29.04154999800005, -25.70803000099994],
            [29.117270000000076, -25.656499999999937],
            [29.24252000300004, -25.708759997999948],
            [29.289129996000042, -25.74535999799997],
            [29.30440999700005, -25.681000000999973],
            [29.286859998000068, -25.642199997999967],
            [29.232839999000078, -25.623790000999975],
            [29.198250011000027, -25.562420000999964],
            [29.254379998000047, -25.49591000099997],
            [29.36245997900005, -25.407110020999937],
            [29.342129973000056, -25.37307003199993],
            [29.264433960000076, -25.37546304199998],
            [29.207338979000042, -25.41457202099997],
            [29.16411997000006, -25.354480029999934],
            [29.166959960000042, -25.30336004199995],
            [29.090169969000044, -25.289399965999962],
            [29.032259983000074, -25.249330019999945],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP315' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.88948059100005, -22.71283912699994],
            [30.931249982000054, -22.64124002899996],
            [30.989229968000075, -22.608260023999946],
            [30.95811997800007, -22.54894001799994],
            [30.997443205000025, -22.49533602899993],
            [30.888754806000065, -22.48032150499995],
            [30.81725288800004, -22.500636356999962],
            [30.787693653000076, -22.592604974999972],
            [30.719974457000035, -22.64690742199997],
            [30.67689304000004, -22.61348912699998],
            [30.564607694000074, -22.64298730799993],
            [30.43528248000007, -22.659607723999954],
            [30.396049943000037, -22.62489005799995],
            [30.32371994300007, -22.653220058999977],
            [30.205389943000057, -22.78258005899994],
            [30.18736994300008, -22.88469005899998],
            [30.164799943000048, -22.92501005899993],
            [30.355329943000072, -23.027190058999963],
            [30.410079943000028, -23.09472005899994],
            [30.47836033200008, -23.063286413999947],
            [30.505397414000072, -23.00142527299994],
            [30.60064794300007, -22.978891058999977],
            [30.658123518000025, -22.941118959999983],
            [30.721125296000025, -22.846444064999957],
            [30.77542085400006, -22.829517388999932],
            [30.822356611000032, -22.78262088699995],
            [30.894081568000047, -22.76321668399993],
            [30.88948059100005, -22.71283912699994],
          ],
        ],
      },
      properties: { ADM1_ID: 'LP', ADM3_ID: 'LIM343' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.323529997000037, -27.793790000999934],
            [25.277410003000057, -27.795319995999932],
            [25.20094000100005, -27.886589998999966],
            [25.09060000200003, -27.984029998999972],
            [25.074650009000038, -28.064249995999944],
            [25.028080000000045, -28.07348000199994],
            [24.964569994000044, -28.25073999899996],
            [24.926679998000054, -28.24689999499998],
            [24.890329997000038, -28.31023000099998],
            [24.93761998900004, -28.324919989999955],
            [24.899329996000063, -28.430469998999968],
            [24.827729996000073, -28.62695999699997],
            [24.90184000000005, -28.64803000099994],
            [24.80182700000006, -28.828258003999963],
            [24.811040001000038, -28.913079996999954],
            [24.86914999800007, -28.89466999299998],
            [24.959300002000077, -28.944860003999963],
            [25.00593999800003, -28.908099999999934],
            [25.085560000000044, -28.907610000999966],
            [25.112190000000055, -28.961339996999982],
            [25.24056999800007, -28.907160001999955],
            [25.33468000000005, -28.894679998999948],
            [25.39003999700003, -28.91682000199995],
            [25.529370003000054, -28.852530000999934],
            [25.625970003000077, -28.893979997999963],
            [25.745260002000066, -28.90640000299993],
            [25.856310009000026, -28.86763000299993],
            [25.87866999700003, -28.760059998999964],
            [25.976949997000077, -28.615439996999953],
            [26.033569999000065, -28.586269998999967],
            [26.059499998000035, -28.509770001999982],
            [25.954050003000077, -28.509169998999937],
            [25.843389998000077, -28.479919999999936],
            [25.723299999000062, -28.36124000199993],
            [25.687809998000034, -28.214239996999936],
            [25.73369000300005, -28.178230001999964],
            [25.70701000400004, -28.12781999899994],
            [25.659690003000037, -28.13560000299998],
            [25.586389996000037, -28.105719996999937],
            [25.626070001000073, -28.038769995999928],
            [25.51746999900007, -27.98636000199997],
            [25.41945000000004, -27.919060000999934],
            [25.349210001000074, -27.850240000999975],
            [25.323529997000037, -27.793790000999934],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS182' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.714579996000055, -27.549159994999968],
            [22.719759999000075, -27.456369993999942],
            [22.669130004000067, -27.450710002999983],
            [22.68164999800007, -27.347749998999973],
            [22.620430000000056, -27.26307000099996],
            [22.487789994000025, -27.278889996999965],
            [22.341339995000055, -27.26111000399993],
            [22.324780004000047, -27.07768999299998],
            [22.251680004000036, -27.039929994999966],
            [22.20940000300004, -27.094450000999927],
            [22.150609992000057, -27.030939994999983],
            [22.124309996000022, -27.07355999899994],
            [21.999490738000077, -27.110249661999944],
            [21.999410629000067, -27.52479934699994],
            [21.91632080100004, -27.55381011999998],
            [22.006195183000045, -27.760420348999958],
            [21.987249374000044, -27.806890487999965],
            [21.788539886000024, -27.968240737999963],
            [21.832889557000044, -28.01063919099994],
            [21.808980942000062, -28.080049514999928],
            [21.681259155000077, -28.209600448999936],
            [21.747940063000044, -28.23625945999993],
            [21.74646999500004, -28.300830005999956],
            [21.774179568000022, -28.353029205999974],
            [21.837610093000023, -28.38274006399996],
            [21.90071000000006, -28.425209999999936],
            [21.926629994000052, -28.520519999999976],
            [22.045949997000037, -28.681650005999984],
            [22.09886000000006, -28.70975001299996],
            [22.123329994000073, -28.76320000299995],
            [22.460600001000046, -28.44446000099998],
            [22.52434499800006, -28.497349996999958],
            [22.667240005000053, -28.50268000099993],
            [22.72977000000003, -28.517949993999935],
            [22.796239998000033, -28.577549997999938],
            [22.995730003000062, -28.580289996999966],
            [23.128460005000022, -28.596609997999963],
            [23.222959996000043, -28.55728999599995],
            [23.292009999000072, -28.649940000999948],
            [23.379085001000078, -28.63630999399993],
            [23.410290002000067, -28.695279996999943],
            [23.54240999600006, -28.747439996999958],
            [23.668500004000066, -28.766740003999928],
            [23.62380999900006, -28.70839000099994],
            [23.706969999000023, -28.58772000099998],
            [23.54312900000008, -28.517288002999976],
            [23.56819000300004, -28.449910000999978],
            [23.388720001000024, -28.371629989999974],
            [23.398839991000045, -28.282359999999983],
            [23.442049997000026, -28.203040004999934],
            [23.523630001000072, -28.095299999999952],
            [23.441180006000025, -28.085999994999952],
            [23.362025980000055, -27.942167130999962],
            [23.30436000700007, -27.936529999999948],
            [23.11221000200004, -27.962780004999956],
            [23.097749994000026, -27.888769999999965],
            [23.023049999000023, -27.857989999999972],
            [22.991550002000054, -27.898040013999946],
            [22.933089995000046, -27.887949998999943],
            [22.772809996000035, -27.98414000599996],
            [22.674030001000062, -27.984360004999928],
            [22.642420000000072, -27.93971999799993],
            [22.727434177000077, -27.930350277999935],
            [22.73954999500006, -27.850730004999946],
            [22.819319996000047, -27.831609998999966],
            [22.80168999700004, -27.792869998999947],
            [22.70051000600006, -27.687049999999942],
            [22.714579996000055, -27.549159994999968],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC085' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.248110002000033, -26.58731999899993],
            [26.103160003000028, -26.578400001999967],
            [26.101999997000064, -26.46177000199998],
            [26.015239996000048, -26.448830001999966],
            [25.94799000200004, -26.400409999999965],
            [25.898370000000057, -26.42296000099998],
            [25.866760003000024, -26.35990000099997],
            [25.889180003000035, -26.320510008999975],
            [25.826899999000034, -26.200359996999964],
            [25.722779997000032, -26.25692000099997],
            [25.71304000300006, -26.22758000999994],
            [25.65525999500005, -26.296639997999932],
            [25.54601999700003, -26.32766999599994],
            [25.50287999300008, -26.380110000999935],
            [25.422349996000037, -26.270750000999953],
            [25.37209999600003, -26.33880000299996],
            [25.29733999700005, -26.32175000099994],
            [25.224939996000046, -26.38575999699998],
            [25.225419998000064, -26.456069998999965],
            [25.16958999700006, -26.519929997999952],
            [25.226705002000074, -26.614766277999934],
            [25.147649998000077, -26.71401999699998],
            [25.120012125000073, -26.79724799199994],
            [25.194198080000035, -26.85758167299997],
            [25.257490000000075, -26.802249995999944],
            [25.320779997000045, -26.886259996999968],
            [25.38267999800007, -26.861659997999936],
            [25.492609999000024, -26.917870001999972],
            [25.569260001000032, -26.936329997999962],
            [25.665810002000057, -26.899133998999957],
            [25.665629995000074, -26.96272000099998],
            [25.809709999000063, -26.901179998999964],
            [25.833310002000076, -26.936159995999958],
            [26.00418999900006, -26.855189997999958],
            [26.07676000200007, -26.862330004999933],
            [26.11505999900004, -26.77104999599993],
            [26.27236000000005, -26.691440000999933],
            [26.248110002000033, -26.58731999899993],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW382' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.075840000000028, -27.710650002999955],
            [26.003179998000064, -27.708049999999957],
            [26.002289998000037, -27.648889992999955],
            [25.92687999700007, -27.60387000099996],
            [25.85260999700006, -27.620979999999975],
            [25.830239996000046, -27.566190002999974],
            [25.677420002000076, -27.630789996999965],
            [25.657800000000066, -27.69485999699998],
            [25.596609999000066, -27.65506999699994],
            [25.55583000200005, -27.686659997999982],
            [25.47943000300006, -27.69338000099998],
            [25.364029997000046, -27.750540000999933],
            [25.323529997000037, -27.793790000999934],
            [25.349210001000074, -27.850240000999975],
            [25.41945000000004, -27.919060000999934],
            [25.51746999900007, -27.98636000199997],
            [25.626070001000073, -28.038769995999928],
            [25.586389996000037, -28.105719996999937],
            [25.659690003000037, -28.13560000299998],
            [25.70701000400004, -28.12781999899994],
            [25.73369000300005, -28.178230001999964],
            [25.687809998000034, -28.214239996999936],
            [25.723299999000062, -28.36124000199993],
            [25.843389998000077, -28.479919999999936],
            [25.954050003000077, -28.509169998999937],
            [26.059499998000035, -28.509770001999982],
            [26.033569999000065, -28.586269998999967],
            [26.14789999800007, -28.557899992999978],
            [26.219069000000047, -28.468846997999947],
            [26.28804000100007, -28.46858999699998],
            [26.320170001000065, -28.41966999699997],
            [26.434859999000025, -28.368919998999957],
            [26.423150001000067, -28.31269999699998],
            [26.408589997000036, -28.259540002999984],
            [26.46707999800003, -28.21218000099998],
            [26.408300002000033, -28.123919998999952],
            [26.414640001000066, -28.092130002999966],
            [26.35466999600004, -28.08602000199994],
            [26.335010001000057, -28.05271999799993],
            [26.188231002000066, -28.001318002999938],
            [26.183160000000044, -27.941849997999952],
            [26.217400003000023, -27.88307999999995],
            [26.12547600000005, -27.818566998999984],
            [26.075840000000028, -27.710650002999955],
          ],
        ],
      },
      properties: { ADM1_ID: 'FS', ADM3_ID: 'FS183' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.44548994300004, -30.08436993999993],
            [30.396639943000025, -30.10230006599994],
            [30.281829943000048, -30.004419939999934],
            [30.212429943000075, -30.017339939999943],
            [30.105759943000066, -29.97464993999995],
            [30.043649048000077, -30.056479173999946],
            [29.957788942000036, -30.07326293999995],
            [29.928449942000043, -30.112059940999984],
            [29.852376942000035, -30.117639940999936],
            [29.914259942000058, -30.181649940999932],
            [29.947939942000062, -30.277649940999936],
            [30.04086994200003, -30.329199940999956],
            [30.114489943000024, -30.40203994099994],
            [30.171449943000027, -30.40259006599996],
            [30.295822943000076, -30.368675940999935],
            [30.324139943000034, -30.327909940999973],
            [30.377339943000038, -30.222319940999967],
            [30.436109943000076, -30.18286994099998],
            [30.41665994300007, -30.142930065999963],
            [30.44548994300004, -30.08436993999993],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN434' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [24.56719000100003, -31.41864000099997],
            [24.478780001000075, -31.43174999699994],
            [24.445739999000068, -31.47863999799995],
            [24.400949998000044, -31.443599991999974],
            [24.387529998000048, -31.386800001999973],
            [24.265629998000065, -31.324039997999932],
            [24.23489000400008, -31.21799999999996],
            [24.152299998000046, -31.18035000599997],
            [24.12350000200007, -31.10532999999998],
            [24.13678764200006, -31.042860877999942],
            [24.054772184000058, -30.97775319899995],
            [23.950628506000044, -30.97168026299994],
            [23.987642298000026, -30.910912614999972],
            [23.86042999400007, -30.864940004999937],
            [23.81402336000008, -30.906850806999955],
            [23.76169297900003, -30.905429159999983],
            [23.70332011100004, -30.941973490999942],
            [23.65829862000004, -30.89690928799996],
            [23.599274344000037, -30.942878657999984],
            [23.556749640000078, -31.007575371999962],
            [23.513484996000045, -30.950600004999956],
            [23.40172999200007, -31.034099999999967],
            [23.325510000000065, -30.95398999599996],
            [23.22530000300003, -30.95372999799997],
            [23.164820001000066, -30.86259999799995],
            [23.109370006000063, -30.828209998999967],
            [23.056190006000065, -30.88226999899996],
            [22.896850003000054, -30.856329996999932],
            [22.896609996000052, -30.879749998999955],
            [22.78191000100003, -30.947620006999955],
            [22.690140002000078, -30.975499997999975],
            [22.664740004000066, -30.954339997999966],
            [22.462409981000064, -31.00684083599998],
            [22.49762999400008, -31.095800003999955],
            [22.443519997000067, -31.13095000499993],
            [22.31849000400007, -31.14293999499995],
            [22.214509991000057, -31.216260002999945],
            [22.18747999200008, -31.168899995999936],
            [22.077040002000047, -31.13426999799998],
            [22.082209996000074, -31.05149999899993],
            [22.003210005000028, -31.01237000599997],
            [21.84595000400003, -31.064089998999975],
            [21.700109998000073, -31.063510004999955],
            [21.670689993000053, -31.09759999099998],
            [21.702214997000056, -31.164755001999936],
            [21.621859994000033, -31.15135999399996],
            [21.614755002000038, -31.24990099799993],
            [21.76240000300004, -31.27140000099996],
            [21.822829999000078, -31.35351000099996],
            [21.880160001000036, -31.399520003999953],
            [21.849879997000073, -31.45643999799995],
            [21.865479994000054, -31.49732000499995],
            [21.961949997000033, -31.512200003999965],
            [22.01165999500006, -31.590449999999976],
            [21.949710001000028, -31.600979996999968],
            [21.915515003000053, -31.645715000999928],
            [22.049580002000027, -31.76997999899993],
            [22.20401000000004, -31.76403000199997],
            [22.26010000200006, -31.662470000999974],
            [22.272920000000056, -31.592540000999975],
            [22.312290002000054, -31.58346000199998],
            [22.495760001000065, -31.67033999599994],
            [22.56481499000006, -31.677919994999968],
            [22.619070003000047, -31.72465000099993],
            [22.578340001000072, -31.80551000099996],
            [22.65152999700007, -31.821670001999962],
            [22.73510000500005, -31.79937999599997],
            [22.776880000000062, -31.85690999999997],
            [22.858970002000035, -31.818289999999934],
            [22.901950001000046, -31.875769997999953],
            [22.975830002000066, -31.860829998999975],
            [23.067390000000046, -31.89073999599998],
            [23.052589999000077, -31.939780000999974],
            [23.087619999000026, -31.972290000999976],
            [23.139449995000064, -31.951539998999976],
            [23.23036999900006, -31.87569000299993],
            [23.263440003000028, -31.778340000999947],
            [23.30242000000004, -31.730149998999934],
            [23.40708999700007, -31.713799999999935],
            [23.42314000500005, -31.682140001999983],
            [23.496109997000076, -31.702689998999972],
            [23.715130000000045, -31.64704000399996],
            [23.756489996000028, -31.69571000199994],
            [23.847620002000042, -31.729219996999973],
            [23.808520002000023, -31.76365999799998],
            [23.878630002000023, -31.833680004999962],
            [23.94865999900003, -31.773330000999977],
            [23.96306000100003, -31.706670006999957],
            [24.028519997000046, -31.730170000999976],
            [24.070940002000043, -31.807089996999935],
            [24.152459995000072, -31.78860999799997],
            [24.161589996000032, -31.740149993999978],
            [24.26825000300005, -31.76666999699995],
            [24.345990001000075, -31.714480004999984],
            [24.50627000000003, -31.706830001999947],
            [24.522960003000037, -31.603689997999936],
            [24.503910002000055, -31.568419998999957],
            [24.558850001000053, -31.481839995999962],
            [24.56719000100003, -31.41864000099997],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC071' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.733409944000073, -28.218509938999944],
            [31.645149944000025, -28.18640993899993],
            [31.645209944000044, -28.150029938999978],
            [31.586289944000043, -28.11181006399994],
            [31.55785994400003, -28.143010063999952],
            [31.49957994400006, -28.118329938999977],
            [31.47557994400006, -27.97571993899993],
            [31.502409944000078, -27.94646993899994],
            [31.488839944000063, -27.85770993799997],
            [31.345099944000026, -27.970090063999976],
            [31.30768994400006, -28.03732993899996],
            [31.218019944000048, -28.02174006399997],
            [31.142089944000077, -28.033129938999934],
            [30.994189943000038, -27.99660993899994],
            [30.986909943000057, -28.056889938999973],
            [30.950359943000024, -28.143590063999966],
            [31.047564943000054, -28.200092063999932],
            [30.94219994300005, -28.312329938999937],
            [30.96541994300003, -28.406320063999942],
            [31.018129943000076, -28.42577006399995],
            [31.106360068000072, -28.528069938999977],
            [31.15853994400004, -28.551114938999945],
            [31.18952994400007, -28.499379938999937],
            [31.249139944000035, -28.462209938999933],
            [31.32945094400003, -28.449164938999957],
            [31.358509944000048, -28.393950063999966],
            [31.41087394400006, -28.458562938999933],
            [31.504399944000056, -28.471979938999937],
            [31.53595994400007, -28.394330063999973],
            [31.610439944000063, -28.37686993899996],
            [31.670649944000047, -28.402399938999963],
            [31.70206494400003, -28.371455063999974],
            [31.733409944000073, -28.218509938999944],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN266' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.44548994300004, -30.08436993999993],
            [30.41665994300007, -30.142930065999963],
            [30.436109943000076, -30.18286994099998],
            [30.377339943000038, -30.222319940999967],
            [30.324139943000034, -30.327909940999973],
            [30.40170994300007, -30.316809940999974],
            [30.483679943000027, -30.32699006599995],
            [30.521409943000037, -30.415089940999962],
            [30.577279943000065, -30.40330006599993],
            [30.590479943000048, -30.464289940999947],
            [30.629299943000035, -30.50300006599997],
            [30.735679943000036, -30.338809940999965],
            [30.76486794300007, -30.26878394099998],
            [30.69243194300003, -30.19854794099996],
            [30.691450991000067, -30.149606948999974],
            [30.59611407400007, -30.12389829899996],
            [30.513780068000074, -30.08713993999993],
            [30.44548994300004, -30.08436993999993],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN212' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.662844617000076, -27.79470825599998],
            [32.73619494500008, -27.541613062999943],
            [32.73423394500003, -27.506462062999958],
            [32.896498945000076, -27.12041506299994],
            [32.944984945000044, -26.871974937999937],
            [32.89133394500004, -26.857862936999936],
            [32.682949945000075, -26.868139936999967],
            [32.34684994500003, -26.864050061999933],
            [32.34588994500007, -26.855900061999932],
            [32.32869994500004, -26.942849937999938],
            [32.28172994500005, -26.96449006299997],
            [32.301769945000046, -27.020810062999942],
            [32.26455994500003, -27.080439937999984],
            [32.21628007000004, -27.203829937999956],
            [32.25333994500005, -27.24967993799993],
            [32.220339945000035, -27.33134006299997],
            [32.26145994500007, -27.35058006299994],
            [32.22306994500008, -27.478569937999964],
            [32.25805994500007, -27.50983006299998],
            [32.40859994500005, -27.483649062999973],
            [32.402282945000024, -27.64807306299997],
            [32.41573307700003, -27.661980149999977],
            [32.52578322800008, -27.68469506599996],
            [32.52307608000007, -27.77544761699994],
            [32.662844617000076, -27.79470825599998],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN271' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.147119392000036, -28.758805396999946],
            [32.14421994400004, -28.702037063999967],
            [32.06850994400003, -28.703410063999968],
            [32.022419944000035, -28.64644993899998],
            [31.95930994400004, -28.664079938999976],
            [31.913679944000023, -28.62874506399993],
            [31.896699944000034, -28.571540063999976],
            [31.829450548000068, -28.569551926999964],
            [31.782424409000043, -28.523163242999942],
            [31.793650505000073, -28.48310668599993],
            [31.719700620000026, -28.49808504899994],
            [31.651483091000046, -28.70387308599993],
            [31.692799944000058, -28.699300063999942],
            [31.817709944000057, -28.78873993899998],
            [31.832299944000056, -28.83155993899993],
            [31.76649994400003, -28.85271993899994],
            [31.815709944000048, -28.945739938999964],
            [31.91853994400003, -28.917469938999943],
            [32.02933994400007, -28.86539993899993],
            [32.147119392000036, -28.758805396999946],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN282' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.815709944000048, -28.945739938999964],
            [31.76649994400003, -28.85271993899994],
            [31.832299944000056, -28.83155993899993],
            [31.817709944000057, -28.78873993899998],
            [31.692799944000058, -28.699300063999942],
            [31.651483091000046, -28.70387308599993],
            [31.520879944000058, -28.713409938999973],
            [31.450219944000025, -28.762239938999983],
            [31.346229944000072, -28.77463993899994],
            [31.307469944000047, -28.81210993899998],
            [31.219719944000076, -28.78855993899998],
            [31.16447994400005, -28.83089006399996],
            [31.122709943000075, -28.827950063999936],
            [31.029826943000046, -28.90152293899996],
            [31.04917994300007, -28.949120063999942],
            [31.125059943000053, -28.958989938999935],
            [31.118280068000047, -28.993340063999938],
            [31.175409944000023, -29.073129939999944],
            [31.288724944000023, -29.16400993999997],
            [31.31832098900003, -29.15002999999996],
            [31.37239994400005, -29.05944993999998],
            [31.38785994400007, -28.99687993899994],
            [31.458979944000077, -28.991679938999937],
            [31.529589944000065, -29.056689939999956],
            [31.675313944000038, -29.05489306499993],
            [31.765349944000036, -28.965429938999932],
            [31.815709944000048, -28.945739938999964],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN284' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.276299943000026, -29.30914993999994],
            [30.221389943000077, -29.292090064999968],
            [30.20822894300005, -29.25164093999996],
            [30.122739943000056, -29.245109939999963],
            [30.011779942000032, -29.296710064999957],
            [30.00558706700008, -29.338471939999977],
            [29.930689942000072, -29.319069939999963],
            [29.841689942000073, -29.357959939999944],
            [29.689915942000027, -29.402831939999942],
            [29.821639942000047, -29.456689939999933],
            [29.918909942000028, -29.533619939999937],
            [30.00618994200005, -29.53643993999998],
            [30.01758006700004, -29.589839939999933],
            [30.10609994300006, -29.629689939999935],
            [30.195457457000032, -29.613106869999967],
            [30.364679943000056, -29.542879939999978],
            [30.356590143000062, -29.48530176299994],
            [30.31407348500005, -29.46677815299995],
            [30.327219943000046, -29.337639939999974],
            [30.276299943000026, -29.30914993999994],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN222' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.877189943000076, -29.275589939999975],
            [30.827759943000046, -29.265070064999975],
            [30.766580068000053, -29.19802006499998],
            [30.57877994300003, -29.258110064999983],
            [30.522809943000027, -29.22001993999993],
            [30.418799943000067, -29.262699939999948],
            [30.37602994300005, -29.18617993999993],
            [30.335870068000077, -29.163850064999963],
            [30.276299943000026, -29.30914993999994],
            [30.327219943000046, -29.337639939999974],
            [30.31407348500005, -29.46677815299995],
            [30.356590143000062, -29.48530176299994],
            [30.364679943000056, -29.542879939999978],
            [30.431659943000057, -29.54343006499994],
            [30.481149943000048, -29.59538993999996],
            [30.540799943000025, -29.618230064999977],
            [30.568739943000026, -29.547399939999934],
            [30.61805994300005, -29.549960064999937],
            [30.673752943000068, -29.619902064999962],
            [30.727179943000067, -29.57093993999996],
            [30.702519943000027, -29.561129939999944],
            [30.747750068000073, -29.46706993999993],
            [30.793549943000073, -29.44954993999994],
            [30.88038994300007, -29.367669939999928],
            [30.854649943000027, -29.322220064999954],
            [30.877189943000076, -29.275589939999975],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN221' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.467099997000048, -30.624210010999946],
            [25.376580002000026, -30.55988999699997],
            [25.307119999000065, -30.57707999799993],
            [25.23710999900004, -30.50122999299998],
            [25.151909997000075, -30.45729999699995],
            [25.09371999700005, -30.37145999699993],
            [25.035619999000062, -30.34420999799994],
            [25.034980005000023, -30.286870008999983],
            [24.98631999500003, -30.289969996999957],
            [24.950169006000067, -30.224845002999928],
            [24.879171945000053, -30.27109122899998],
            [24.84294701600004, -30.366067465999947],
            [24.75599677100007, -30.45960166699996],
            [24.67957999600003, -30.62595999599995],
            [24.644425397000077, -30.751596894999977],
            [24.630346748000022, -30.836215873999947],
            [24.703809999000043, -30.828499995999948],
            [24.757820000000038, -30.870549997999944],
            [24.802620001000037, -30.972409995999953],
            [24.847270000000037, -30.99189000399997],
            [24.82237615400004, -31.04039404699995],
            [24.750860002000024, -31.095959996999966],
            [24.75150999300007, -31.140319998999928],
            [24.661509998000042, -31.287819997999975],
            [24.563969996000026, -31.377370001999964],
            [24.56719000100003, -31.41864000099997],
            [24.664990001000035, -31.38366000999997],
            [24.704810003000034, -31.400590001999944],
            [24.788679998000077, -31.389460002999954],
            [24.852990005000038, -31.328209989999948],
            [24.94197000500003, -31.315069998999945],
            [25.00562000000008, -31.263099998999962],
            [25.05847000400007, -31.269379999999956],
            [25.170479998000076, -31.23917999899993],
            [25.22504000300006, -31.195199999999943],
            [25.354419997000036, -31.23599999399994],
            [25.38621000100005, -31.21784000399998],
            [25.384560001000068, -31.150970000999962],
            [25.446389999000075, -31.10020000199995],
            [25.486750001000075, -31.036910003999935],
            [25.47502000000003, -30.983879999999942],
            [25.51759000000004, -30.903389997999966],
            [25.471289999000078, -30.869840000999943],
            [25.521629998000037, -30.83318000099996],
            [25.48020000200006, -30.77890999999994],
            [25.45648000400007, -30.637000003999958],
            [25.467099997000048, -30.624210010999946],
          ],
        ],
      },
      properties: { ADM1_ID: 'NC', ADM3_ID: 'NC072' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.13629006800005, -30.624449940999966],
            [30.118039943000042, -30.559330065999973],
            [30.05695994200005, -30.467349940999952],
            [30.00159994200004, -30.493709940999963],
            [29.954169942000078, -30.565840065999964],
            [29.81332506700005, -30.535094940999954],
            [29.782159942000078, -30.510459940999965],
            [29.645719942000028, -30.52717994099993],
            [29.640639942000064, -30.562039940999966],
            [29.57220004100003, -30.655149972999936],
            [29.599509973000067, -30.689519969999935],
            [29.675369982000063, -30.669939978999935],
            [29.70792995900007, -30.70478996099996],
            [29.852609983000036, -30.76160002699993],
            [29.94686997200006, -30.76994996999997],
            [29.961164980000035, -30.82316997199996],
            [30.02099994200006, -30.738349940999967],
            [30.082109943000034, -30.696669940999982],
            [30.072869943000057, -30.649989940999944],
            [30.13629006800005, -30.624449940999966],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN214' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.993349943000055, -28.85647993899994],
            [30.98679994300005, -28.805120063999937],
            [30.833109943000068, -28.771699938999973],
            [30.77085994300006, -28.722680063999974],
            [30.69907394300003, -28.771935938999945],
            [30.62528194300006, -28.80475993899995],
            [30.563990068000066, -28.879339938999976],
            [30.45184994300007, -28.88077993899998],
            [30.36396994300003, -28.942870063999976],
            [30.32774164600005, -28.946712600999945],
            [30.300251082000045, -28.95597004299998],
            [30.342568193000034, -29.050260564999974],
            [30.309049318000064, -29.09782518999998],
            [30.36360994300003, -29.12302993999998],
            [30.335870068000077, -29.163850064999963],
            [30.37602994300005, -29.18617993999993],
            [30.418799943000067, -29.262699939999948],
            [30.522809943000027, -29.22001993999993],
            [30.57877994300003, -29.258110064999983],
            [30.766580068000053, -29.19802006499998],
            [30.827759943000046, -29.265070064999975],
            [30.877189943000076, -29.275589939999975],
            [30.98118994300006, -29.269259939999984],
            [30.984729943000048, -29.22410993999995],
            [30.86271994300006, -29.14751006499995],
            [30.93671994300007, -29.080199939999943],
            [31.02377994300008, -29.078830064999977],
            [30.980179943000053, -28.969889938999984],
            [30.92207994300003, -28.94841993899996],
            [30.91921994300003, -28.908489938999935],
            [30.993349943000055, -28.85647993899994],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN245' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.852376942000035, -30.117639940999936],
            [29.828389942000058, -30.073039939999944],
            [29.77227994200007, -30.061450064999974],
            [29.673859942000036, -30.079409939999948],
            [29.632879942000045, -30.033889939999938],
            [29.50890994200006, -30.00181993999996],
            [29.479739942000037, -29.965269939999928],
            [29.417289942000025, -29.969134939999947],
            [29.47891994200006, -30.040369939999948],
            [29.406780067000057, -30.095859940999958],
            [29.38802994200006, -30.157550065999942],
            [29.524589942000034, -30.22235994099998],
            [29.49830994200005, -30.26992994099993],
            [29.497840067000027, -30.34030994099993],
            [29.573779942000044, -30.404852940999945],
            [29.62175994200004, -30.49035994099995],
            [29.640639942000064, -30.562039940999966],
            [29.645719942000028, -30.52717994099993],
            [29.782159942000078, -30.510459940999965],
            [29.81332506700005, -30.535094940999954],
            [29.954169942000078, -30.565840065999964],
            [30.00159994200004, -30.493709940999963],
            [30.05695994200005, -30.467349940999952],
            [30.114489943000024, -30.40203994099994],
            [30.04086994200003, -30.329199940999956],
            [29.947939942000062, -30.277649940999936],
            [29.914259942000058, -30.181649940999932],
            [29.852376942000035, -30.117639940999936],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN435' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.13525000100003, -30.605139977999954],
            [29.084270282000034, -30.61232883699995],
            [28.95614058800004, -30.57247770799995],
            [28.924677001000077, -30.68729899599998],
            [28.86030099800007, -30.685753998999928],
            [28.759363000000064, -30.588210002999972],
            [28.699170003000063, -30.582563996999966],
            [28.655906997000045, -30.649993001999974],
            [28.560369998000056, -30.655260001999977],
            [28.54985000100004, -30.69243000399996],
            [28.641113076000067, -30.772916348999956],
            [28.657989997000072, -30.81152999699998],
            [28.72983999400003, -30.844120001999954],
            [28.836249999000074, -30.941860003999977],
            [28.873959998000032, -31.005519998999944],
            [28.86458000400006, -31.051410001999955],
            [28.905729999000073, -31.077709997999932],
            [28.978939997000055, -31.025019997999948],
            [29.06473800200007, -31.037947419999966],
            [29.109115601000042, -31.035037993999936],
            [29.145029068000042, -30.971429824999973],
            [29.086420059000034, -30.94628906199995],
            [29.068309999000064, -30.85512999799994],
            [29.165560001000074, -30.81916000399997],
            [29.215230002000055, -30.87232999699995],
            [29.39245999700006, -30.836789996999983],
            [29.46067000200003, -30.78511999799997],
            [29.48363000100005, -30.700839996999946],
            [29.522201133000067, -30.699014831999932],
            [29.543550296000035, -30.647186529999942],
            [29.51235997200007, -30.61821998299996],
            [29.372800038000037, -30.64896003499996],
            [29.26132997600007, -30.621159976999934],
            [29.13525000100003, -30.605139977999954],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC442' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.629299943000035, -30.50300006599997],
            [30.590479943000048, -30.464289940999947],
            [30.577279943000065, -30.40330006599993],
            [30.521409943000037, -30.415089940999962],
            [30.483679943000027, -30.32699006599995],
            [30.40170994300007, -30.316809940999974],
            [30.324139943000034, -30.327909940999973],
            [30.295822943000076, -30.368675940999935],
            [30.171449943000027, -30.40259006599996],
            [30.114489943000024, -30.40203994099994],
            [30.05695994200005, -30.467349940999952],
            [30.118039943000042, -30.559330065999973],
            [30.13629006800005, -30.624449940999966],
            [30.218259943000078, -30.65540994099996],
            [30.361459943000057, -30.616439940999953],
            [30.42733994300005, -30.57786994099996],
            [30.508829943000023, -30.59159994099997],
            [30.507544943000028, -30.53953994099993],
            [30.583549943000037, -30.56070994099997],
            [30.629299943000035, -30.50300006599997],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN213' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.97775994400007, -27.31752006299996],
            [31.49368994400004, -27.31516006299995],
            [31.27432998000006, -27.24317002099997],
            [31.16586999200007, -27.368520012999966],
            [31.14086502400005, -27.362659979999933],
            [31.189004478000072, -27.454314525999962],
            [31.171449944000074, -27.563989937999963],
            [31.254949944000032, -27.581740062999984],
            [31.297369944000025, -27.511700062999978],
            [31.45533994400006, -27.609170062999965],
            [31.51992994400007, -27.670030062999956],
            [31.570779944000037, -27.64861006299998],
            [31.504340944000035, -27.812478062999958],
            [31.51141294400003, -27.83823406299996],
            [31.58836994400008, -27.77412006299994],
            [31.658499944000027, -27.761380062999933],
            [31.76971994400003, -27.703300062999972],
            [31.765319944000055, -27.651370062999945],
            [31.805519944000025, -27.624079937999966],
            [31.951619944000072, -27.61907993799997],
            [31.986959944000034, -27.579909937999957],
            [32.05013994400008, -27.58379993799997],
            [32.02069994400006, -27.512840062999942],
            [31.97775994400007, -27.31752006299996],
          ],
        ],
      },
      properties: { ADM1_ID: 'KZN', ADM3_ID: 'KZN262' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.169850000000054, -26.080229996999947],
            [27.142029999000044, -26.10068999899994],
            [27.053780004000032, -26.10068999899994],
            [26.974799999000027, -26.065050000999975],
            [26.84792999900003, -26.059699998999974],
            [26.807079999000052, -26.084029998999938],
            [26.733110001000057, -26.10156999999998],
            [26.709239998000044, -26.04755999899993],
            [26.61765100300005, -26.06486700199997],
            [26.62964000900007, -26.13613000099997],
            [26.545779997000068, -26.172699997999928],
            [26.586130001000072, -26.24519999699993],
            [26.534689999000022, -26.264190000999974],
            [26.55844078100006, -26.340418393999983],
            [26.483649998000033, -26.38641999799995],
            [26.45990999600008, -26.483499998999946],
            [26.530379994000043, -26.51806999799993],
            [26.63119000100005, -26.515979998999967],
            [26.694669997000062, -26.55868000199996],
            [26.704759999000032, -26.612480000999938],
            [26.783010000000047, -26.611090003999948],
            [26.79416000300006, -26.767229998999937],
            [26.85022243000003, -26.816509534999966],
            [26.89799000200003, -26.828930002999982],
            [26.866440002000047, -26.91906000299997],
            [26.90868000000006, -26.945709999999963],
            [26.947220010000024, -26.89200999899998],
            [27.013929998000037, -26.932050001999983],
            [27.11343000200003, -26.926359996999963],
            [27.17366000100003, -26.96759000199995],
            [27.219160002000024, -26.944359995999946],
            [27.306050003000053, -26.85333999599993],
            [27.389485000000036, -26.906384999999943],
            [27.418589997000026, -26.92386000099998],
            [27.511750002000042, -26.836510002999944],
            [27.517359997000028, -26.781970000999934],
            [27.590429997000058, -26.73836000299997],
            [27.569090002000053, -26.647160003999943],
            [27.378349998000033, -26.610679997999966],
            [27.241869998000027, -26.636459999999943],
            [27.22835999700004, -26.571050000999946],
            [27.182637003000025, -26.574619995999967],
            [27.158760003000054, -26.52541999899995],
            [27.231421002000047, -26.50548099599996],
            [27.22484999900007, -26.44396999999998],
            [27.187952000000053, -26.377862998999944],
            [27.330071000000032, -26.28181499899995],
            [27.291409998000063, -26.144620003999933],
            [27.361720000000048, -26.115669998999977],
            [27.326239998000062, -26.10072000899993],
            [27.169850000000054, -26.080229996999947],
          ],
        ],
      },
      properties: { ADM1_ID: 'NW', ADM3_ID: 'NW405' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.984219996000036, -26.23693000999998],
            [29.02028999600003, -26.193169997999973],
            [28.99935000100004, -26.120870002999936],
            [28.919584000000043, -26.100004998999964],
            [28.92492999600006, -26.023830001999954],
            [28.95366000100006, -25.97478000199993],
            [29.02670999700007, -25.916650000999937],
            [28.94107000200006, -25.877290002999928],
            [28.888960002000033, -25.88032999799998],
            [28.885049996000077, -25.974399997999967],
            [28.864839998000036, -26.001269994999973],
            [28.793860004000067, -26.004569999999944],
            [28.632260004000045, -25.970779996999966],
            [28.590949997000052, -26.00247999299995],
            [28.578939997000077, -26.059590002999983],
            [28.50305499700005, -26.063800002999983],
            [28.49050000400007, -26.126392000999942],
            [28.52715000300003, -26.178740003999962],
            [28.53053999900004, -26.225309994999975],
            [28.622290003000046, -26.24837999799996],
            [28.62690000200007, -26.292439996999974],
            [28.710120010000026, -26.34124000099996],
            [28.805080002000068, -26.30659000199995],
            [28.838440003000073, -26.340750001999936],
            [28.86756000200006, -26.32764999999995],
            [28.886340003000043, -26.257710001999953],
            [28.939509996000027, -26.265809994999984],
            [28.984219996000036, -26.23693000999998],
          ],
        ],
      },
      properties: { ADM1_ID: 'MP', ADM3_ID: 'MP311' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.280609999000035, -30.57835999799994],
            [26.259649999000032, -30.540720000999954],
            [26.193830002000027, -30.52797999699993],
            [26.162559999000052, -30.483489996999936],
            [26.097999999000024, -30.516500005999944],
            [25.973089990000062, -30.53938999299993],
            [25.851229999000054, -30.62933000399994],
            [25.799829998000064, -30.63479000199993],
            [25.778900001000068, -30.67587999999995],
            [25.700139996000075, -30.679509999999937],
            [25.63086000000004, -30.65934999999996],
            [25.60308999700004, -30.594389999999976],
            [25.556280000000072, -30.61662999999993],
            [25.467099997000048, -30.624210010999946],
            [25.45648000400007, -30.637000003999958],
            [25.48020000200006, -30.77890999999994],
            [25.521629998000037, -30.83318000099996],
            [25.471289999000078, -30.869840000999943],
            [25.51759000000004, -30.903389997999966],
            [25.47502000000003, -30.983879999999942],
            [25.486750001000075, -31.036910003999935],
            [25.446389999000075, -31.10020000199995],
            [25.384560001000068, -31.150970000999962],
            [25.38621000100005, -31.21784000399998],
            [25.47940999800005, -31.23725000199994],
            [25.557529999000053, -31.27799000699997],
            [25.51211999700007, -31.346009998999932],
            [25.564499996000052, -31.358469997999975],
            [25.59171000400005, -31.418869996999945],
            [25.589330002000054, -31.48531000199995],
            [25.66567000300006, -31.460999998999966],
            [25.706090002000053, -31.475119993999954],
            [25.769259997000063, -31.444140002999973],
            [25.965890002000037, -31.47676999999993],
            [26.033190004000062, -31.332179999999937],
            [26.121829993000063, -31.293670007999935],
            [26.13459000100005, -31.251529999999946],
            [26.20341999900006, -31.27723999899996],
            [26.237009998000076, -31.224320000999967],
            [26.426300000000026, -31.184740002999945],
            [26.42713000200007, -31.222999998999967],
            [26.52102999400006, -31.207279996999944],
            [26.628740004000065, -31.22938999799993],
            [26.687380001000065, -31.192590000999928],
            [26.70870000000008, -31.27709999999996],
            [26.666680002000078, -31.32136000099996],
            [26.66367000200006, -31.37255999799993],
            [26.61266000300003, -31.371979990999932],
            [26.633320001000072, -31.455249996999953],
            [26.743230006000033, -31.417259999999942],
            [26.846869999000035, -31.435850002999928],
            [26.882279998000058, -31.378019995999978],
            [26.93464499600003, -31.343969998999967],
            [27.017140002000076, -31.36102499599997],
            [27.047469999000043, -31.34454999899998],
            [27.130789996000033, -31.42660000099994],
            [27.175179998000033, -31.367779996999957],
            [27.275999996000053, -31.339759998999966],
            [27.296570003000056, -31.291580001999932],
            [27.24217999800004, -31.25994000199995],
            [27.165129989000036, -31.25978000699996],
            [27.168749999000056, -31.160150001999966],
            [27.217830002000028, -31.145989997999948],
            [27.141180000000077, -31.001889997999967],
            [27.173449998000024, -30.975309996999954],
            [27.13111000200007, -30.905224997999937],
            [27.179799996000042, -30.802640001999976],
            [27.119100003000028, -30.782809998999937],
            [27.10711999800003, -30.63177000299993],
            [27.034309991000043, -30.599859995999964],
            [26.94789999900007, -30.607639999999947],
            [26.94301000200005, -30.66214999799996],
            [26.847679997000057, -30.68386999699993],
            [26.814140004000024, -30.642670002999978],
            [26.70656000200006, -30.685679997999955],
            [26.629450004000034, -30.693879997999943],
            [26.481230003000064, -30.627629998999964],
            [26.490230002000033, -30.596010002999947],
            [26.425180002000047, -30.56523999799998],
            [26.34891000400006, -30.594969998999943],
            [26.280609999000035, -30.57835999799994],
          ],
        ],
      },
      properties: { ADM1_ID: 'EC', ADM3_ID: 'EC145' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.43859999500006, -32.940060003999974],
            [20.38004999900005, -32.90184999999997],
            [20.299899996000022, -32.80495999899995],
            [20.219040003000032, -32.78473999499994],
            [20.187609997000038, -32.752670002999935],
            [20.191720000000032, -32.68575999999996],
            [20.14119000200003, -32.643739995999965],
            [20.096810000000062, -32.50295999699995],
            [20.079690004000042, -32.39749999399993],
            [20.132020001000058, -32.42112000299994],
            [20.163520004000077, -32.35102000599994],
            [20.21603000500005, -32.30315999499993],
            [20.240840003000073, -32.22418999599995],
            [20.166360001000044, -32.22749000399995],
            [20.151830002000054, -32.18651999499997],
            [20.09696000300005, -32.25023999899997],
            [19.93749000300005, -32.37727999799995],
            [19.802700001000062, -32.393700001999946],
            [19.730240002000073, -32.44235999999995],
            [19.621850004000066, -32.47062000099993],
            [19.60495000000003, -32.62945999799996],
            [19.528249996000056, -32.67323999799993],
            [19.48680500300003, -32.56543999599995],
            [19.419019998000067, -32.622319999999945],
            [19.356930000000034, -32.616360003999944],
            [19.320050002000073, -32.57463999999993],
            [19.26470000300003, -32.588720001999945],
            [19.159169999000028, -32.57193000099994],
            [19.142990000000054, -32.62143999799997],
            [19.204800001000024, -32.71113998799996],
            [19.171769996000023, -32.736819999999966],
            [19.18442999900003, -32.82707000199997],
            [19.153710001000036, -32.98403999899995],
            [19.172990000000027, -33.09192000199994],
            [19.072419997000054, -33.127659997999956],
            [19.05773000100004, -33.200140000999966],
            [19.083970000000022, -33.319609999999955],
            [19.086350002000074, -33.43106999699995],
            [19.107040003000066, -33.54113999699996],
            [19.23946999800006, -33.558840000999965],
            [19.31132000200006, -33.607100000999935],
            [19.378590001000077, -33.61909000399993],
            [19.405300003000036, -33.480509998999935],
            [19.537909998000032, -33.426440000999946],
            [19.58069000200004, -33.36452000399993],
            [19.66866999900003, -33.38186000099995],
            [19.830580000000054, -33.37942000199996],
            [19.90847000100007, -33.36269999599995],
            [19.972039997000024, -33.316779990999976],
            [20.013769999000033, -33.23878800399996],
            [20.086984003000055, -33.19327799599995],
            [20.202179999000066, -33.17010999799993],
            [20.306440000000066, -33.15933999899994],
            [20.302549999000064, -33.067999992999944],
            [20.383750003000046, -33.03627999999998],
            [20.43859999500006, -32.940060003999974],
          ],
        ],
      },
      properties: { ADM1_ID: 'WC', ADM3_ID: 'WC022' },
    },
  ],
}

export { municipalities }
